import { Component, OnInit, OnDestroy, ChangeDetectorRef, HostListener, Input } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OrderService } from 'src/app/_services/dispo/order.service';
import { TeamBaseService } from 'src/app/_services/dispo/team-base';
import { TeamOrderService } from 'src/app/_services/dispo/team-order.service';
import { EmployeeService } from 'src/app/_services/dispo/employee.service';
import { Helper } from 'src/app/_services/dispo/helper.service';
import { DocumentService } from 'src/app/_services/dispo/document.service';
import { ActionService } from 'src/app/_services/dispo/action.service';
import { SkillService } from 'src/app/_services/dispo/skill.service';
import { CustomerBranchService } from 'src/app/_services/dispo/customer-branch.service';
import { ToastrService } from 'ngx-toastr';
import { HttpClient, HttpParams } from '@angular/common/http';
import { environment } from 'src/environments/environment';
import moment from 'moment';
import Swal from 'sweetalert2';
import { forkJoin, of, throwError, Subscription } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { moveItemInArray, CdkDragDrop } from '@angular/cdk/drag-drop';
import { MatDialog } from '@angular/material/dialog';
import { EmailDialogComponent } from '../../common/email-dialog/email-dialog.component';
import {
  TerminContactChoiceDialogComponent,
  TerminContactChoiceResult
} from '../../dialogs/termin-contact-choice/termin-contact-choice-dialog.component';

@Component({
  selector: 'app-order-disposition',
  templateUrl: './order-disposition.component.html',
  styleUrls: ['./order-disposition.component.css']
})
export class OrderDispositionComponent implements OnInit, OnDestroy {
  /** 'order' = im Auftragskontext (Teams nach Branch), 'agenda' = alle team_base ohne Auftrag */
  @Input() mode: 'order' | 'agenda' = 'order';
  content: any;
  orderData: any;
  
  currentDate = moment();
  calendarDays: any[] = [];
  weekDays = ['Mo', 'Di', 'Mi', 'Do', 'Fr', 'Sa'];
  viewMode: 'month' | 'week' = 'week';
  calendarMode: 'orders' | 'staff' | 'appointment' = 'orders'; // Kalendermodus: Auftragsverplanung, Personal/Fahrzeugverplanung oder Termin
  displayMode: 'full' | 'compact' | 'team' = 'compact'; // Anzeigemodus: Vollansicht, Kompaktansicht, Teamansicht
  
  selectedDate: moment.Moment | null = null;
  selectedCell: { teamId: number, day: any } | null = null;
  /** Modal für leere Zelle: Resource + Tag mit Karte und Terminliste */
  showDayMapModal = false;
  dayMapModalTeam: any = null;
  dayMapModalDay: any = null;
  dayMapModalEvents: any[] = [];
  /** Anzeigeliste für Day-Map (Filiale + Termine), für Drag & Drop umsortierbar. */
  dayMapDisplayEventsList: any[] = [];
  /** Gecachte Koordinaten für die Karte (einmal beim Öffnen berechnet, verhindert CD-Last). */
  dayMapCachedCoords: { event: any; lat: number; lng: number }[] = [];
  private dayMapModalTimeoutId: any = null;
  /** Geöffnetes 3-Punkte-Menü: Event-ID (ev?.id ?? ev?.data?.id ?? orderId). */
  dayMapMenuOpenForEventId: number | string | null = null;
  /** Event-ID, für die gerade Koordinaten per API ermittelt werden. */
  dayMapGeocodeEventId: number | string | null = null;
  /** Kartenmittelpunkt beim Klick auf einen Termin (null = Übersicht). */
  dayMapCenterLat: number | null = null;
  dayMapCenterLng: number | null = null;
  /** Standort der Filiale (customer branch) als Start in der Day-Map-Liste/Karte. */
  dayMapBranchStart: any = null;
  /** Route im Day-Map-Modal: Gesamtstrecke und -zeit (via Backend-API). */
  dayMapRouteDistance: string = '';
  dayMapRouteDuration: string = '';
  /** Polyline-Punkte der Route (vom Backend). */
  dayMapRoutePath: { lat: number; lng: number }[] = [];
  /** Streckenabschnitte zwischen den Punkten (Entfernung + Zeit pro Teilstück). */
  dayMapRouteLegs: { distance_text: string; duration_text: string }[] = [];
  /** Route wird gerade per API berechnet. */
  dayMapRouteLoading: boolean = false;
  events: any[] = [];
  weekStart: moment.Moment = moment().startOf('isoWeek');
  teams: any[] = [];
  filteredTeams: any[] = [];
  selectedTeamIds: number[] = [];
  teamEvents: Map<number, any[]> = new Map();
  teamStaffEvents: Map<number, any[]> = new Map(); // Separate Map für Personal/Fahrzeuge
  draggedOrder: any = null;
  /** Beim Drag aus einem Multi-Slot-Feld: team_order_type_id für diesen Slot. */
  draggedOrderSlotTypeId: number | null = null;
  teamOrderTypes: any[] = [];
  selectedTeamOrderType: any = null;
  existingAppointments: any[] = [];
  highlightedAppointment: any = null;
  selectedEventData: any = null; // Daten des ausgewählten Termins (wenn nicht zum aktuellen Auftrag gehörend)
  selectedEventDocuments: any[] = []; // Dokumente des ausgewählten Termins
  selectedEventNotes: any[] = []; // Notizen des ausgewählten Termins
  isLoadingEventDocuments: boolean = false;
  isLoadingEventNotes: boolean = false;
  isLoadingEventData: boolean = false; // Loading-State für Event-Daten beim Terminwechsel (linke Seite)
  isLoadingPanelLeft: boolean = false; // Lade-Symbol für linke Seite (Auftrag, Termine) bei Verplanung/Löschen/Aktualisierung
  contextMenuEvent: any = null;
  contextMenuPosition: { x: number, y: number } = { x: 0, y: 0 };
  showContextMenu: boolean = false;
  contextMenuType: 'event' | 'day' | 'weekday' | 'staff-day' | 'team-column' | 'staff-event' | null = null; // Typ des Kontextmenüs
  contextMenuDay: any = null; // Tag für Tag/Team-Kontextmenü
  contextMenuTeam: any = null; // Team für Tag/Team-Kontextmenü
  contextMenuWeekday: any = null; // Wochentag für Header-Kontextmenü
  contextMenuTeamColumn: any = null;
  draggingEvent: any = null; // Event das gerade verschoben wird
  searchFilter: string = ''; // Suchfilter für Events
  employees: any[] = []; // Personal-Liste
  vehicles: any[] = []; // Fahrzeug-Liste
  employeeFilter: string = ''; // Filter für Personal
  draggedEmployee: any = null; // Personal das gerade gezogen wird
  draggedVehicle: any = null; // Fahrzeug das gerade gezogen wird
  holidaysMap: Map<string, any> = new Map();
  teamBlockedDays: Set<string> = new Set();
  teamBlockedNotes: Map<string, string> = new Map(); // Notizen für blockierte Tage: key = "teamId_date", value = note
  isInitialLoading: boolean = true;
  private hasFinishedInitialLoading: boolean = false;
  isLoadingEvents: boolean = false; // Loading-State für Events beim Wochensprung
  private isLoadEventsInProgress: boolean = false; // Flag um mehrfaches gleichzeitiges Laden zu verhindern
  private isLoadingTeamAbsencesFlag: boolean = false; // Flag um mehrfaches Laden von Team-Abwesenheiten zu verhindern
  private lastLoadedDateRange: { start: moment.Moment, end: moment.Moment } | null = null; // Gespeicherter Datumsbereich
  calendarViews: any[] = []; // Definierten Ansichten
  selectedCalendarView: any = null; // Ausgewählte Ansicht
  skeletonPanelItems = Array.from({ length: 5 });
  skeletonToolbarItems = Array.from({ length: 3 });
  skeletonGridColumns = Array.from({ length: 7 });
  skeletonGridRows = Array.from({ length: 4 });
  copiedStaffAssignments: any[] | null = null; // Zwischenspeicher für kopierte Belegung
  copiedStaffSource: { teamId: number; date: moment.Moment } | null = null;
  copiedOrder: any = null; // Zwischenspeicher für kopierten Auftrag
  copiedEvent: any = null; // Zwischenspeicher für kopiertes Event (für Verschieben)
  showPasteOrderModal: boolean = false; // Modal für Termintyp-Auswahl und Aktion beim Einfügen
  pasteOrderAction: 'copy' | 'move' = 'copy'; // Aktion: Kopieren (neuer Termin zusätzlich) oder Verschieben (alter wird gelöscht)
  pasteOrderTargetDay: any = null; // Gespeichertes Ziel-Datum für das Einfügen
  pasteOrderTargetTeam: any = null; // Gespeichertes Ziel-Team für das Einfügen
  showEditModal: boolean = false; // Modal für Terminbearbeitung
  editModalData: any = null; // Daten für das Bearbeitungs-Modal
  showEditTeamModal: boolean = false; // Modal für Teambearbeitung
  editTeamModalData: any = null; // Daten für das Team-Bearbeitungs-Modal
  teamEditTab: 'stammdaten' | 'einsatzbereich' | 'absences' = 'stammdaten';
  showBlockDayModal: boolean = false; // Modal für Blockierung
  blockDayModalData: { isBlocked: boolean; note: string } = { isBlocked: false, note: '' };
  showStatusChangeModal: boolean = false; // Modal für Status-Änderung
  statusChangeModalData: { orderId: number; orderNumber: string; currentStatusId: number | null; currentStatusLabel: string; event: any } | null = null;
  statusList: any[] = []; // Status-Optionen aus Filter-API
  teamAbsences: any[] = [];
  isLoadingTeamAbsences: boolean = false;
  teamAbsenceYear: number = moment().year();
  absenceCalendarMonths: any[] = [];
  doubleBookedEvents: Set<number> = new Set(); // Set von Event-IDs mit Doppelbelegung
  selectedAbsenceDays: Set<string> = new Set(); // Format: "YYYY-MM-DD" für selektierte Tage im Abwesenheits-Kalender
  customersList: any[] = []; // Liste aller Kunden für Dropdown
  companyList: any[] = []; // Liste aller Firmen für Dropdown
  legacyList: any[] = []; // Liste aller Legacy-Teams für Dropdown
  /** Flache Map Skill-ID -> Skill-Objekt (title, color, …) für Anreicherung der Team-Skills */
  private skillById: Record<number, any> = {};
  
  // Debouncing für Wochensprung
  private loadEventsSubscription: Subscription | null = null;
  private loadEventsDebounceTimer: any = null;

  // Rekla-Payer (Verursacher) Liste für Farbgebung – analog zum Hauptkalender
  payerList = [
    { id: 0, label: 'Reklamationspauschale', short: 'RP', bgcolor: '#f59d9d', color: '#fff' },
    { id: 1, label: 'Kosten ROLLER (Abstimmungsfall)', short: 'KR', bgcolor: '#9dbaf5', color: '#fff' },
    { id: 2, label: 'Fremdreklamation', short: 'FR', bgcolor: '#f5d29d', color: '#000' },
    { id: 3, label: 'SONSTIGES (siehe Notizen)', short: 'SON', bgcolor: '#ffffff', color: '#000' }
  ];

  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private orderService: OrderService,
    private teamBaseService: TeamBaseService,
    private teamOrderService: TeamOrderService,
    private employeeService: EmployeeService,
    private helper: Helper,
    private documentService: DocumentService,
    private actionService: ActionService,
    private skillService: SkillService,
    private customerBranchService: CustomerBranchService,
    private http: HttpClient,
    private toastr: ToastrService,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog
  ) {}

  ngOnInit(): void {
    // Agenda-Modus: sofort Kalender anzeigen (ohne Skeleton), nächster Tick damit View gebunden ist
    if (this.mode === 'agenda') {
      this.orderData = null;
      this.weekStart = moment().startOf('isoWeek');
      setTimeout(() => {
        this.finishInitialLoading();
        this.generateCalendar();
        this.cdr.detectChanges();
      }, 0);
    }

    // Schließe Kontextmenü beim Klick außerhalb
    document.addEventListener('click', () => {
      this.closeContextMenu();
    });

    this.loadHolidays();

    this.skillService.getModuleAll().subscribe({
      next: (data: any) => {
        const skills = data?.skills || data || [];
        this.skillById = {};
        (Array.isArray(skills) ? skills : []).forEach((cat: any) => {
          (cat?.items || []).forEach((item: any) => {
            if (item?.id != null) this.skillById[item.id] = item;
          });
        });
      },
      error: () => {}
    });

    if (this.mode === 'agenda') {
      // Agenda: team_base und Events nachladen (Kalender ist bereits angezeigt)
      this.cdr.detectChanges();
      this.loadTeamOrderTypes();
      this.loadStatusList();
      this.loadEmployees();
      this.loadVehicles();
      this.loadCustomers();
      this.loadTeamBaseData();
      this.teamBaseService.getAll().subscribe({
        next: (data: any) => {
          const list = data?.data ?? data;
          this.teams = Array.isArray(list) ? list.map((t: any) => ({
            id: t.id,
            label: t.label || t.name,
            name: t.label || t.name,
            color: t.color,
            skill_items: t.skill_items || t.skillItems || []
          })) : [];
          this.applyTeamFilter();
          this.loadEvents();
        },
        error: () => {
          this.teams = [];
          this.applyTeamFilter();
          this.loadEvents();
        }
      });
    } else {
      const orderId = this.route.snapshot.parent?.params['id'] ?? this.route.snapshot.params['id'];
      if (orderId) {
        this.orderService.show(orderId).subscribe(
          data => {
            this.orderData = data;
            this.weekStart = moment().startOf('isoWeek');
            this.loadEvents();
            this.loadTeamOrderTypes();
            this.loadStatusList();
            this.loadEmployees();
            this.loadVehicles();
            this.loadCustomers();
            this.loadTeamBaseData();
          },
          err => {
            this.content = err?.error?.message || 'Fehler beim Laden der Daten';
            this.finishInitialLoading();
          }
        );
      } else {
        this.orderService.getCurrentOrderData().subscribe(
          data => {
            const order = data?.base ?? data?.data ?? data;
            this.orderData = order;
            if (this.orderData) {
              this.weekStart = moment().startOf('isoWeek');
              this.loadEvents();
              this.loadTeamOrderTypes();
              this.loadStatusList();
              this.loadEmployees();
              this.loadVehicles();
              this.loadCustomers();
              this.loadTeamBaseData();
            }
          }
        );
      }
    }
  }

  loadTeamAbsencesForTeam(teamId: number, year: number): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!teamId) {
        resolve();
        return;
      }
      this.isLoadingTeamAbsences = true;
      const start = moment(`${year}-01-01`).format('YYYY-MM-DD');
      const end = moment(`${year}-12-31`).format('YYYY-MM-DD');
      const params = new HttpParams()
        .set('team_base_id', teamId.toString())
        .set('start', start)
        .set('end', end);

      this.http.get(environment.prismaApiUrl + '/api/dispo/team_absence', { params }).subscribe(
        (data: any) => {
          this.teamAbsences = (data.data || data || []).sort((a: any, b: any) => {
            return moment(a.start_date).valueOf() - moment(b.start_date).valueOf();
          });
          this.generateAbsenceCalendar();
          this.isLoadingTeamAbsences = false;
          resolve();
        },
        err => {
          console.error('Fehler beim Laden der Abwesenheiten', err);
          this.toastr.error('Abwesenheiten konnten nicht geladen werden', 'Fehler');
          this.teamAbsences = [];
          this.isLoadingTeamAbsences = false;
          reject(err);
        }
      );
    });
  }

  changeTeamAbsenceYear(delta: number): void {
    this.teamAbsenceYear += delta;
    if (this.editTeamModalData?.id) {
      this.loadTeamAbsencesForTeam(this.editTeamModalData.id, this.teamAbsenceYear).catch(err => {
        console.error('Fehler beim Laden der Abwesenheiten', err);
      });
    } else {
      // Falls keine Team-ID vorhanden, Kalender trotzdem neu generieren
      this.generateAbsenceCalendar();
    }
  }

  deleteTeamAbsence(absence: any): void {
    if (!absence?.id) return;
    Swal.fire({
      title: 'Abwesenheit löschen?',
      text: `${moment(absence.start_date).format('DD.MM.YYYY')} - ${moment(absence.end_date).format('DD.MM.YYYY')}`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ja, löschen',
      cancelButtonText: 'Abbrechen'
    }).then((result) => {
      if (result.isConfirmed) {
        this.http.delete(environment.prismaApiUrl + `/api/dispo/team_absence/${absence.id}`).subscribe(
          () => {
            this.toastr.success('Abwesenheit gelöscht', 'Erfolg');
            this.teamAbsences = this.teamAbsences.filter(a => a.id !== absence.id);
            this.generateAbsenceCalendar();
          },
          err => {
            console.error('Fehler beim Löschen der Abwesenheit', err);
            this.toastr.error('Abwesenheit konnte nicht gelöscht werden', 'Fehler');
          }
        );
      }
    });
  }

  generateAbsenceCalendar(): void {
    this.absenceCalendarMonths = [];
    
    // Erstelle für jeden Monat des Jahres einen Kalender
    for (let month = 0; month < 12; month++) {
      const monthStart = moment(`${this.teamAbsenceYear}-${month + 1}-01`).startOf('month');
      const monthEnd = monthStart.clone().endOf('month');
      const calendarStart = monthStart.clone().startOf('isoWeek');
      const calendarEnd = monthEnd.clone().endOf('isoWeek');
      
      const monthDays: any[] = [];
      const day = calendarStart.clone();
      
      while (day.isSameOrBefore(calendarEnd, 'day')) {
        const dayDate = day.format('YYYY-MM-DD');
        const isAbsent = this.isDayAbsent(dayDate);
        
        monthDays.push({
          date: day.clone(),
          dayNumber: day.date(),
          isCurrentMonth: day.isSame(monthStart, 'month'),
          isAbsent: isAbsent,
          absenceInfo: isAbsent ? this.getAbsenceForDay(dayDate) : null
        });
        
        day.add(1, 'day');
      }
      
      this.absenceCalendarMonths.push({
        month: month,
        monthName: monthStart.format('MMMM YYYY'),
        monthStart: monthStart,
        days: monthDays
      });
    }
  }

  isDayAbsent(date: string): boolean {
    return this.teamAbsences.some(absence => {
      const start = moment(absence.start_date);
      const end = moment(absence.end_date);
      const checkDate = moment(date);
      return checkDate.isSameOrAfter(start, 'day') && checkDate.isSameOrBefore(end, 'day');
    });
  }

  getAbsenceForDay(date: string): any {
    return this.teamAbsences.find(absence => {
      const start = moment(absence.start_date);
      const end = moment(absence.end_date);
      const checkDate = moment(date);
      return checkDate.isSameOrAfter(start, 'day') && checkDate.isSameOrBefore(end, 'day');
    });
  }

  toggleAbsenceDaySelection(date: string, isCurrentMonth: boolean): void {
    // Nur Tage des aktuellen Monats können selektiert werden
    if (!isCurrentMonth) {
      return;
    }
    
    if (this.selectedAbsenceDays.has(date)) {
      this.selectedAbsenceDays.delete(date);
    } else {
      this.selectedAbsenceDays.add(date);
    }
  }

  isAbsenceDaySelected(date: string): boolean {
    return this.selectedAbsenceDays.has(date);
  }

  groupConsecutiveDates(dates: string[]): Array<{start: string, end: string}> {
    if (dates.length === 0) return [];
    
    const sortedDates = dates.sort();
    const ranges: Array<{start: string, end: string}> = [];
    let currentStart = sortedDates[0];
    let currentEnd = sortedDates[0];
    
    for (let i = 1; i < sortedDates.length; i++) {
      const currentDate = moment(sortedDates[i]);
      const prevDate = moment(sortedDates[i - 1]);
      
      // Prüfe ob der Tag direkt auf den vorherigen folgt
      if (currentDate.diff(prevDate, 'days') === 1) {
        currentEnd = sortedDates[i];
      } else {
        // Neuer Bereich beginnt
        ranges.push({ start: currentStart, end: currentEnd });
        currentStart = sortedDates[i];
        currentEnd = sortedDates[i];
      }
    }
    
    // Füge den letzten Bereich hinzu
    ranges.push({ start: currentStart, end: currentEnd });
    
    return ranges;
  }

  findAbsenceForDateRange(startDate: string, endDate: string): any {
    const start = moment(startDate);
    const end = moment(endDate);
    
    return this.teamAbsences.find(absence => {
      const absenceStart = moment(absence.start_date);
      const absenceEnd = moment(absence.end_date);
      
      // Prüfe ob die Abwesenheit genau diesen Bereich abdeckt
      return absenceStart.isSameOrBefore(start, 'day') && absenceEnd.isSameOrAfter(end, 'day');
    });
  }

  saveAbsences(): Promise<void> {
    return new Promise((resolve, reject) => {
      if (!this.editTeamModalData?.id || this.selectedAbsenceDays.size === 0) {
        resolve();
        return;
      }

      const selectedDates = Array.from(this.selectedAbsenceDays).sort();
      if (selectedDates.length === 0) {
        resolve();
        return;
      }

      // Gruppiere zusammenhängende Datumsbereiche
      const dateRanges = this.groupConsecutiveDates(selectedDates);
      
      // Für jeden Bereich: Prüfe ob Abwesenheit existiert, dann löschen oder erstellen
      const promises: Promise<any>[] = [];
      
      dateRanges.forEach(range => {
        const startDate = moment(range.start);
        const endDate = moment(range.end);
        
        // Prüfe ob für diesen Bereich bereits eine Abwesenheit existiert
        const existingAbsence = this.findAbsenceForDateRange(range.start, range.end);
        
        if (existingAbsence) {
          // Abwesenheit existiert - löschen
          promises.push(
            this.http.delete(environment.prismaApiUrl + `/api/dispo/team_absence/${existingAbsence.id}`).toPromise()
          );
        } else {
          // Abwesenheit existiert nicht - erstellen
          const payload = {
            data: {
              team_base_id: this.editTeamModalData.id,
              start_date: startDate.format('YYYY-MM-DD'),
              end_date: endDate.format('YYYY-MM-DD'),
              absence_type: 'blocked',
              absence_type_id: 0,
              note: null
            }
          };
          
          promises.push(
            this.http.post(environment.prismaApiUrl + '/api/dispo/team_absence', payload).toPromise()
          );
        }
      });

      // Warte auf alle Requests
      Promise.all(promises).then(() => {
        this.selectedAbsenceDays.clear();
        // Lade Abwesenheiten neu
        this.loadTeamAbsencesForTeam(this.editTeamModalData.id, this.teamAbsenceYear).then(() => {
          // Aktualisiere auch die blocked days im Hauptkalender
          if (this.viewMode === 'week') {
            const weekStart = this.weekStart.clone().startOf('isoWeek');
            const weekEnd = this.weekStart.clone().endOf('isoWeek');
            this.loadTeamAbsences(weekStart, weekEnd, () => {
              this.generateCalendar();
            });
          } else {
            const monthStart = this.currentDate.clone().startOf('month');
            const monthEnd = this.currentDate.clone().endOf('month');
            this.loadTeamAbsences(monthStart, monthEnd, () => {
              this.generateCalendar();
            });
          }
          resolve();
        }).catch(err => {
          reject(err);
        });
      }).catch(err => {
        console.error('Fehler beim Aktualisieren der Abwesenheiten', err);
        reject(err);
      });
    });
  }

  @HostListener('document:keydown.escape')
  onEscapeKey(): void {
    if (this.showDayMapModal) { this.closeDayMapModal(); return; }
    if (this.showEditModal) { this.closeEditModal(); return; }
    if (this.showEditTeamModal) { this.closeEditTeamModal(); return; }
    if (this.showBlockDayModal) { this.closeBlockDayModal(); return; }
    if (this.showStatusChangeModal) { this.closeStatusChangeModal(); return; }
    if (this.showPasteOrderModal) { this.closePasteOrderModal(); return; }
  }

  ngOnDestroy(): void {
    if (this.dayMapModalTimeoutId) {
      clearTimeout(this.dayMapModalTimeoutId);
      this.dayMapModalTimeoutId = null;
    }
    this.closeDayMapModal();
    if (this.loadEventsSubscription) {
      this.loadEventsSubscription.unsubscribe();
      this.loadEventsSubscription = null;
    }
    if (this.loadEventsDebounceTimer) {
      clearTimeout(this.loadEventsDebounceTimer);
      this.loadEventsDebounceTimer = null;
    }
  }

  loadTeams(): void {
    this.teamBaseService.getAll().subscribe(
      data => {
        this.teams = data.data || data || [];
        this.applyTeamFilter();
      },
      err => {
        this.toastr.error('Fehler beim Laden der Teams', 'Fehler');
      }
    );
  }

  applyTeamFilter(): void {
    // Kombiniere Team-Auswahl-Filter und Suchfilter
    let teamsToFilter = this.teams;
    
    // Zuerst nach Team-Auswahl filtern
    if (this.selectedTeamIds.length > 0) {
      teamsToFilter = teamsToFilter.filter(team => 
        this.selectedTeamIds.includes(team.id)
      );
    }
    
    // Dann nach Suchfilter filtern
    if (this.searchFilter && this.searchFilter.trim()) {
      const searchTerm = this.searchFilter.toLowerCase().trim();
      teamsToFilter = teamsToFilter.filter(team => {
        // Suche im Team-Namen
        const teamLabel = (team.label || team.name || 'Team ' + team.id).toLowerCase();
        if (teamLabel.includes(searchTerm)) {
          return true;
        }
        
        // Suche in Events des Teams
        const teamEvents = this.teamEvents.get(team.id) || [];
        return teamEvents.some(event => {
          const title = (event.title || '').toLowerCase();
          const orderNumber = (event.order_number || '').toLowerCase();
          const lastName = (event.last_name || '').toLowerCase();
          const postalCode = (event.postal_code || '').toLowerCase();
          const street = (event.data?.street || '').toLowerCase();
          const place = (event.data?.place || '').toLowerCase();
          
          return title.includes(searchTerm) ||
                 orderNumber.includes(searchTerm) ||
                 lastName.includes(searchTerm) ||
                 postalCode.includes(searchTerm) ||
                 street.includes(searchTerm) ||
                 place.includes(searchTerm);
        });
      });
    }
    
    this.filteredTeams = teamsToFilter;
    this.loadEvents();
  }

  toggleTeamFilter(teamId: number): void {
    const index = this.selectedTeamIds.indexOf(teamId);
    if (index > -1) {
      this.selectedTeamIds.splice(index, 1);
    } else {
      this.selectedTeamIds.push(teamId);
    }
    this.applyTeamFilter();
  }

  isTeamSelected(teamId: number): boolean {
    return this.selectedTeamIds.length === 0 || this.selectedTeamIds.includes(teamId);
  }

  selectAllTeams(): void {
    if (this.selectedTeamIds.length === this.teams.length) {
      this.selectedTeamIds = [];
    } else {
      this.selectedTeamIds = this.teams.map(team => team.id);
    }
    this.applyTeamFilter();
  }

  generateCalendar(): void {
    if (this.viewMode === 'week') {
      this.generateWeekCalendar();
    } else {
      this.generateMonthCalendar();
    }
  }

  generateMonthCalendar(): void {
    const startOfMonth = moment(this.currentDate).startOf('month');
    const endOfMonth = moment(this.currentDate).endOf('month');
    const startCalendar = startOfMonth.clone().startOf('isoWeek');
    const endCalendar = endOfMonth.clone().endOf('isoWeek');

    this.calendarDays = [];
    const day = startCalendar.clone();

    while (day.isSameOrBefore(endCalendar, 'day')) {
      const dayObj: any = {
        date: day.clone(),
        isCurrentMonth: day.isSame(this.currentDate, 'month'),
        isToday: day.isSame(moment(), 'day'),
        isSelected: this.selectedDate && day.isSame(this.selectedDate, 'day')
      };
      this.applyHolidayToDay(dayObj);
      this.calendarDays.push(dayObj);
      day.add(1, 'day');
    }
  }

  generateWeekCalendar(): void {
    this.calendarDays = [];
    const day = this.weekStart.clone();

    for (let i = 0; i < 6; i++) {
      const dayObj: any = {
        date: day.clone(),
        isCurrentMonth: true,
        isToday: day.isSame(moment(), 'day'),
        isSelected: this.selectedDate && day.isSame(this.selectedDate, 'day')
      };
      this.applyHolidayToDay(dayObj);
      this.calendarDays.push(dayObj);
      day.add(1, 'day');
    }
  }

  toggleViewMode(): void {
    this.viewMode = this.viewMode === 'month' ? 'week' : 'month';
    if (this.viewMode === 'week') {
      this.weekStart = this.currentDate.clone().startOf('isoWeek');
    }
    this.generateCalendar();
  }

  previousPeriod(): void {
    // Breche laufenden Debounce-Timer ab
    if (this.loadEventsDebounceTimer) {
      clearTimeout(this.loadEventsDebounceTimer);
      this.loadEventsDebounceTimer = null;
    }

    if (this.viewMode === 'week') {
      this.weekStart.subtract(1, 'week');
    } else {
      this.currentDate.subtract(1, 'month');
    }
    this.generateCalendar();
    this.isLoadingEvents = true; // Zeige Skeleton beim Laden
    
    // Debounce: Warte 300ms, bevor Events geladen werden
    this.loadEventsDebounceTimer = setTimeout(() => {
      this.loadEvents();
      this.loadEventsDebounceTimer = null;
    }, 300);
  }

  nextPeriod(): void {
    // Breche laufenden Debounce-Timer ab
    if (this.loadEventsDebounceTimer) {
      clearTimeout(this.loadEventsDebounceTimer);
      this.loadEventsDebounceTimer = null;
    }

    if (this.viewMode === 'week') {
      this.weekStart.add(1, 'week');
    } else {
      this.currentDate.add(1, 'month');
    }
    this.generateCalendar();
    this.isLoadingEvents = true; // Zeige Skeleton beim Laden
    
    // Debounce: Warte 300ms, bevor Events geladen werden
    this.loadEventsDebounceTimer = setTimeout(() => {
      this.loadEvents();
      this.loadEventsDebounceTimer = null;
    }, 300);
  }

  previousMonth(): void {
    // Breche laufenden Debounce-Timer ab
    if (this.loadEventsDebounceTimer) {
      clearTimeout(this.loadEventsDebounceTimer);
      this.loadEventsDebounceTimer = null;
    }

    if (this.viewMode === 'week') {
      this.weekStart.subtract(1, 'month');
    } else {
      this.currentDate.subtract(1, 'month');
    }
    this.generateCalendar();
    this.isLoadingEvents = true; // Zeige Skeleton beim Laden
    
    // Debounce: Warte 300ms, bevor Events geladen werden
    this.loadEventsDebounceTimer = setTimeout(() => {
      this.loadEvents();
      this.loadEventsDebounceTimer = null;
    }, 300);
  }

  nextMonth(): void {
    // Breche laufenden Debounce-Timer ab
    if (this.loadEventsDebounceTimer) {
      clearTimeout(this.loadEventsDebounceTimer);
      this.loadEventsDebounceTimer = null;
    }

    if (this.viewMode === 'week') {
      this.weekStart.add(1, 'month');
    } else {
      this.currentDate.add(1, 'month');
    }
    this.generateCalendar();
    this.isLoadingEvents = true; // Zeige Skeleton beim Laden
    
    // Debounce: Warte 300ms, bevor Events geladen werden
    this.loadEventsDebounceTimer = setTimeout(() => {
      this.loadEvents();
      this.loadEventsDebounceTimer = null;
    }, 300);
  }

  selectCalendarView(id: any): void {
    this.selectedCalendarView = id;
    // Resources neu laden mit der ausgewählten CalendarView
    // Ähnlich wie im calendar.component: fetchResources wird aufgerufen
    this.loadEvents();
  }

  goToToday(): void {
    this.currentDate = moment();
    this.weekStart = moment().startOf('week');
    this.generateCalendar();
    this.loadEvents();
  }

  /** Klick auf Resource/Tag-Zelle (nicht auf ein Event): Modal mit team_events für diesen Tag öffnen. */
  selectDate(day: any, team: any, event: Event): void {
    try {
      const target = event?.target as HTMLElement;
      if (target?.closest?.('.event-item-small')) return;
      event?.stopPropagation?.();
      if (!day?.date || team?.id == null) return;
      this.selectedDate = null;
      this.selectedCell = null;
      this.dayMapModalTeam = team;
      this.dayMapModalDay = day;
      this.dayMapBranchStart = null;
      const events = this.getEventsForTeamAndDay(team.id, day);
      this.dayMapModalEvents = Array.isArray(events) ? events : [];
      this.dayMapDisplayEventsList = [...this.dayMapModalEvents];
      this.dayMapCachedCoords = this.computeDayMapCoords(this.dayMapDisplayEventsList);
      this.dayMapCenterLat = null;
      this.dayMapCenterLng = null;
      this.dayMapRouteDistance = '';
      this.dayMapRouteDuration = '';
      this.dayMapRoutePath = [];
      this.showDayMapModal = true;
      if (this.orderData?.customer_branch_id) {
        this.customerBranchService.show(this.orderData.customer_branch_id).subscribe({
          next: (branch: any) => {
            this.dayMapBranchStart = branch;
            this.dayMapDisplayEventsList = [this.getBranchAsEvent(), ...this.dayMapModalEvents];
            this.dayMapCachedCoords = this.computeDayMapCoords(this.dayMapDisplayEventsList);
            this.cdr.detectChanges();
          },
          error: () => { this.dayMapBranchStart = null; }
        });
      }
      if (this.dayMapModalTimeoutId) clearTimeout(this.dayMapModalTimeoutId);
      this.dayMapModalTimeoutId = setTimeout(() => {
        this.dayMapModalTimeoutId = null;
        if (!this.showDayMapModal) return;
        try {
          this.generateCalendar();
          if (this.dayMapModalEvents.length > 0 && day?.date) {
            this.loadEventsForDate(day.date);
          }
        } catch (e) {
          console.warn('Day-Map-Modal: Fehler nach Öffnen', e);
        }
      }, 0);
      this.cdr.detectChanges();
    } catch (e) {
      console.error('Day-Map-Modal: Fehler beim Öffnen', e);
      this.closeDayMapModal();
    }
  }

  /** Liste für Day-Map: Filiale als Start, dann Termine. (Fallback wenn List leer.) */
  get dayMapDisplayEvents(): any[] {
    if (this.dayMapDisplayEventsList?.length) return this.dayMapDisplayEventsList;
    const list = this.dayMapModalEvents ?? [];
    if (this.dayMapBranchStart) return [this.getBranchAsEvent(), ...list];
    return list;
  }

  /** Nach Umordnung per Drag & Drop: Liste aktualisieren, Coords/Route neu. */
  onDayMapOrderDrop(event: CdkDragDrop<any[]>): void {
    if (event.previousIndex === event.currentIndex) return;
    moveItemInArray(this.dayMapDisplayEventsList, event.previousIndex, event.currentIndex);
    this.dayMapModalEvents = this.dayMapDisplayEventsList.filter((e: any) => !e.isBranchStart);
    this.dayMapCachedCoords = this.computeDayMapCoords(this.dayMapDisplayEventsList);
    this.dayMapRoutePath = [];
    this.dayMapRouteLegs = [];
    this.dayMapRouteDistance = '';
    this.dayMapRouteDuration = '';
    this.cdr.detectChanges();
  }

  /** Synthetisches Event für den Standort der Filiale (Start in der Liste/Karte). */
  private getBranchAsEvent(): any {
    const b = this.dayMapBranchStart;
    if (!b) return null;
    return {
      isBranchStart: true,
      title: b.title || 'Filiale',
      data: {
        lat: b.lat,
        lng: b.lng,
        postal_code: b.postal_code,
        place: b.place,
        street: b.street
      }
    };
  }

  private computeDayMapCoords(list: any[]): { event: any; lat: number; lng: number }[] {
    const out: { event: any; lat: number; lng: number }[] = [];
    const arr = list ?? [];
    for (let i = 0; i < arr.length; i++) {
      try {
        const ev = arr[i];
        const lat = this.getDayMapEventLat(ev);
        const lng = this.getDayMapEventLng(ev);
        if (lat != null && lng != null) out.push({ event: ev, lat, lng });
      } catch (_) { /* Einzelnes Event überspringen */ }
    }
    return out;
  }

  closeDayMapModal(): void {
    try {
      if (this.dayMapModalTimeoutId) {
        clearTimeout(this.dayMapModalTimeoutId);
        this.dayMapModalTimeoutId = null;
      }
      this.dayMapMenuOpenForEventId = null;
      this.dayMapGeocodeEventId = null;
      this.dayMapCenterLat = null;
      this.dayMapCenterLng = null;
      this.showDayMapModal = false;
      this.dayMapModalTeam = null;
      this.dayMapModalDay = null;
      this.dayMapModalEvents = [];
      this.dayMapDisplayEventsList = [];
      this.dayMapCachedCoords = [];
      this.dayMapBranchStart = null;
      this.dayMapRouteDistance = '';
      this.dayMapRouteDuration = '';
      this.dayMapRoutePath = [];
      this.dayMapRouteLegs = [];
      this.dayMapRouteLoading = false;
      this.cdr.detectChanges();
    } catch (e) {
      console.warn('closeDayMapModal', e);
      this.dayMapMenuOpenForEventId = null;
      this.dayMapGeocodeEventId = null;
      this.dayMapCenterLat = null;
      this.dayMapCenterLng = null;
      this.showDayMapModal = false;
      this.dayMapModalTeam = null;
      this.dayMapModalDay = null;
      this.dayMapModalEvents = [];
      this.dayMapDisplayEventsList = [];
      this.dayMapCachedCoords = [];
      this.dayMapBranchStart = null;
      this.dayMapRouteDistance = '';
      this.dayMapRouteDuration = '';
      this.dayMapRoutePath = [];
      this.dayMapRouteLegs = [];
      this.dayMapRouteLoading = false;
    }
  }

  /** Label für Marker: Filiale = "S" (Start), sonst Nummer. */
  getDayMapMarkerLabel(item: { event?: any; lat: number; lng: number }, index: number): string {
    if (item?.event?.isBranchStart) return 'S';
    return (index + 1).toString();
  }

  /** Route per Backend-API berechnen (nur per Button-Klick). Filiale ist immer erster Punkt, wenn vorhanden. */
  loadDayMapRoute(): void {
    this.dayMapCachedCoords = this.computeDayMapCoords(this.dayMapDisplayEvents);
    const coords = this.dayMapCachedCoords;
    if (!coords || coords.length < 2) {
      this.dayMapRoutePath = [];
      this.dayMapRouteLegs = [];
      this.dayMapRouteDistance = '';
      this.dayMapRouteDuration = '';
      return;
    }
    this.dayMapRouteLoading = true;
    const waypoints = coords.map(c => ({ lat: c.lat, lng: c.lng }));
    this.orderService.getRouteDirections(waypoints).subscribe({
      next: (res: any) => {
        this.dayMapRouteDistance = res.distance_text || '';
        this.dayMapRouteDuration = res.duration_text || '';
        this.dayMapRoutePath = Array.isArray(res.path) ? res.path : [];
        this.dayMapRouteLegs = Array.isArray(res.legs) ? res.legs : [];
        this.dayMapRouteLoading = false;
        this.cdr.detectChanges();
      },
      error: () => {
        this.dayMapRoutePath = [];
        this.dayMapRouteLegs = [];
        this.dayMapRouteDistance = '';
        this.dayMapRouteDuration = '';
        this.dayMapRouteLoading = false;
        this.cdr.detectChanges();
      }
    });
  }

  getDayMapEventTime(ev: any): string {
    try {
      if (ev?.time) return ev.time;
      if (ev?.timeStart && ev?.timeEnd) return `${ev.timeStart} – ${ev.timeEnd}`;
      if (ev?.start && ev?.end) return `${ev.start} – ${ev.end}`;
      if (ev?.start) return String(ev.start);
    } catch (_) {}
    return '';
  }

  getDayMapEventTitle(ev: any): string {
    try {
      if (ev?.isBranchStart) return 'Start: ' + (ev?.title || 'Filiale');
      return ev?.title || ev?.label || (ev?.data ? (ev.data?.root_order?.person ? `${ev.data.root_order.person.last_name || ''}, ${ev.data.root_order.person.first_name || ''}`.trim() : ev.data?.order_number || '') : '') || this.getEventOrderNumbers(ev)?.first || '–';
    } catch (_) {}
    return '–';
  }

  /** Kaufvertragsnummer / Auftragsnummer für Termin (nicht Filiale). */
  getDayMapEventOrderNumber(ev: any): string {
    if (ev?.isBranchStart) return '';
    const first = this.getEventOrderNumbers(ev)?.first;
    return first != null && first !== '' ? String(first) : '';
  }

  getDayMapEventAddress(ev: any): string {
    try {
      if (ev?.isBranchStart && this.dayMapBranchStart) {
        const b = this.dayMapBranchStart;
        const parts = [b.street, [b.postal_code, b.place].filter(Boolean).join(' ')].filter(Boolean);
        return parts.join(', ');
      }
      const d = ev?.data || ev?.order || {};
      const root = d?.root_order || d?.rootOrder || {};
      const person = root?.person || {};
      const postal_code = d?.postal_code ?? person?.postal_code;
      const place = d?.place ?? person?.place;
      const street = d?.street ?? person?.street;
      const parts = [street, [postal_code, place].filter(Boolean).join(' ')].filter(Boolean);
      return parts.join(', ') || [postal_code, place].filter(Boolean).join(' ');
    } catch (_) {}
    return '';
  }

  getDayMapOrderId(ev: any): number | null {
    try {
      const d = ev?.data || ev?.order || {};
      const id = d?.id ?? d?.order_id ?? ev?.order_id ?? ev?.orderId ?? null;
      if (id == null) return null;
      const num = Number(id);
      return isNaN(num) ? null : num;
    } catch (_) { return null; }
  }

  /** Termintyp (team_order_type) für Modal-Anzeige: name oder label. */
  getDayMapEventTermTypeLabel(ev: any): string {
    const t = ev?.teamOrderType ?? ev?.team_order_type ?? null;
    if (!t) return '';
    return t.name || t.label || t.short || t.short_name || '';
  }

  /** Lat/Lng für Event (Karte im Day-Map-Modal). Sicher gegen fehlerhafte Daten. */
  getDayMapEventLat(ev: any): number | null {
    try {
      const d = ev?.data || ev?.order || {};
      const root = d?.root_order || d?.rootOrder || {};
      const person = root?.person || {};
      const v = d?.lat ?? person?.lat ?? root?.lat ?? null;
      return v != null ? Number(v) : null;
    } catch (_) { return null; }
  }
  getDayMapEventLng(ev: any): number | null {
    try {
      const d = ev?.data || ev?.order || {};
      const root = d?.root_order || d?.rootOrder || {};
      const person = root?.person || {};
      const v = d?.lng ?? person?.lng ?? root?.lng ?? null;
      return v != null ? Number(v) : null;
    } catch (_) { return null; }
  }

  get dayMapMapLat(): number {
    if (this.dayMapCenterLat != null) return this.dayMapCenterLat;
    const first = this.dayMapCachedCoords?.[0];
    return first?.lat ?? 51.1657;
  }
  get dayMapMapLng(): number {
    if (this.dayMapCenterLng != null) return this.dayMapCenterLng;
    const first = this.dayMapCachedCoords?.[0];
    return first?.lng ?? 10.4515;
  }
  get dayMapMapZoom(): number {
    if (this.dayMapCenterLat != null && this.dayMapCenterLng != null) return 15;
    return (this.dayMapCachedCoords?.length ?? 0) <= 1 ? 10 : 8;
  }

  /** Karte auf den Marker des angeklickten Termins zentrieren. */
  centerMapOnEvent(ev: any): void {
    const lat = this.getDayMapEventLat(ev);
    const lng = this.getDayMapEventLng(ev);
    if (lat != null && lng != null) {
      this.dayMapCenterLat = lat;
      this.dayMapCenterLng = lng;
      this.cdr.detectChanges();
    }
  }

  isCellSelected(teamId: number, day: any): boolean {
    if (!this.selectedCell) return false;
    return this.selectedCell.teamId === teamId && 
           this.selectedCell.day.date.format('YYYY-MM-DD') === day.date.format('YYYY-MM-DD');
  }

  getSelectedTeamLabel(): string {
    if (!this.selectedCell) return '';
    const team = this.teams?.find((t: any) => t.id === this.selectedCell!.teamId)
      || this.filteredTeams?.find((t: any) => t.id === this.selectedCell!.teamId);
    return team ? (team.label || team.name || 'Team ' + team.id) : 'Team ' + this.selectedCell.teamId;
  }

  loadEvents(): void {
    // Verhindere mehrfaches gleichzeitiges Laden
    if (this.isLoadEventsInProgress) {
      return;
    }

    // Breche laufende Anfrage ab, falls vorhanden
    if (this.loadEventsSubscription) {
      this.loadEventsSubscription.unsubscribe();
      this.loadEventsSubscription = null;
    }
    
    this.isLoadEventsInProgress = true;
    
    // Setze Loading-State nur wenn nicht initial loading
    if (!this.isInitialLoading) {
      this.isLoadingEvents = true;
    }

    // Events für alle Teams im aktuellen Zeitraum laden
    const startDate = this.viewMode === 'week' 
      ? this.weekStart.clone().startOf('day')
      : moment(this.currentDate).startOf('month').startOf('day');
    const endDate = this.viewMode === 'week'
      ? this.weekStart.clone().endOf('isoWeek').endOf('day')
      : moment(this.currentDate).endOf('month').endOf('day');

    if (this.calendarMode === 'orders' || this.calendarMode === 'appointment') {
      // Lade Termine wie im Hauptkalender über calendar-all-by-date-range,
      // damit bestehende TeamOrders identisch angezeigt werden.
      // Verwende 'calendar' Modus, um Teams basierend auf der Branch des Auftrags zu filtern
      // Falls keine orderData vorhanden ist, verwende 'scheduler' Modus für alle Teams
      const useCalendarMode = this.orderData && this.orderData.customer_branch_id;
      const rangePayload = {
        start: startDate.toISOString(),
        end: endDate.toISOString(),
        mode: useCalendarMode ? 'calendar' : 'scheduler',
        order: useCalendarMode ? this.orderData : null,
        selectedCalendarView: this.selectedCalendarView
      };

      this.loadEventsSubscription = this.teamBaseService.calendarAllByDateRange(rangePayload, useCalendarMode ? 'calendar' : 'scheduler').subscribe(
        data => {
          // Lade calendarViews aus der API-Antwort
          if (data.calendarViews) {
            this.calendarViews = data.calendarViews;
          }
          
          // Lade Teams NUR aus den Resources, die von der API zurückgegeben werden
          // Das Backend gibt data.resources zurück, die bereits nach Branch gefiltert sind
          // Extrahiere Teams aus Resources (Resources mit ID "O<teamId>" oder "G<teamId>")
          if (data.resources && Array.isArray(data.resources)) {
            const teamMap = new Map();
            
            // Funktion zum Extrahieren von Teams aus einer Resource (inkl. Children)
            const extractTeamsFromResource = (resource: any) => {
              // Prüfe die Resource selbst
              if (resource.id) {
                let teamId: number | null = null;
                let teamName: string | null = null;
                let teamColor: string | null = null;
                
                if (resource.id.startsWith('O')) {
                  teamId = parseInt(resource.id.substring(1));
                  teamName = resource.name;
                  teamColor = resource.color || resource.team_base?.color || null;
                } else if (resource.id.startsWith('G')) {
                  teamId = parseInt(resource.id.substring(1));
                  teamName = resource.name;
                  teamColor = resource.color || resource.team_base?.color || null;
                }
                
                if (teamId && teamName && !teamMap.has(teamId)) {
                  teamMap.set(teamId, {
                    id: teamId,
                    label: teamName,
                    name: teamName,
                    color: teamColor,
                    skill_items: resource.skill_items || resource.skillItems || []
                  });
                }
              }
              
              // Prüfe Children (für verschachtelte Resources)
              if (resource.children && Array.isArray(resource.children)) {
                resource.children.forEach((child: any) => {
                  if (child.id && child.id.startsWith('O')) {
                    const teamId = parseInt(child.id.substring(1));
                    const teamName = child.name || resource.name;
                    const childColor = child.color || child.team_base?.color || resource.color || resource.team_base?.color || null;
                    if (!teamMap.has(teamId) && teamName) {
                      teamMap.set(teamId, {
                        id: teamId,
                        label: teamName,
                        name: teamName,
                        color: childColor,
                        skill_items: child.skill_items || child.skillItems || resource.skill_items || resource.skillItems || []
                      });
                    }
                  }
                });
              }
            };
            
            // Durchlaufe alle Resources und extrahiere Teams
            data.resources.forEach(extractTeamsFromResource);
            
            this.teams = Array.from(teamMap.values());
            this.enrichTeamsWithSkillItems(data.teams);
            this.applyTeamFilter();
          } else if (data.teams && Array.isArray(data.teams)) {
            // Fallback: Verwende teams direkt vom Backend
            this.teams = data.teams.map((t: any) => ({
              id: t.id,
              label: t.label || t.name,
              name: t.label || t.name,
              color: t.color,
              skill_items: this.resolveSkillItemsFromParams(t.params)
            }));
            this.applyTeamFilter();
          } else {
            // Keine Resources vom Kalender-API – im Agenda-Modus Teams von getAll() beibehalten
            if (this.mode !== 'agenda') {
              this.teams = [];
            }
            this.applyTeamFilter();
          }
          
          const allEvents = data.events || data || [];

          // Events nach Teams gruppieren – orientiert an resource "O<teamId>"
          // WICHTIG: filteredTeams muss bereits gesetzt sein (durch applyTeamFilter())
          this.filteredTeams.forEach(team => {
            const resourceId = 'O' + team.id;

            const teamEvents = allEvents
              .filter((item: any) => {
                const resource = item.resource;
                // Nur echte TeamOrders mit Order-Bezug und passender Ressource
                return resource === resourceId && (item.order || item.order_id);
              })
              .map((item: any) => {
                const orderData = item.order || item.data || {};
                const teamOrderType = item.team_order_type || item.teamOrderType || null;

                const firstName = orderData.root_order?.person?.first_name || orderData.first_name || '';
                const lastName = orderData.root_order?.person?.last_name || orderData.last_name || '';
                const fullName = (firstName + ' ' + lastName).trim() || 'Termin';

                const startTime = moment(item.start).local();
                const endTime = moment(item.end).local();
                const timeRange = startTime.format('HH:mm') + ' - ' + endTime.format('HH:mm');

                return {
                  id: item.id,
                  teamId: team.id,
                  reserved: item.reserved,
                  date: startTime,
                  time: timeRange,
                  timeStart: startTime.format('HH:mm'),
                  timeEnd: endTime.format('HH:mm'),
                  title: fullName,
                  data: orderData,
                  order_id: item.order_id,
                  orderId: item.order_id || orderData.id,
                  rootOrderId: orderData.root_order?.id || null,
                  order_number: orderData.order_number || '',
                  last_name: lastName,
                  postal_code: orderData.root_order?.person?.postal_code || orderData.postal_code || '',
                  teamOrderType: teamOrderType,
                  teamOrderTypeId: item.team_order_type_id,
                  start: item.start,
                  end: item.end,
                  comment: item.comment || null,
                  // Anzeigename des Users: Vorname + Name, dann Name, dann E-Mail, dann ID
                  createdBy: item.user
                    ? [
                        item.user.first_name || '',
                        item.user.name || ''
                      ].join(' ').trim() || item.user.email || item.user_id || null
                    : item.user_id || null,
                  // Order-Type für Anzeige im Kalender
                  orderType: orderData.order_type || orderData.orderType || null,
                  // Dokumente-, Bilder- und Notizen-Anzahl
                  documents_count: item.documents_count || 0,
                  images_count: item.images_count || 0,
                  notes_count: item.notes_count || 0,
                  confirmed_at: item.confirmed_at || null,
                  declined_at: item.declined_at || null,
                  hasAppointmentRequest: !!(item.has_appointment_request || (item.appointment_confirmation_tokens && item.appointment_confirmation_tokens.length > 0))
                };
              });

            this.teamEvents.set(team.id, teamEvents);
          });

          // Dokument- und Bildanzahl pro Order (Fallback, falls Backend keine Counts liefert)
          this.checkDocumentsForEvents();

          // Lade auch TeamEvents (Personal/Fahrzeuge) für die Anzeige im Header
          this.loadTeamStaffEvents(startDate, endDate);
          // Lade Team-Abwesenheiten (wird intern geprüft ob bereits geladen)
          this.loadTeamAbsences(startDate, endDate);
          
          // Kalender neu generieren nachdem Teams und Events geladen sind
          this.generateCalendar();
          
          // Events geladen, verstecke Skeleton
          this.isLoadingEvents = false;
          this.isLoadEventsInProgress = false;
          this.finishInitialLoading();
        },
        err => {
          console.error('Fehler beim Laden der Kalenderdaten (calendar-all-by-date-range)', err);
          this.finishInitialLoading();
          this.isLoadingEvents = false;
          this.isLoadEventsInProgress = false;
        }
      );
    } else {
      // Lade TeamEvents (Personal/Fahrzeugverplanung)
      this.loadEventsSubscription = this.http.post(environment.prismaApiUrl + '/api/dispo/team_events/get-all-by-resource-and-date', {
        data: {
          start: startDate.format('YYYY-MM-DD'),
          end: endDate.format('YYYY-MM-DD')
        }
      }).subscribe(
        (data: any) => {
          const allEvents = data.data || data || [];
          
          // Events nach Teams gruppieren
          this.filteredTeams.forEach(team => {
            const teamEvents = allEvents
              .filter((item: any) => {
                const location = item.location || item;
                return location.team_base_id === team.id && location.dispo_type !== 99; // 99 = Root Event
              })
              .map((item: any) => {
                const location = item.location || item;
                // Interpretiere die Zeit als lokale Zeit (nicht UTC)
                const startTime = moment(location.start).local();
                const endTime = moment(location.end).local();
                const timeRange = startTime.format('HH:mm') + ' - ' + endTime.format('HH:mm');
                
                return {
                  id: location.id,
                  teamId: team.id,
                  date: startTime,
                  time: timeRange,
                  timeStart: startTime.format('HH:mm'),
                  timeEnd: endTime.format('HH:mm'),
                  title: location.label || 'Event',
                  dispoType: location.dispo_type,
                  moduleItemId: location.module_item_id,
                  resource: location.resource,
                  start: location.start,
                  end: location.end
                };
              });
            this.teamEvents.set(team.id, teamEvents);
          });
          
          // Speichere auch in teamStaffEvents für die Anzeige
          this.filteredTeams.forEach(team => {
            const teamEvents = allEvents
              .filter((item: any) => {
                const location = item.location || item;
                return location.team_base_id === team.id && location.dispo_type !== 99;
              })
              .map((item: any) => {
                const location = item.location || item;
                // Interpretiere die Zeit als lokale Zeit (nicht UTC)
                const startTime = moment(location.start).local();
                
                // Versuche Employee-Daten aus der Relation zu holen
                let employeeData = null;
                if (location.employee) {
                  employeeData = location.employee;
                } else if (location.module_item_id) {
                  // Fallback: Suche in der bereits geladenen employees-Liste
                  employeeData = this.employees.find((emp: any) => emp.id === location.module_item_id);
                }
                
                const eventId = location.id;
                const moduleItemId = location.module_item_id;
                const dispoType = location.dispo_type;
                // Prüfe ob dieses Event eine Doppelbelegung hat
                const isDoubleBooked = this.isEventDoubleBooked(eventId, moduleItemId, dispoType, startTime);
                
                return {
                  id: eventId,
                  teamId: team.id,
                  date: startTime,
                  title: location.label || 'Event',
                  dispoType: dispoType,
                  moduleItemId: moduleItemId,
                  resource: location.resource,
                  start: location.start,
                  end: location.end,
                  employee: employeeData, // Employee-Daten für Namensformatierung
                  isDoubleBooked: isDoubleBooked
                };
              });
          this.teamStaffEvents.set(team.id, teamEvents);
        });
        
        // Nach dem Laden aller Events, prüfe Doppelbelegungen
        this.checkAllDoubleBookings();

        this.finishInitialLoading();
        // Lade Team-Abwesenheiten (wird intern geprüft ob bereits geladen)
        this.loadTeamAbsences(startDate, endDate);
        
        // Events geladen, verstecke Skeleton
        this.isLoadingEvents = false;
        this.isLoadEventsInProgress = false;
        },
        err => {
          console.error('Fehler beim Laden der TeamEvents', err);
          this.finishInitialLoading();
          this.isLoadingEvents = false;
          this.isLoadEventsInProgress = false;
        }
      );
    }
  }

  loadTeamStaffEvents(startDate: moment.Moment, endDate: moment.Moment): void {
    // Lade TeamEvents (Personal/Fahrzeuge) für die Anzeige im Header
    this.http.post(environment.prismaApiUrl + '/api/dispo/team_events/get-all-by-resource-and-date', {
      data: {
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD')
      }
    }).subscribe(
      (data: any) => {
        const allEvents = data.data || data || [];
        
        // Events nach Teams gruppieren
        this.filteredTeams.forEach(team => {
          const teamEvents = allEvents
            .filter((item: any) => {
              const location = item.location || item;
              return location.team_base_id === team.id && location.dispo_type !== 99; // 99 = Root Event
            })
            .map((item: any) => {
              const location = item.location || item;
              const startTime = moment(location.start);
              
              // Versuche Employee-Daten aus der Relation zu holen
              let employeeData = null;
              if (location.employee) {
                employeeData = location.employee;
              } else if (location.module_item_id) {
                // Fallback: Suche in der bereits geladenen employees-Liste
                employeeData = this.employees.find((emp: any) => emp.id === location.module_item_id);
              }
              
              return {
                id: location.id,
                teamId: team.id,
                date: startTime,
                title: location.label || 'Event',
                dispoType: location.dispo_type,
                moduleItemId: location.module_item_id,
                resource: location.resource,
                start: location.start,
                end: location.end,
                employee: employeeData // Employee-Daten für Namensformatierung
              };
            });
          this.teamStaffEvents.set(team.id, teamEvents);
        });
        
        // Nach dem Laden aller Events, prüfe Doppelbelegungen
        this.checkAllDoubleBookings();

        this.finishInitialLoading();
      },
      err => {
        console.error('Fehler beim Laden der TeamStaffEvents', err);
        this.finishInitialLoading();
      }
    );
  }


  onDragStart(event: DragEvent, order: any, slotTypeId?: number): void {
    this.draggedOrder = order;
    this.draggedOrderSlotTypeId = slotTypeId ?? null;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', JSON.stringify(order));
    }
  }

  onDragOver(event: DragEvent): void {
    event.preventDefault();
    event.stopPropagation();
    if (event.dataTransfer) {
      event.dataTransfer.dropEffect = 'move';
    }
    const target = event.currentTarget as HTMLElement;
    // Direkte DOM-Manipulation ohne Transition für sofortiges Feedback
    if (!target.classList.contains('drag-over')) {
      target.classList.add('drag-over');
    }
  }

  onDragLeave(event: DragEvent): void {
    const target = event.currentTarget as HTMLElement;
    // Direkte DOM-Manipulation ohne Transition für sofortiges Feedback
    if (target.classList.contains('drag-over')) {
      target.classList.remove('drag-over');
    }
  }

  onDrop(event: DragEvent, team: any, day: any): void {
    event.preventDefault();
    event.stopPropagation();
    const target = event.currentTarget as HTMLElement;
    target.classList.remove('drag-over');

    // Prüfe ob es ein verschobenes Event ist
    try {
      const dragDataString = event.dataTransfer?.getData('application/json');
      if (dragDataString) {
        const dragData = JSON.parse(dragDataString);
        if (dragData.isMoving && dragData.event) {
          // Event verschieben
          this.moveEvent(dragData.event, team, day);
          this.draggingEvent = null; // Verschieben-Modus deaktivieren
          return;
        }
      }
    } catch (e) {
      // Ignoriere Fehler beim Parsen
    }

    // Prüfe ob es Personal oder Fahrzeug ist
    try {
      const dragDataString = event.dataTransfer?.getData('text/plain');
      if (dragDataString) {
        const dragData = JSON.parse(dragDataString);
        if (dragData.type === 'employee' && dragData.employee) {
          this.createEmployeeEvent(dragData.employee, team, day);
          this.draggedEmployee = null;
          return;
        } else if (dragData.type === 'vehicle' && dragData.vehicle) {
          this.createVehicleEvent(dragData.vehicle, team, day);
          this.draggedVehicle = null;
          return;
        }
      }
    } catch (e) {
      // Ignoriere Fehler beim Parsen
    }

    // Normale Drag-and-Drop für neue Aufträge (nur bei Auftragsverplanung)
    if (this.calendarMode !== 'orders') {
      return;
    }

    if (!this.draggedOrder) {
      return;
    }

    if (this.isOrderFullyPlanned()) {
      this.toastr.warning(
        'Dieser Auftrag hat bereits alle erforderlichen Termine. Bitte klonen Sie den Auftrag, um weitere Termine zu verplanen.',
        'Auftrag voll verplant'
      );
      this.draggedOrder = null;
      this.draggedOrderSlotTypeId = null;
      return;
    }

    const teamOrderTypeId = this.draggedOrderSlotTypeId ?? this.selectedTeamOrderType?.id ?? this.getEffectiveTeamOrderType()?.id;
    if (!teamOrderTypeId) {
      this.toastr.warning('Bitte wählen Sie einen Termintyp aus', 'Warnung');
      return;
    }

    const order = this.draggedOrder;
    this.draggedOrderSlotTypeId = null;

    const startDate = day.date.clone().startOf('day').add(8, 'hours'); // 8:00 Uhr als Standard
    const endDate = startDate.clone().add((order.duration || 60) * 60, 'seconds');

    const resource = 'O' + team.id;
    const data = {
      start: startDate.toDate(),
      end: endDate.toDate(),
      resource: resource,
      id: order.id,
      data: order,
      team_order_type_id: teamOrderTypeId
    };

    const type = this.getEffectiveTeamOrderType() || this.selectedTeamOrderType || this.teamOrderTypes.find((t: any) =>
      Array.isArray(t.event_type_ids) && t.event_type_ids.some((id: any) => Number(id) === Number(teamOrderTypeId))
    ) || { event_count: 1, event_type_ids: [teamOrderTypeId] };
    const eventCount = type.event_count ?? 1;
    const eventTypeIds: number[] = Array.isArray(type.event_type_ids) && type.event_type_ids.length > 0
      ? type.event_type_ids
      : Array(eventCount).fill(type.id ?? teamOrderTypeId);
    const filledIds = new Set(
      (this.existingAppointments || [])
        .map((a: any) => a.teamOrderType?.id ?? a.team_order_type_id)
        .filter((id: any) => id != null)
    );
    filledIds.add(teamOrderTypeId);
    const willBeFullyPlanned = eventTypeIds.every((id: number) => filledIds.has(id));

    this.teamOrderService.store(data).subscribe(
      result => {
        this.toastr.success('Auftrag wurde erfolgreich disponiert', 'Erfolg');
        this.loadEvents();
        this.loadExistingAppointments();
        this.draggedOrder = null;
        const appointmentId = result?.id ?? null;
        if (willBeFullyPlanned) {
          const newAppointment = {
            start: startDate,
            end: endDate,
            teamBase: team,
            teamOrderType: this.teamOrderTypes.find((t: any) => Number(t?.id ?? t) === Number(teamOrderTypeId))
          };
          const allAppointments = [
            ...(this.existingAppointments || []),
            newAppointment
          ].sort((a: any, b: any) => (a.start?.valueOf?.() ?? 0) - (b.start?.valueOf?.() ?? 0));
          this.openTerminContactChoiceDialog(order, startDate, endDate, team, appointmentId, allAppointments);
        }
      },
      err => {
        this.toastr.error(err.error?.message || 'Fehler beim Speichern', 'Fehler');
        this.draggedOrder = null;
      }
    );
  }

  /** Modal nach Termin-Positionierung: E-Mail schreiben oder Anruf. */
  openTerminContactChoiceDialog(order: any, startDate: moment.Moment, endDate: moment.Moment, team: any, appointmentId?: number | null, appointments?: any[]): void {
    const teamName = team?.name ?? team?.label ?? null;
    const dialogRef = this.dialog.open(TerminContactChoiceDialogComponent, {
      width: '420px',
      data: {
        order,
        startDate: startDate.toDate(),
        endDate: endDate.toDate(),
        teamName
      }
    });
    const effectiveType = this.getEffectiveTeamOrderType() || this.selectedTeamOrderType;
    const appointmentTypeLabel = effectiveType
      ? (effectiveType.name || effectiveType.label || null)
      : null;

    dialogRef.afterClosed().subscribe((choice: TerminContactChoiceResult) => {
      if (choice === 'email') {
        this.openEmailDialogForTermin(order, startDate, endDate, teamName, appointmentId ?? null, appointmentTypeLabel, appointments);
      } else if (choice === 'call') {
        const person = order?.root_order?.person ?? order?.person;
        const phone = person?.phone ?? order?.root_order?.person?.phone ?? null;
        const firstName = person?.first_name ?? order?.root_order?.person?.first_name ?? '';
        const lastName = person?.last_name ?? order?.root_order?.person?.last_name ?? '';
        if (phone) {
          this.confirmCall(String(phone), firstName, lastName);
        } else {
          this.toastr.warning('Keine Telefonnummer zum Auftrag hinterlegt.', 'Anruf');
        }
      }
    });
  }

  /** E-Mail-Dialog mit Termintext öffnen (Terminanfrage). Links für Bestätigen/Absagen werden vom Backend beim Versand eingefügt. */
  openEmailDialogForTermin(order: any, startDate: moment.Moment, endDate: moment.Moment, teamName?: string | null, appointmentId?: number | null, appointmentTypeLabel?: string | null, appointments?: any[]): void {
    const person = order?.root_order?.person ?? order?.person;
    const email = person?.email ?? order?.root_order?.person?.email ?? null;
    const recipients = email ? [email] : [];
    const orderNumber = order?.order_number ?? order?.root_order?.order_number ?? order?.id ?? '';
    const dateStr = startDate.format('DD.MM.YYYY');
    const baseType = (appointmentTypeLabel && appointmentTypeLabel.trim().length > 0)
      ? appointmentTypeLabel.trim()
      : 'LIEFERUNG + MONTAGE';
    const subject = `Terminanfrage – ${dateStr} – Auftrag ${orderNumber}`;

    const appointmentsList = (appointments && appointments.length > 1)
      ? appointments
          .map((a: any) => {
            const s = a.start && (typeof a.start.format === 'function') ? a.start : moment(a.start);
            const typeName = this.getAppointmentTypeName(a.teamOrderType);
            return `${typeName} am: ${s.format('DD.MM.YYYY')}`;
          })
          .join('<br>')
      : null;

    const body = `
<p>Sehr geehrte Kundin,<br>
sehr geehrter Kunde,</p>

<p>wir haben von ROLLER die Information erhalten, dass Ihre bei ROLLER gekaufte Küche für die Lieferung und Montage bereitsteht. Wir haben für Sie bereits reserviert:</p>

<p>${appointmentsList ? appointmentsList + '<br><br>Auftragsnummer: <strong>' + orderNumber + '</strong>' : '<strong>' + baseType + ' am ' + dateStr + ' reserviert.</strong><br>Auftragsnummer: <strong>' + orderNumber + '</strong>'}</p>

<!-- APPOINTMENT_CONFIRM_BUTTON -->

<p>Das genaue Zeitfenster erhalten Sie einen Tag vorher per SMS direkt über das ROLLER-System.</p>

<p>Wir bitten Sie, uns den Termin kurzfristig per E-Mail zu bestätigen, da unsere Kapazitäten begrenzt sind und wir den Termin andernfalls anderweitig vergeben müssen.</p>

<p><strong>Terminbestätigung – Voraussetzungen für Lieferung und Montage</strong></p>

<p>Bitte bestätigen Sie den Liefer- bzw. Montagetermin nur, wenn Sie die folgenden Hinweise zur Kenntnis genommen haben und die genannten Voraussetzungen am Liefertag erfüllt sind:</p>

<p>
  <span style="color:#28a745;font-weight:bold;">✔</span> Ein geeigneter Standplatz für das Lieferfahrzeug mit einer Länge von mindestens zwei PKW-Stellplätzen steht zur Verfügung.<br>
  <span style="color:#28a745;font-weight:bold;">✔</span> Falls keine ausreichende Parkmöglichkeit vorhanden ist, wurde eigenständig ein temporäres Halteverbot bei der zuständigen Kommune beantragt.<br>
  <span style="color:#28a745;font-weight:bold;">✔</span> Die Lieferadresse ist vollständig und korrekt angegeben.<br>
  <span style="color:#28a745;font-weight:bold;">✔</span> Die Etage ist korrekt angegeben sowie die Information, ob ein Aufzug vorhanden und nutzbar ist.<br>
  <span style="color:#28a745;font-weight:bold;">✔</span> Der Zugang zur Lieferadresse ist frei zugänglich und die Lieferung bzw. Montage kann ohne Verzögerung erfolgen.<br>
  <span style="color:#28a745;font-weight:bold;">✔</span> Eventuell bestehende offene Forderungen bei ROLLER werden am Tag der Lieferung überprüft; eine Lieferung oder Montage erfolgt nur bei ausgeglichenem Kundenkonto oder sofortiger Begleichung.<br>
  <span style="color:#28a745;font-weight:bold;">✔</span> Falls am Liefertag eine Zahlung erforderlich ist, erfolgt diese ausschließlich per BAR-Zahlung oder SEPA-Kartenzahlung (EC-Karte) direkt beim Lieferpersonal.
</p>

<p style="color:#c00;font-weight:bold;">
Wichtiger Hinweis<br>
Sollten die oben genannten Voraussetzungen nicht erfüllt sein, behalten wir uns vor, daraus entstehende Mehrkosten (z. B. Wartezeiten, erneute Anfahrt, Ersatz- oder Ausfallkosten) in Rechnung zu stellen.
</p>

<p>Bei Rückfragen stehen wir Ihnen gerne zur Verfügung.</p>

<p>Mit freundlichen Grüßen / best regards<br>
Serviceteam Mhoch3</p>

<p>
Mhoch3 GmbH &amp; Co. KG<br>
Sottorfallee 1A<br>
22529 Hamburg<br>
<br>
<a href="mailto:disposition@mh3.hamburg">disposition@mh3.hamburg</a><br>
Tel. 040 / 23 96 98 500
</p>

<p>
AG Hamburg, HRA 122576<br>
USt-ID-Nr. DE 316 301 875<br>
Finanzamt Hamburg<br>
<br>
Persönlich haftende Gesellschafterin:<br>
Mhoch3 Beteiligungs-GmbH, Hamburg<br>
AG Hamburg, HRB 149969<br>
GF: Frank Mühsam
</p>
`.trim();

    const dialogRef = this.dialog.open(EmailDialogComponent, {
      width: '70vw',
      maxWidth: '98vw',
      maxHeight: '90vh',
      data: {
        subject,
        body,
        recipients,
        context: {
          orderId: order?.id ?? order?.root_order?.id,
          mailTypeId: 1,
          appointmentId: appointmentId ?? undefined
        }
      }
    });

    dialogRef.afterClosed().subscribe((sent: boolean) => {
      if (sent && appointmentId) {
        this.markAppointmentAsPending(appointmentId);
      }
    });
  }

  /** Setzt im Frontend für einen Termin das Flag hasAppointmentRequest, damit „Wartend“ sofort angezeigt wird. */
  private markAppointmentAsPending(appointmentId: number): void {
    try {
      this.teamEvents.forEach((events: any[], teamId: number) => {
        const idx = events.findIndex(e => e.id === appointmentId);
        if (idx !== -1) {
          events[idx].hasAppointmentRequest = true;
        }
      });
      if (this.contextMenuEvent && this.contextMenuEvent.event && this.contextMenuEvent.event.id === appointmentId) {
        this.contextMenuEvent.event.hasAppointmentRequest = true;
      }
    } catch (e) {
      console.warn('markAppointmentAsPending: konnte Termin nicht markieren', e);
    }
  }

  moveEvent(event: any, newTeam: any, newDay: any): void {
    // Berechne neue Start- und Endzeit (behalte die ursprüngliche Dauer)
    const originalStart = moment(event.start || event.date);
    const originalEnd = moment(event.end || originalStart.clone().add(1, 'hour'));
    const duration = originalEnd.diff(originalStart, 'minutes');

    const newStartDate = newDay.date.clone().startOf('day').add(originalStart.hours(), 'hours').add(originalStart.minutes(), 'minutes');
    const newEndDate = newStartDate.clone().add(duration, 'minutes');
    const newResource = 'G' + newTeam.id;

    const updateData = {
      id: event.id,
      start: newStartDate.toDate(),
      end: newEndDate.toDate(),
      resource: newResource,
      team_order_type_id: event.teamOrderTypeId || event.team_order_type_id
    };

    this.teamOrderService.update(updateData).subscribe(
      result => {
        this.toastr.success('Termin wurde erfolgreich verschoben', 'Erfolg');
        
        // Aktualisiere das Event in teamStaffEvents sofort (wenn es ein Staff-Event ist)
        if (this.calendarMode === 'staff' && event.id) {
          this.teamStaffEvents.forEach((events, teamId) => {
            const eventIndex = events.findIndex((e: any) => e.id === event.id);
            if (eventIndex !== -1) {
              // Aktualisiere das Event mit neuen Daten
              const updatedEvent = events[eventIndex];
              updatedEvent.teamId = newTeam.id;
              updatedEvent.date = newDay.date.clone().startOf('day').add(originalStart.hours(), 'hours').add(originalStart.minutes(), 'minutes');
              updatedEvent.start = newStartDate.format('YYYY-MM-DD HH:mm:ss');
              updatedEvent.end = newEndDate.format('YYYY-MM-DD HH:mm:ss');
              events[eventIndex] = updatedEvent;
              this.teamStaffEvents.set(teamId, events);
            }
          });
          
          // Prüfe Doppelbelegungen sofort nach dem Verschieben
          this.checkAllDoubleBookings();
        }
        
        this.loadEvents();
        this.loadExistingAppointments();
        this.draggingEvent = null; // Verschieben-Modus deaktivieren
      },
      err => {
        this.toastr.error(err.error?.message || 'Fehler beim Verschieben', 'Fehler');
        this.draggingEvent = null; // Verschieben-Modus deaktivieren auch bei Fehler
      }
    );
  }

  loadEventsForDate(date: moment.Moment): void {
    // Hier können Events für ein spezifisches Datum geladen werden
    console.log('Events für', date.format('DD.MM.YYYY'));
  }

  getMonthYearLabel(): string {
    if (this.viewMode === 'week') {
      const weekEnd = this.weekStart.clone().endOf('isoWeek');
      if (this.weekStart.month() === weekEnd.month()) {
        return `${this.weekStart.format('D.')} - ${weekEnd.format('D. MMMM YYYY')}`;
      } else {
        return `${this.weekStart.format('D. MMM')} - ${weekEnd.format('D. MMM YYYY')}`;
      }
    }
    return this.currentDate.format('MMMM YYYY');
  }

  getFormattedDate(): string {
    if (this.viewMode === 'week') {
      // Für Wochenansicht: Datum des ersten Tages der Woche im Format TT.MM.JJ
      return this.weekStart.format('DD.MM.YY');
    }
    // Für Monatsansicht: Datum des ersten Tages des Monats im Format TT.MM.JJ
    return this.currentDate.clone().startOf('month').format('DD.MM.YY');
  }

  getEventsForDay(day: any): any[] {
    if (!this.events || this.events.length === 0) {
      return [];
    }
    return this.events.filter(event => 
      moment(event.date).isSame(day.date, 'day')
    );
  }

  getEventsForTeamAndDay(teamId: number, day: any): any[] {
    try {
      if (day?.date == null || teamId == null) return [];
      const dayM = moment(day.date);
      if (!dayM.isValid()) return [];
      if (this.calendarMode === 'staff') {
        const teamEvents = this.teamStaffEvents.get(teamId) || [];
        if (teamEvents.length === 0) return [];
        return teamEvents.filter(event => {
          try {
            const eventDate = moment(event?.date || event?.start);
            return eventDate.isValid() && eventDate.isSame(dayM, 'day');
          } catch (_) { return false; }
        });
      }
      const teamEvents = this.teamEvents.get(teamId) || [];
      if (teamEvents.length === 0) return [];
      return teamEvents.filter(event => {
        try {
          const eventDate = moment(event?.date);
          return eventDate.isValid() && eventDate.isSame(dayM, 'day');
        } catch (_) { return false; }
      });
    } catch (_) {
      return [];
    }
  }

  onSearchFilterChange(): void {
    // Filtere Teams basierend auf dem Suchtext
    this.applyTeamFilter();
    this.generateCalendar();
  }

  clearSearchFilter(): void {
    this.searchFilter = '';
    this.applyTeamFilter();
    this.generateCalendar();
  }

  getWeekDayLabel(day: any): string {
    return day.date.format('DD.MM.');
  }

  getCurrentWeekNumber(): number {
    return moment().isoWeek();
  }

  getWeekNumberForDate(date: moment.Moment): number {
    return date.isoWeek();
  }

  getCurrentYear(): number {
    return this.weekStart.isoWeekYear();
  }

  navigateToPreviousYear(): void {
    if (this.viewMode === 'week') {
      // Breche laufenden Debounce-Timer ab
      if (this.loadEventsDebounceTimer) {
        clearTimeout(this.loadEventsDebounceTimer);
        this.loadEventsDebounceTimer = null;
      }

      const currentYear = this.weekStart.isoWeekYear();
      const currentWeek = this.weekStart.isoWeek();
      this.weekStart = moment().isoWeekYear(currentYear - 1).isoWeek(currentWeek).startOf('isoWeek');
      this.generateCalendar();
      
      // Debounce: Warte 300ms, bevor Events geladen werden
      this.loadEventsDebounceTimer = setTimeout(() => {
        this.loadEvents();
        this.loadEventsDebounceTimer = null;
      }, 300);
    }
  }

  navigateToNextYear(): void {
    if (this.viewMode === 'week') {
      // Breche laufenden Debounce-Timer ab
      if (this.loadEventsDebounceTimer) {
        clearTimeout(this.loadEventsDebounceTimer);
        this.loadEventsDebounceTimer = null;
      }

      const currentYear = this.weekStart.isoWeekYear();
      const currentWeek = this.weekStart.isoWeek();
      this.weekStart = moment().isoWeekYear(currentYear + 1).isoWeek(currentWeek).startOf('isoWeek');
      this.generateCalendar();
      
      // Debounce: Warte 300ms, bevor Events geladen werden
      this.loadEventsDebounceTimer = setTimeout(() => {
        this.loadEvents();
        this.loadEventsDebounceTimer = null;
      }, 300);
    }
  }

  isCurrentWeek(weekNumber: number): boolean {
    // Prüfe ob es die angezeigte KW ist (weekStart), nicht die aktuelle KW von heute
    if (this.viewMode === 'week') {
      return weekNumber === this.weekStart.isoWeek();
    }
    return weekNumber === this.getCurrentWeekNumber();
  }

  getWeekNumbersForView(): number[] {
    if (this.viewMode === 'week') {
      // Bei Wochenansicht: 5 KW vor und 5 KW nach der aktuellen KW
      const currentWeek = this.weekStart.isoWeek();
      const currentYear = this.weekStart.isoWeekYear();
      const weekNumbers: number[] = [];
      
      // 5 KW vorher
      for (let i = 5; i >= 1; i--) {
        const weekDate = this.weekStart.clone().subtract(i, 'weeks');
        weekNumbers.push(weekDate.isoWeek());
      }
      
      // Aktuelle KW
      weekNumbers.push(currentWeek);
      
      // 5 KW danach
      for (let i = 1; i <= 5; i++) {
        const weekDate = this.weekStart.clone().add(i, 'weeks');
        weekNumbers.push(weekDate.isoWeek());
      }
      
      return weekNumbers;
    } else {
      // Bei Monatsansicht: alle KW des Monats
      const weekNumbers = new Set<number>();
      this.calendarDays.forEach(day => {
        weekNumbers.add(day.date.isoWeek());
      });
      return Array.from(weekNumbers).sort((a, b) => a - b);
    }
  }

  navigateToPreviousWeekRange(): void {
    if (this.viewMode === 'week') {
      // Breche laufenden Debounce-Timer ab
      if (this.loadEventsDebounceTimer) {
        clearTimeout(this.loadEventsDebounceTimer);
        this.loadEventsDebounceTimer = null;
      }

      this.weekStart.subtract(11, 'weeks'); // 11 Wochen zurück (5 + 5 + 1)
      this.generateCalendar();
      
      // Debounce: Warte 300ms, bevor Events geladen werden
      this.loadEventsDebounceTimer = setTimeout(() => {
        this.loadEvents();
        this.loadEventsDebounceTimer = null;
      }, 300);
    }
  }

  navigateToNextWeekRange(): void {
    if (this.viewMode === 'week') {
      // Breche laufenden Debounce-Timer ab
      if (this.loadEventsDebounceTimer) {
        clearTimeout(this.loadEventsDebounceTimer);
        this.loadEventsDebounceTimer = null;
      }

      this.weekStart.add(11, 'weeks'); // 11 Wochen vor (5 + 5 + 1)
      this.generateCalendar();
      
      // Debounce: Warte 300ms, bevor Events geladen werden
      this.loadEventsDebounceTimer = setTimeout(() => {
        this.loadEvents();
        this.loadEventsDebounceTimer = null;
      }, 300);
    }
  }

  navigateToWeek(weekNumber: number): void {
    if (this.viewMode === 'week') {
      // Breche laufenden Debounce-Timer ab
      if (this.loadEventsDebounceTimer) {
        clearTimeout(this.loadEventsDebounceTimer);
        this.loadEventsDebounceTimer = null;
      }

      // Finde die KW im aktuellen Jahr
      const currentYear = this.weekStart.isoWeekYear();
      let targetDate = moment().isoWeekYear(currentYear).isoWeek(weekNumber).startOf('isoWeek');
      
      // Prüfe ob die KW im nächsten Jahr liegt
      if (targetDate.isoWeek() !== weekNumber) {
        const nextYearDate = moment().isoWeekYear(currentYear + 1).isoWeek(weekNumber).startOf('isoWeek');
        if (nextYearDate.isoWeek() === weekNumber) {
          targetDate = nextYearDate;
        }
      }
      
      // Prüfe auch vorheriges Jahr
      if (targetDate.isoWeek() !== weekNumber) {
        const prevYearDate = moment().isoWeekYear(currentYear - 1).isoWeek(weekNumber).startOf('isoWeek');
        if (prevYearDate.isoWeek() === weekNumber) {
          targetDate = prevYearDate;
        }
      }
      
      this.weekStart = targetDate;
      this.generateCalendar();
      this.isLoadingEvents = true; // Zeige Skeleton beim Laden
      
      // Debounce: Warte 300ms, bevor Events geladen werden
      this.loadEventsDebounceTimer = setTimeout(() => {
        this.loadEvents();
        this.loadEventsDebounceTimer = null;
      }, 300);
    }
  }

  loadTeamOrderTypes(): void {
    // Direkt aus der Datenbank laden über HTTP
    const API_URL = environment.prismaApiUrl + '/api/dispo/team_order_types';
    
    this.http.get(API_URL).subscribe(
      (data: any) => {
        this.teamOrderTypes = data.data || data || [];
        console.log('loadTeamOrderTypes - geladene Termintypen:', this.teamOrderTypes);
        console.log('loadTeamOrderTypes - Anzahl Termintypen:', this.teamOrderTypes.length);
        if (this.teamOrderTypes.length > 0 && !this.selectedTeamOrderType) {
          this.selectedTeamOrderType = this.teamOrderTypes[0];
          console.log('loadTeamOrderTypes - Standard-Termintyp gesetzt:', this.selectedTeamOrderType);
        }
        // Nach dem Laden der Termintypen, lade die Termine neu (falls bereits vorhanden)
        if (this.orderData && this.orderData.id) {
          this.loadExistingAppointments();
        }
      },
      err => {
        console.error('Fehler beim Laden der TeamOrderTypes', err);
        console.error('Fehler-Details:', err.error);
        this.toastr.warning('Fehler beim Laden der Termintypen', 'Warnung');
        this.teamOrderTypes = [];
      }
    );
  }

  loadStatusList(): void {
    this.orderService.getFilter().subscribe(
      (data: any) => {
        this.statusList = data.statuses || [];
      },
      () => {
        this.statusList = [];
      }
    );
  }

  onTeamOrderTypeChange(selectedType: any): void {
    console.log('onTeamOrderTypeChange - Ausgewählter Typ:', selectedType);
    this.selectedTeamOrderType = selectedType;
    console.log('onTeamOrderTypeChange - selectedTeamOrderType gesetzt:', this.selectedTeamOrderType);
  }

  trackByTeamOrderType(index: number, item: any): any {
    return item ? item.id : index;
  }

  /** Vergleich per ID, damit die Auswahl bei neu geladenen teamOrderTypes erhalten bleibt. */
  compareTeamOrderTypeById(a: any, b: any): boolean {
    if (!a || !b) return a === b;
    const idA = a?.id ?? a;
    const idB = b?.id ?? b;
    return idA === idB;
  }

  trackByDragSlot(index: number, slot: { slotIndex: number; typeId: number }): any {
    return slot ? `${slot.slotIndex}-${slot.typeId}` : index;
  }

  /**
   * Effektiver Termintyp: Nur bei 0 Terminen oder wenn der Nutzer explizit Lieferung & Montage
   * gewählt hat und 1 Termin geplant ist, wird ein weiterer Slot erlaubt.
   * Bei 0 Terminen: selectedTeamOrderType. Bei 1 Termin: nur wenn selectedTeamOrderType
   * event_count>=2 hat (Lieferung & Montage), sonst null. Bei 2+ Terminen: null.
   */
  getEffectiveTeamOrderType(): any {
    const appointments = this.existingAppointments || [];
    if (appointments.length === 0) {
      return this.selectedTeamOrderType;
    }
    if (appointments.length >= 2) {
      return null;
    }
    const sel = this.selectedTeamOrderType;
    if (!sel || (sel.event_count ?? 1) < 2) {
      return null;
    }
    return sel;
  }

  /**
   * Liefert die noch zu verplanenden Drag-Slots je nach Termintyp.
   * Bei event_count=1: ein Slot. Bei Lieferung+Montage (event_count=2, event_type_ids): 2 Slots.
   * Bereits verplante Typen werden ausgeschlossen.
   * Bei Aufträgen mit 1 Termin (außer Lieferung+Montage): keine weiteren Slots.
   */
  getDragSlots(): { slotIndex: number; typeId: number; label: string; color?: string }[] {
    const type = this.getEffectiveTeamOrderType();
    if (!type || !this.orderData) {
      return [];
    }
    const eventCount = type.event_count ?? 1;
    const eventTypeIds: number[] = Array.isArray(type.event_type_ids) && type.event_type_ids.length > 0
      ? type.event_type_ids
      : Array(eventCount).fill(type.id);

    const filledTypeIds = new Set(
      (this.existingAppointments || [])
        .map((a: any) => a.teamOrderType?.id ?? a.team_order_type_id)
        .filter((id: any) => id != null)
    );

    const slots: { slotIndex: number; typeId: number; label: string; color?: string }[] = [];
    eventTypeIds.forEach((typeId: number, idx: number) => {
      if (filledTypeIds.has(typeId)) {
        return;
      }
      const t = this.teamOrderTypes.find((tt: any) => Number(tt?.id) === Number(typeId));
      slots.push({
        slotIndex: idx,
        typeId,
        label: t?.name ?? t?.label ?? String(typeId),
        color: t?.color
      });
    });
    return slots;
  }

  /** true, wenn alle erforderlichen Termine verplant sind (keine weiteren Slots). */
  isOrderFullyPlanned(): boolean {
    return this.getDragSlots().length === 0 && (this.existingAppointments?.length ?? 0) > 0;
  }

  hasExistingAppointments(): boolean {
    if (!this.orderData || !this.orderData.id) {
      return false;
    }
    return this.existingAppointments && this.existingAppointments.length > 0;
  }

  loadExistingAppointments(): void {
    if (!this.orderData || !this.orderData.id) {
      return;
    }

    this.isLoadingPanelLeft = true;
    this.cdr.detectChanges();

    // Lade bestehende Termine für diesen Auftrag
    // Verwende den Order-Service, der bereits TeamOrders mit Relations lädt
    this.orderService.getCurrentObject().subscribe(
      (order: any) => {
        if (order && order.team_orders) {
          this.existingAppointments = order.team_orders
            .map((to: any) => {
              // Versuche teamOrderType aus verschiedenen Quellen zu holen
              let teamOrderType = to.team_order_type || to.teamOrderType;
              
              // Falls nicht vorhanden, aber team_order_type_id vorhanden ist, 
              // suche in den bereits geladenen teamOrderTypes
              if (!teamOrderType && to.team_order_type_id && this.teamOrderTypes.length > 0) {
                teamOrderType = this.teamOrderTypes.find((type: any) => type.id === to.team_order_type_id);
              }
              
              // Versuche teamBase aus verschiedenen Quellen zu holen
              let teamBase = to.team_base || to.teamBase;
              
              // Falls nicht vorhanden, aber team_base_id vorhanden ist,
              // suche in den bereits geladenen teams
              if (!teamBase && to.team_base_id && this.teams.length > 0) {
                teamBase = this.teams.find((team: any) => team.id === to.team_base_id);
              }
              
              return {
                id: to.id,
                teamOrderType: teamOrderType,
                teamBase: teamBase,
                start: moment(to.start),
                end: moment(to.end),
                reserved: to.reserved,
                resource: to.resource,
                orderId: to.order_id,
                order: order, // Order-Daten für Nachname und PLZ
                confirmed_at: to.confirmed_at || null,
                declined_at: to.declined_at || null,
                hasAppointmentRequest: !!(to.has_appointment_request || (to.appointment_confirmation_tokens && to.appointment_confirmation_tokens.length > 0))
              };
            })
                .sort((a: any, b: any) => a.start.valueOf() - b.start.valueOf());
          this.isLoadingPanelLeft = false;
          this.cdr.detectChanges();
        } else {
          // Fallback: Direkt über HTTP laden
          this.http.get(environment.prismaApiUrl + '/api/dispo/team_orders').subscribe(
            (allTeamOrders: any) => {
              const teamOrders = allTeamOrders.data || allTeamOrders || [];
              this.existingAppointments = teamOrders
                .filter((to: any) => to.order_id === this.orderData.id)
                .map((to: any) => {
                  // Versuche teamOrderType aus verschiedenen Quellen zu holen
                  let teamOrderType = to.team_order_type || to.teamOrderType;
                  
                  // Falls nicht vorhanden, aber team_order_type_id vorhanden ist, 
                  // suche in den bereits geladenen teamOrderTypes
                  if (!teamOrderType && to.team_order_type_id && this.teamOrderTypes.length > 0) {
                    teamOrderType = this.teamOrderTypes.find((type: any) => type.id === to.team_order_type_id);
                  }
                  
                  // Versuche teamBase aus verschiedenen Quellen zu holen
                  let teamBase = to.team_base || to.teamBase;
                  
                  // Falls nicht vorhanden, aber team_base_id vorhanden ist,
                  // suche in den bereits geladenen teams
                  if (!teamBase && to.team_base_id && this.teams.length > 0) {
                    teamBase = this.teams.find((team: any) => team.id === to.team_base_id);
                  }
                  
                  return {
                    id: to.id,
                    teamOrderType: teamOrderType,
                    teamBase: teamBase,
                    start: moment(to.start),
                    end: moment(to.end),
                    reserved: to.reserved,
                    resource: to.resource,
                    orderId: to.order_id,
                    order: this.orderData, // Verwende bereits geladene Order-Daten
                    confirmed_at: to.confirmed_at || null,
                    declined_at: to.declined_at || null,
                    hasAppointmentRequest: !!(to.has_appointment_request || (to.appointment_confirmation_tokens && to.appointment_confirmation_tokens.length > 0))
                  };
                })
                .sort((a: any, b: any) => a.start.valueOf() - b.start.valueOf());
              this.isLoadingPanelLeft = false;
              this.cdr.detectChanges();
            },
            err => {
              console.error('Fehler beim Laden der bestehenden Termine', err);
              this.isLoadingPanelLeft = false;
              this.cdr.detectChanges();
            }
          );
        }
      },
      err => {
        console.error('Fehler beim Laden des Auftrags', err);
        this.isLoadingPanelLeft = false;
        this.cdr.detectChanges();
      }
    );
  }

  getTeamName(teamBase: any): string {
    if (!teamBase) return 'Unbekannt';
    return teamBase.label || teamBase.name || 'Team ' + (teamBase.id || '');
  }

  getTeamEmployeesForDay(teamId: number, day: any): any[] {
    // Verwende teamStaffEvents für Personal/Fahrzeuge
    const teamEvents = this.teamStaffEvents.get(teamId) || [];
    if (teamEvents.length === 0) {
      return [];
    }
    // Filtere Events für diesen Tag mit dispo_type = 0 (Personal)
    return teamEvents
      .filter(event => {
        const eventDate = moment(event.date || event.start);
        return eventDate.isSame(day.date, 'day') && event.dispoType === 0;
      })
      .map(event => {
        // Versuche Employee-Daten zu finden
        let employeeName = event.title || event.label || 'Unbekannt';
        
        // Zuerst versuche employee aus dem Event zu holen (vom Backend geladen)
        let employee = event.employee;
        
        // Wenn nicht vorhanden, suche in der employees-Liste
        if (!employee && (event.moduleItemId || event.module_item_id)) {
          const employeeId = event.moduleItemId || event.module_item_id;
          employee = this.employees.find((emp: any) => emp.id === employeeId);
        }
        
        if (employee) {
          const firstName = employee.first_name || '';
          const lastName = employee.last_name || '';
          if (firstName && lastName) {
            const firstInitial = firstName.charAt(0).toUpperCase();
            employeeName = `${firstInitial}. ${lastName}`;
          } else if (lastName) {
            employeeName = lastName;
          } else if (firstName) {
            employeeName = firstName;
          }
        }
        
        return {
          id: event.id,
          label: employeeName,
          title: employeeName,
          moduleItemId: event.moduleItemId || event.module_item_id
        };
      });
  }

  getTeamVehiclesForDay(teamId: number, day: any): any[] {
    // Verwende teamStaffEvents für Personal/Fahrzeuge
    const teamEvents = this.teamStaffEvents.get(teamId) || [];
    if (teamEvents.length === 0) {
      return [];
    }
    // Filtere Events für diesen Tag mit dispo_type = 1 (Fahrzeuge)
    return teamEvents
      .filter(event => {
        const eventDate = moment(event.date || event.start);
        return eventDate.isSame(day.date, 'day') && event.dispoType === 1;
      })
      .map(event => ({
        id: event.id,
        label: event.title || event.label || 'Unbekannt',
        title: event.title || event.label || 'Unbekannt',
        moduleItemId: event.moduleItemId || event.module_item_id
      }));
  }

  private getStaffAssignmentsForDay(teamId: number, day: any): any[] {
    const staffEvents = this.teamStaffEvents.get(teamId) || [];
    if (staffEvents.length === 0) {
      return [];
    }

    return staffEvents.filter(event => {
      const eventDate = moment(event.date || event.start);
      return eventDate.isSame(day.date, 'day');
    });
  }

  private staffAssignmentExists(teamId: number, targetDate: moment.Moment, assignment: any): boolean {
    const staffEvents = this.teamStaffEvents.get(teamId) || [];
    const moduleId = assignment.moduleItemId || assignment.module_item_id;

    return staffEvents.some(event => {
      const eventDate = moment(event.date || event.start);
      const eventModuleId = event.moduleItemId || event.module_item_id;
      return eventDate.isSame(targetDate, 'day')
        && event.dispoType === assignment.dispoType
        && moduleId
        && eventModuleId
        && moduleId === eventModuleId;
    });
  }

  private createStaffEventClone(assignment: any, team: any, targetDate: moment.Moment) {
    const startMoment = moment(assignment.start || assignment.date || targetDate.clone().startOf('day').add(8, 'hours'));
    const endMoment = assignment.end ? moment(assignment.end) : startMoment.clone().add(8, 'hours');

    const startDateTime = targetDate.clone().set({
      hour: startMoment.hour(),
      minute: startMoment.minute(),
      second: startMoment.second()
    });

    const endDateTime = targetDate.clone().set({
      hour: endMoment.hour(),
      minute: endMoment.minute(),
      second: endMoment.second()
    });

    const moduleId = assignment.moduleItemId || assignment.module_item_id || null;
    const resourcePrefix = assignment.resource?.charAt(0) || (assignment.dispoType === 0 ? 'P' : 'V');
    const resourceId = moduleId || assignment.resource || '';
    const resource = assignment.resource || `${resourcePrefix}${resourceId}`;

    const eventData = {
      resource: resource,
      label: assignment.label || assignment.title || 'Event',
      module_item_id: moduleId,
      start: startDateTime.format('YYYY-MM-DD HH:mm:ss'),
      end: endDateTime.format('YYYY-MM-DD HH:mm:ss'),
      team_base_id: team.id,
      dispo_type: assignment.dispoType,
      image: assignment.image || null,
      id: null
    };

    return this.http.post(environment.prismaApiUrl + '/api/dispo/team_events', { data: eventData });
  }

  private deleteTeamEvent(eventId: number) {
    return this.http.delete(environment.prismaApiUrl + '/api/dispo/team_events/' + eventId)
      .pipe(
        // Konvertiere erfolgreiche Antwort in einheitliches Format
        map((response: any) => ({ success: true, data: response })),
        // Behandle 404-Fehler (Event bereits gelöscht) als Erfolg
        catchError((error: any) => {
          if (error.status === 404) {
            // Event wurde bereits gelöscht, behandele als Erfolg
            return of({ success: true, message: 'Event bereits gelöscht' });
          }
          // Andere Fehler weiterwerfen
          return throwError(() => error);
        })
      );
  }

  private getHolidayForDate(date: moment.Moment): any | null {
    const key = date.format('YYYY-MM-DD');
    return this.holidaysMap.get(key) || null;
  }

  private applyHolidayToDay(dayObj: any): void {
    dayObj.holiday = this.getHolidayForDate(dayObj.date);
  }

  isTeamBlocked(teamId: number, day: any): boolean {
    const key = `${teamId}_${day.date.format('YYYY-MM-DD')}`;
    return this.teamBlockedDays.has(key);
  }

  getTeamBlockedNote(teamId: number, day: any): string {
    const key = `${teamId}_${day.date.format('YYYY-MM-DD')}`;
    return this.teamBlockedNotes.get(key) || '';
  }

  loadTeamAbsences(startDate: moment.Moment, endDate: moment.Moment, callback?: () => void): void {
    // Verhindere mehrfaches gleichzeitiges Laden
    if (this.isLoadingTeamAbsencesFlag) {
      if (callback) {
        callback();
      }
      return;
    }

    // Prüfe ob sich der Datumsbereich geändert hat
    if (this.lastLoadedDateRange && 
        this.lastLoadedDateRange.start.isSame(startDate, 'day') && 
        this.lastLoadedDateRange.end.isSame(endDate, 'day')) {
      if (callback) {
        callback();
      }
      return;
    }

    // Nur Abwesenheiten für die aktuell angezeigten Teams laden
    const teamIds = this.filteredTeams.length > 0 
      ? this.filteredTeams.map(team => team.id)
      : this.teams.map(team => team.id);
    
    if (teamIds.length === 0) {
      this.teamBlockedDays = new Set<string>();
      if (callback) {
        callback();
      }
      return;
    }

    this.isLoadingTeamAbsencesFlag = true;
    this.lastLoadedDateRange = { start: startDate.clone(), end: endDate.clone() };

    // Erstelle Parameter mit Team-IDs als Array
    let params = new HttpParams()
      .set('start', startDate.format('YYYY-MM-DD'))
      .set('end', endDate.format('YYYY-MM-DD'));
    
    // Füge team_base_id Parameter hinzu (als Array für mehrere Teams)
    teamIds.forEach(teamId => {
      params = params.append('team_base_id[]', teamId.toString());
    });

    this.http.get(environment.prismaApiUrl + '/api/dispo/team_absence', { params }).subscribe(
      (data: any) => {
        const allAbsences = data.data || data || [];
        const blocked = new Set<string>();

        // Verarbeite alle zurückgegebenen Abwesenheiten (bereits gefiltert vom Backend)
        allAbsences.forEach((absence: any) => {
          const teamId = absence.team_base_id;
          const absenceStart = moment(absence.start_date);
          const absenceEnd = moment(absence.end_date);
          const cursor = absenceStart.clone().startOf('day');
          while (cursor.isSameOrBefore(absenceEnd, 'day')) {
            const key = `${teamId}_${cursor.format('YYYY-MM-DD')}`;
            blocked.add(key);
            // Lade Notiz, falls vorhanden
            if (absence.note) {
              this.teamBlockedNotes.set(key, absence.note);
            }
            cursor.add(1, 'day');
          }
        });

        this.teamBlockedDays = blocked;
        this.isLoadingTeamAbsencesFlag = false;
        if (callback) {
          callback();
        }
      },
      err => {
        console.error('Fehler beim Laden der Team-Abwesenheiten', err);
        this.isLoadingTeamAbsencesFlag = false;
        if (callback) {
          callback();
        }
      }
    );
  }

  onTeamColumnRightClick(team: any, mouseEvent: MouseEvent): void {
    mouseEvent.preventDefault();
    mouseEvent.stopPropagation();

    this.contextMenuTeamColumn = team;
    this.contextMenuType = 'team-column';
    this.contextMenuPosition = {
      x: mouseEvent.clientX,
      y: mouseEvent.clientY
    };
    this.showContextMenu = true;
  }

  editTeam(): void {
    if (!this.contextMenuTeamColumn) {
      return;
    }
    
    // Lade Team-Daten vom Backend
    this.teamBaseService.show(this.contextMenuTeamColumn.id).subscribe(
      (data: any) => {
        const teamData = data.teamBase || data;
        this.editTeamModalData = {
          id: teamData.id,
          label: teamData.label || '',
          color: teamData.color || '#007bff',
          default_start: teamData.default_start || '08:00',
          default_end: teamData.default_end || '17:00',
          type: teamData.type || '',
          area: teamData.area || '',
          identity: teamData.identity || '',
          active: teamData.active !== undefined ? teamData.active : true,
          status_id: teamData.status_id || null,
          phone: teamData.phone || '',
          company_id: teamData.company_id || null,
          legacy_team_id: teamData.legacy_team_id || null,
          killable: teamData.killable !== undefined ? teamData.killable : false
        };
        this.teamEditTab = 'stammdaten';
        this.teamAbsenceYear = moment().year();
        this.selectedAbsenceDays.clear(); // Selektierte Tage zurücksetzen
        this.loadTeamAbsencesForTeam(teamData.id, this.teamAbsenceYear).catch(err => {
          console.error('Fehler beim Laden der Abwesenheiten', err);
        });
        this.showEditTeamModal = true;
        this.closeContextMenu();
      },
      err => {
        console.error('Fehler beim Laden der Team-Daten', err);
        this.toastr.error('Fehler beim Laden der Team-Daten', 'Fehler');
        this.closeContextMenu();
      }
    );
  }

  closeEditTeamModal(): void {
    this.showEditTeamModal = false;
    this.editTeamModalData = null;
    this.teamAbsences = [];
    this.selectedAbsenceDays.clear(); // Selektierte Tage zurücksetzen
  }

  createNewTeam(): void {
    // Navigiere zur Team-Base Route für neues Team
    // Die Route ist unter order-disposition verfügbar
    const orderId = this.orderData?.id;
    if (!orderId) {
      this.toastr.error('Keine Auftrags-ID gefunden', 'Fehler');
      return;
    }

    // Prüfe die aktuelle Route-Struktur
    const currentUrl = this.router.url;
    console.log('createNewTeam - current URL:', currentUrl);
    console.log('createNewTeam - orderId:', orderId);
    console.log('createNewTeam - route snapshot:', this.route.snapshot);
    
    // Navigiere absolut zur order-disposition/team/null/team-base Route
    const targetRoute = ['/order', orderId, 'order-disposition', 'team', 'null', 'team-base'];
    console.log('createNewTeam - navigating to:', targetRoute);
    console.log('createNewTeam - full path:', targetRoute.join('/'));
    
    this.router.navigate(targetRoute, { skipLocationChange: false }).then(
      (success) => {
        console.log('Navigation erfolgreich:', success);
        console.log('createNewTeam - new URL:', this.router.url);
        if (!success) {
          this.toastr.error('Navigation fehlgeschlagen - Route nicht gefunden', 'Fehler');
        }
      },
      (error) => {
        console.error('Navigation fehlgeschlagen:', error);
        this.toastr.error('Fehler bei der Navigation: ' + (error?.message || 'Unbekannter Fehler'), 'Fehler');
      }
    );
  }

  saveTeam(): void {
    if (!this.editTeamModalData) {
      this.toastr.error('Keine Team-Daten zum Speichern', 'Fehler');
      return;
    }

    // Bereite Daten für das Backend vor
    const teamData: any = {
      label: this.editTeamModalData.label,
      color: this.editTeamModalData.color,
      default_start: this.editTeamModalData.default_start,
      default_end: this.editTeamModalData.default_end,
      type: this.editTeamModalData.type,
      identity: this.editTeamModalData.identity,
      active: this.editTeamModalData.active,
      status_id: this.editTeamModalData.status_id,
      phone: this.editTeamModalData.phone,
      company_id: this.editTeamModalData.company_id,
      killable: this.editTeamModalData.killable
    };

    // Füge optionale Felder hinzu, falls vorhanden
    if (this.editTeamModalData.customer_id) {
      teamData.customer_id = this.editTeamModalData.customer_id;
    }
    if (this.editTeamModalData.customer_branch_id) {
      teamData.customer_branch_id = this.editTeamModalData.customer_branch_id;
    }
    if (this.editTeamModalData.legacy_team_id) {
      teamData.legacy_team_id = this.editTeamModalData.legacy_team_id;
    }

    // Wenn ID vorhanden, aktualisiere; sonst erstelle neues Team
    if (this.editTeamModalData.id) {
      const updateData = { ...teamData, id: this.editTeamModalData.id, deleted_at: null };
      this.teamBaseService.update(updateData).subscribe(
        (data: any) => {
          // Speichere auch die Abwesenheiten, wenn welche selektiert sind
          if (this.selectedAbsenceDays.size > 0) {
            this.saveAbsences().then(() => {
              this.toastr.success('Team und Abwesenheiten wurden erfolgreich gespeichert', 'Erfolg');
              // Modal bleibt offen - nicht schließen
              // Aktualisiere die Teams-Liste durch Neuladen der Events (Teams kommen aus Resources)
              this.loadEvents();
            }).catch(err => {
              this.toastr.error('Team wurde gespeichert, aber Abwesenheiten konnten nicht aktualisiert werden', 'Teilweise erfolgreich');
              // Modal bleibt offen auch bei Fehler
              this.loadEvents();
            });
          } else {
            this.toastr.success('Team wurde erfolgreich gespeichert', 'Erfolg');
            // Modal bleibt offen - nicht schließen
            // Aktualisiere die Teams-Liste durch Neuladen der Events (Teams kommen aus Resources)
            this.loadEvents();
          }
        },
        err => {
          console.error('Fehler beim Speichern des Teams', err);
          this.toastr.error(err.error?.message || 'Fehler beim Speichern des Teams', 'Fehler');
        }
      );
    } else {
      // Neues Team erstellen
      this.teamBaseService.store(teamData).subscribe(
        (data: any) => {
          const newTeam = data.data || data;
          // Aktualisiere editTeamModalData mit der neuen ID
          this.editTeamModalData.id = newTeam.id;
          this.toastr.success('Neues Team wurde erfolgreich erstellt', 'Erfolg');
          // Aktualisiere die Teams-Liste durch Neuladen der Events
          this.loadEvents();
        },
        err => {
          console.error('Fehler beim Erstellen des Teams', err);
          this.toastr.error(err.error?.message || 'Fehler beim Erstellen des Teams', 'Fehler');
        }
      );
    }
  }

  blockTeamForWeek(): void {
    if (!this.contextMenuTeamColumn) {
      return;
    }
    const teamName = this.contextMenuTeamColumn.label || this.contextMenuTeamColumn.name || `Team ${this.contextMenuTeamColumn.id}`;
    const weekRange = `${this.weekStart.clone().format('DD.MM.')} - ${this.weekStart.clone().endOf('isoWeek').format('DD.MM.YYYY')}`;

    Swal.fire({
      title: 'Team blockieren?',
      text: `Soll ${teamName} für die Woche ${weekRange} blockiert werden?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#00a5a8',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ja, blockieren',
      cancelButtonText: 'Abbrechen'
    }).then(result => {
      if (!result.isConfirmed) {
        this.closeContextMenu();
        return;
      }

      const startOfWeek = this.weekStart.clone().startOf('day');
      const endOfWeek = this.weekStart.clone().endOf('isoWeek').startOf('day');
      const daysToBlock: moment.Moment[] = [];
      const dayCursor = startOfWeek.clone();
      let needsBlocking = false;

      while (dayCursor.isSameOrBefore(endOfWeek, 'day')) {
        const key = `${this.contextMenuTeamColumn.id}_${dayCursor.format('YYYY-MM-DD')}`;
        if (!this.teamBlockedDays.has(key)) {
          needsBlocking = true;
        }
        daysToBlock.push(dayCursor.clone());
        dayCursor.add(1, 'day');
      }

      if (!needsBlocking) {
        this.toastr.info('Team ist bereits für diese Woche blockiert.', 'Info');
        this.closeContextMenu();
        return;
      }

      const payload = {
        data: {
          team_base_id: this.contextMenuTeamColumn.id,
          start_date: startOfWeek.clone().startOf('day').format('YYYY-MM-DD 00:00:00'),
          end_date: endOfWeek.clone().endOf('day').format('YYYY-MM-DD 23:59:59'),
          absence_type: 'blocked',
          absence_type_id: 0,
          note: `Kalenderblock KW ${this.weekStart.isoWeek()}`
        }
      };

      this.http.post(environment.prismaApiUrl + '/api/dispo/team_absence', payload).subscribe(
        () => {
          daysToBlock.forEach(day => {
            const key = `${this.contextMenuTeamColumn.id}_${day.format('YYYY-MM-DD')}`;
            this.teamBlockedDays.add(key);
          });
          this.toastr.success(`${teamName} wurde blockiert.`, 'Erfolg');
          // Anzeige aktualisieren und Absences neu laden
          this.loadTeamAbsences(this.weekStart.clone().startOf('isoWeek'), this.weekStart.clone().endOf('isoWeek'));
          this.generateCalendar();
          this.closeContextMenu();
        },
        err => {
          console.error('Fehler beim Blockieren des Teams', err);
          this.toastr.error(err.error?.error || 'Fehler beim Blockieren des Teams', 'Fehler');
          this.closeContextMenu();
        }
      );
    });
  }

  getTeamEmployeesForDayFormatted(teamId: number, day: any): string {
    const employees = this.getTeamEmployeesForDay(teamId, day);
    if (employees.length === 0) {
      return '';
    }
    return employees.map(emp => emp.label).join(', ');
  }

  getTeamVehiclesForDayFormatted(teamId: number, day: any): string {
    const vehicles = this.getTeamVehiclesForDay(teamId, day);
    if (vehicles.length === 0) {
      return '';
    }
    return vehicles.map(veh => veh.label).join(', ');
  }

  getTeamStaffingForDay(team: any, day: any): number {
    // Prüfe ob team.staffing oder team.person_count vorhanden ist
    if (team.person_count) {
      return team.person_count;
    }
    // Fallback: Prüfe ob team.data oder team.members vorhanden ist
    if (team.data && team.data.person_count) {
      return team.data.person_count;
    }
    if (team.members && Array.isArray(team.members)) {
      return team.members.length;
    }
    // Dummy-Besetzung: Zufällige Anzahl zwischen 2 und 5 Personen basierend auf Team-ID
    const dummyCount = 2 + (team.id % 4); // 2-5 Personen
    return dummyCount;
  }


  formatCurrency(value: string | number): string {
    if (!value) return '';
    
    const numValue = typeof value === 'string' ? parseFloat(value) : value;
    if (isNaN(numValue)) return '';
    
    // Formatiere als Euro mit Tausender-Trennzeichen und 2 Dezimalstellen
    return numValue.toLocaleString('de-DE', {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    }) + '€';
  }

  getTeamPersonsCount(teamId: number): number {
    // Dummy-Daten: Anzahl der Personen für das Team
    // In einer echten Implementierung würde dies aus der Datenbank kommen
    const team = this.teams.find(t => t.id === teamId);
    if (team && team.employees && Array.isArray(team.employees)) {
      return team.employees.length;
    }
    // Fallback: Dummy-Wert basierend auf Team-ID
    return 2 + (teamId % 3); // 2-4 Personen
  }

  getTeamPersonsDays(teamId: number): number {
    // Berechne die Anzahl der Tage, an denen Personen für dieses Team geplant sind
    const teamEvents = this.teamEvents.get(teamId) || [];
    if (teamEvents.length === 0) return 0;
    
    // Filtere Events der aktuellen Woche
    const weekStart = this.weekStart.clone().startOf('day');
    const weekEnd = this.weekStart.clone().endOf('isoWeek').endOf('day');
    
    const weekEvents = teamEvents.filter((event: any) => {
      const eventDate = moment(event.date || event.start);
      return eventDate.isSameOrAfter(weekStart) && eventDate.isSameOrBefore(weekEnd);
    });
    
    // Zähle eindeutige Tage
    const uniqueDays = new Set();
    weekEvents.forEach((event: any) => {
      const eventDate = moment(event.date || event.start);
      uniqueDays.add(eventDate.format('YYYY-MM-DD'));
    });
    
    return uniqueDays.size;
  }

  getTeamVehiclesCount(teamId: number): number {
    // Dummy-Daten: Anzahl der Fahrzeuge für das Team
    // In einer echten Implementierung würde dies aus der Datenbank kommen
    const team = this.teams.find(t => t.id === teamId);
    if (team && team.vehicles && Array.isArray(team.vehicles)) {
      return team.vehicles.length;
    }
    // Fallback: Immer 1 Fahrzeug
    return 1;
  }

  getTeamVehiclesDays(teamId: number): number {
    // Berechne die Anzahl der Tage, an denen Fahrzeuge für dieses Team geplant sind
    // Dies ist identisch mit den Personentagen, da beide für die gleichen Events geplant sind
    return this.getTeamPersonsDays(teamId);
  }

  setCalendarMode(mode: 'orders' | 'staff' | 'appointment'): void {
    const previousMode = this.calendarMode;
    this.calendarMode = mode;
    // Bei Wechsel zurück zu Aufträge, selectedEventData zurücksetzen
    if (mode === 'orders') {
      this.selectedEventData = null;
      this.selectedEventDocuments = [];
      this.selectedEventNotes = [];
    }
    // Bei Modus-Wechsel Events neu laden (auch bei appointment, damit Termine angezeigt werden)
    // ABER: Wenn bereits im appointment-Modus und zu appointment wechseln, keine Events neu laden
    if (mode === 'orders' || (mode === 'appointment' && previousMode !== 'appointment')) {
      this.loadEvents();
    }
  }

  setDisplayMode(mode: 'full' | 'compact' | 'team'): void {
    this.displayMode = mode;
    // Bei Vollansicht: aktuelle Kalendereinstellung beibehalten
    // Bei Kompaktansicht: Events werden auf max 2 Zeilen begrenzt (via CSS)
    // Bei Teamansicht: (später implementieren)
    this.generateCalendar();
  }

  loadEmployees(): void {
    this.employeeService.getAll().subscribe(
      (data: any) => {
        this.employees = data.data || data || [];
        this.filterEmployees();
      },
      err => {
        console.error('Fehler beim Laden der Mitarbeiter', err);
      }
    );
  }

  loadCustomers(): void {
    this.http.get(environment.prismaApiUrl + '/api/dispo/customers').subscribe(
      (data: any) => {
        this.customersList = data.data || data || [];
      },
      err => {
        console.error('Fehler beim Laden der Kunden', err);
      }
    );
  }

  loadTeamBaseData(): void {
    // Lade companyList und legacyList nur einmal beim Initialisieren
    this.teamBaseService.getCurrentObject().subscribe(
      (data: any) => {
        this.companyList = data.companyList || [];
        this.legacyList = data.legacyList || [];
      },
      err => {
        console.error('Fehler beim Laden der Team-Base-Daten', err);
        this.companyList = [];
        this.legacyList = [];
      }
    );
  }

  loadVehicles(): void {
    this.http.get(environment.prismaApiUrl + '/api/dispo/vehicles').subscribe(
      (data: any) => {
        this.vehicles = data.data || data || [];
      },
      err => {
        console.error('Fehler beim Laden der Fahrzeuge', err);
      }
    );
  }

  loadHolidays(): void {
    this.http.get(environment.prismaApiUrl + '/api/dispo/holidays').subscribe(
      (data: any) => {
        const holidays = data.data || data || [];
        const map = new Map<string, any>();
        holidays.forEach((holiday: any) => {
          const key = moment(holiday.date).format('YYYY-MM-DD');
          map.set(key, holiday);
        });
        this.holidaysMap = map;
        this.generateCalendar();
      },
      err => {
        console.error('Fehler beim Laden der Feiertage', err);
      }
    );
  }

  get filteredEmployees(): any[] {
    if (!this.employeeFilter || !this.employeeFilter.trim()) {
      return this.employees;
    }
    const filter = this.employeeFilter.toLowerCase().trim();
    return this.employees.filter(emp => {
      const firstName = (emp.first_name || '').toLowerCase();
      const lastName = (emp.last_name || '').toLowerCase();
      return firstName.includes(filter) || lastName.includes(filter);
    });
  }

  filterEmployees(): void {
    // Die Filterung erfolgt über den Getter filteredEmployees
  }

  onEmployeeDragStart(event: DragEvent, employee: any): void {
    this.draggedEmployee = employee;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', JSON.stringify({
        type: 'employee',
        employee: employee
      }));
    }
  }

  onVehicleDragStart(event: DragEvent, vehicle: any): void {
    this.draggedVehicle = vehicle;
    if (event.dataTransfer) {
      event.dataTransfer.effectAllowed = 'move';
      event.dataTransfer.setData('text/plain', JSON.stringify({
        type: 'vehicle',
        vehicle: vehicle
      }));
    }
  }

  private isEmployeeAlreadyAssigned(employeeId: number, day: any): boolean {
    const dayKey = day.date.format('YYYY-MM-DD');
    
    // Prüfe in allen Teams, ob das Personal bereits an diesem Tag eingeplant ist
    for (const [teamId, teamEvents] of this.teamStaffEvents.entries()) {
      const hasAssignment = teamEvents.some((event: any) => {
        if (!event) return false;
        
        // Verschiedene Möglichkeiten, das Datum zu bekommen
        let eventDate: moment.Moment;
        if (event.date) {
          eventDate = moment(event.date);
        } else if (event.start) {
          eventDate = moment(event.start).local();
        } else {
          return false;
        }
        
        const isSameDay = eventDate.isSame(day.date, 'day');
        
        // Verschiedene Möglichkeiten, die module_item_id zu bekommen
        const eventModuleItemId = event.moduleItemId || event.module_item_id;
        const isEmployee = event.dispoType === 0 && eventModuleItemId === employeeId;
        
        return isSameDay && isEmployee;
      });
      if (hasAssignment) {
        console.log('Doppelbelegung gefunden für Employee', employeeId, 'am Tag', dayKey, 'in Team', teamId);
        return true;
      }
    }
    
    // Zusätzlich: Prüfe auch in teamEvents (falls vorhanden)
    for (const [teamId, teamEvents] of this.teamEvents.entries()) {
      const hasAssignment = teamEvents.some((event: any) => {
        if (!event) return false;
        
        let eventDate: moment.Moment;
        if (event.date) {
          eventDate = moment(event.date);
        } else if (event.start) {
          eventDate = moment(event.start).local();
        } else {
          return false;
        }
        
        const isSameDay = eventDate.isSame(day.date, 'day');
        const eventModuleItemId = event.moduleItemId || event.module_item_id;
        const isEmployee = event.dispoType === 0 && eventModuleItemId === employeeId;
        
        return isSameDay && isEmployee;
      });
      if (hasAssignment) {
        console.log('Doppelbelegung gefunden für Employee', employeeId, 'am Tag', dayKey, 'in TeamEvents', teamId);
        return true;
      }
    }
    
    return false;
  }

  private isVehicleAlreadyAssigned(vehicleId: number, day: any): boolean {
    const dayKey = day.date.format('YYYY-MM-DD');
    
    // Prüfe in allen Teams, ob das Fahrzeug bereits an diesem Tag eingeplant ist
    for (const [teamId, teamEvents] of this.teamStaffEvents.entries()) {
      const hasAssignment = teamEvents.some((event: any) => {
        if (!event) return false;
        
        // Verschiedene Möglichkeiten, das Datum zu bekommen
        let eventDate: moment.Moment;
        if (event.date) {
          eventDate = moment(event.date);
        } else if (event.start) {
          eventDate = moment(event.start).local();
        } else {
          return false;
        }
        
        const isSameDay = eventDate.isSame(day.date, 'day');
        
        // Verschiedene Möglichkeiten, die module_item_id zu bekommen
        const eventModuleItemId = event.moduleItemId || event.module_item_id;
        const isVehicle = event.dispoType === 1 && eventModuleItemId === vehicleId;
        
        return isSameDay && isVehicle;
      });
      if (hasAssignment) {
        console.log('Doppelbelegung gefunden für Vehicle', vehicleId, 'am Tag', dayKey, 'in Team', teamId);
        return true;
      }
    }
    
    // Zusätzlich: Prüfe auch in teamEvents (falls vorhanden)
    for (const [teamId, teamEvents] of this.teamEvents.entries()) {
      const hasAssignment = teamEvents.some((event: any) => {
        if (!event) return false;
        
        let eventDate: moment.Moment;
        if (event.date) {
          eventDate = moment(event.date);
        } else if (event.start) {
          eventDate = moment(event.start).local();
        } else {
          return false;
        }
        
        const isSameDay = eventDate.isSame(day.date, 'day');
        const eventModuleItemId = event.moduleItemId || event.module_item_id;
        const isVehicle = event.dispoType === 1 && eventModuleItemId === vehicleId;
        
        return isSameDay && isVehicle;
      });
      if (hasAssignment) {
        console.log('Doppelbelegung gefunden für Vehicle', vehicleId, 'am Tag', dayKey, 'in TeamEvents', teamId);
        return true;
      }
    }
    
    return false;
  }

  private checkAllDoubleBookings(): void {
    // Prüfe alle Events auf Doppelbelegungen
    this.doubleBookedEvents.clear();
    
    // Sammle alle Events mit ihrer module_item_id, dispo_type und Datum
    const eventsByItemAndDay = new Map<string, number[]>();
    
    for (const [teamId, teamEvents] of this.teamStaffEvents.entries()) {
      teamEvents.forEach((event: any) => {
        const eventDate = moment(event.date || event.start);
        const dayKey = eventDate.format('YYYY-MM-DD');
        const moduleItemId = event.moduleItemId || event.module_item_id;
        const dispoType = event.dispoType || event.dispo_type;
        
        if (moduleItemId !== null && moduleItemId !== undefined) {
          const key = `${moduleItemId}_${dispoType}_${dayKey}`;
          if (!eventsByItemAndDay.has(key)) {
            eventsByItemAndDay.set(key, []);
          }
          eventsByItemAndDay.get(key)!.push(event.id);
        }
      });
    }
    
    // Markiere alle Events als Doppelbelegung, wenn mehr als 1 Event für dasselbe Item/Tag existiert
    eventsByItemAndDay.forEach((eventIds: number[]) => {
      if (eventIds.length > 1) {
        eventIds.forEach(eventId => {
          this.doubleBookedEvents.add(eventId);
        });
      }
    });
  }

  private isEventDoubleBooked(eventId: number, moduleItemId: number, dispoType: number, eventDate: moment.Moment): boolean {
    // Prüfe ob das Event im doubleBookedEvents Set ist
    return this.doubleBookedEvents.has(eventId);
  }

  createEmployeeEvent(employee: any, team: any, day: any): void {
    // Immer prüfen, ob Doppelbelegung vorliegt (nur im Teammode)
    if (this.calendarMode !== 'staff') {
      this.createEmployeeEventInternal(employee, team, day, false);
      return;
    }
    
    // Prüfe direkt vom Backend, ob bereits ein Event existiert
    this.checkEmployeeDoubleBookingFromBackend(employee, team, day);
  }

  private checkEmployeeDoubleBookingFromBackend(employee: any, team: any, day: any): void {
    const startDate = day.date.clone().startOf('day');
    const endDate = day.date.clone().endOf('day');
    
    // Lade alle Events für diesen Tag vom Backend
    this.http.post(environment.prismaApiUrl + '/api/dispo/team_events/get-all-by-resource-and-date', {
      data: {
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD')
      }
    }).subscribe(
      (data: any) => {
        const allEvents = data.data || data || [];
        
        // Prüfe ob bereits ein Event für dieses Personal an diesem Tag existiert
        const existingEvent = allEvents.find((item: any) => {
          const location = item.location || item;
          if (!location) return false;
          
          // Prüfe Datum
          const eventDate = moment(location.start).local();
          const isSameDay = eventDate.isSame(day.date, 'day');
          
          // Prüfe ob es Personal ist (dispo_type === 0)
          const isEmployee = location.dispo_type === 0;
          
          // Prüfe ob es dasselbe Personal ist
          const isSameEmployee = location.module_item_id === employee.id;
          
          const result = isSameDay && isEmployee && isSameEmployee;
          if (result) {
            console.log('Doppelbelegung gefunden:', {
              employeeId: employee.id,
              eventDate: eventDate.format('YYYY-MM-DD'),
              dayDate: day.date.format('YYYY-MM-DD'),
              location: location
            });
          }
          return result;
        });
        
        if (existingEvent) {
          const employeeName = `${employee.first_name} ${employee.last_name}`;
          const dateLabel = day.date.format('DD.MM.YYYY');
          Swal.fire({
            title: 'Doppelbelegung',
            html: `<p><strong>${employeeName}</strong> ist bereits am <strong>${dateLabel}</strong> eingeplant.</p><p>Möchten Sie trotzdem fortfahren?</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Zustimmen',
            cancelButtonText: 'Abbrechen'
          }).then((result) => {
            if (result.isConfirmed) {
              this.createEmployeeEventInternal(employee, team, day, true); // true = Doppelbelegung
            }
          });
        } else {
          this.createEmployeeEventInternal(employee, team, day, false);
        }
      },
      err => {
        console.error('Fehler beim Prüfen der Doppelbelegung', err);
        // Bei Fehler trotzdem erstellen
        this.createEmployeeEventInternal(employee, team, day, false);
      }
    );
  }

  private createEmployeeEventInternal(employee: any, team: any, day: any, isDoubleBooking: boolean): void {
    const startDate = day.date.clone().startOf('day').add(8, 'hours'); // 8:00 Uhr als Standard
    const endDate = startDate.clone().add(8, 'hours'); // 8 Stunden Standard

    const eventData = {
      resource: 'P' + employee.id,
      label: employee.first_name + ' ' + employee.last_name,
      module_item_id: employee.id, // Wichtig: module_item_id muss gesetzt sein, damit nur dieses Event gelöscht wird
      start: startDate.format('YYYY-MM-DD HH:mm:ss'),
      end: endDate.format('YYYY-MM-DD HH:mm:ss'),
      team_base_id: team.id,
      dispo_type: 0, // 0 = Personal
      image: null,
      id: null // id ist null beim Erstellen
    };

    this.http.post(environment.prismaApiUrl + '/api/dispo/team_events', { data: eventData }).subscribe(
      (response: any) => {
        const createdEvent = response.data || response;
        const eventId = createdEvent.id || createdEvent.location?.id;
        
        // Wenn Doppelbelegung, markiere das Event
        if (isDoubleBooking && eventId) {
          this.doubleBookedEvents.add(eventId);
        }
        
        this.toastr.success('Personal wurde erfolgreich eingeplant', 'Erfolg');
        this.loadEvents();
      },
      err => {
        console.error('Fehler beim Einplanen des Personals', err);
        this.toastr.error(err.error?.error || 'Fehler beim Einplanen des Personals', 'Fehler');
      }
    );
  }

  createVehicleEvent(vehicle: any, team: any, day: any): void {
    // Immer prüfen, ob Doppelbelegung vorliegt (nur im Teammode)
    if (this.calendarMode !== 'staff') {
      this.createVehicleEventInternal(vehicle, team, day, false);
      return;
    }
    
    // Prüfe direkt vom Backend, ob bereits ein Event existiert
    this.checkVehicleDoubleBookingFromBackend(vehicle, team, day);
  }

  private checkVehicleDoubleBookingFromBackend(vehicle: any, team: any, day: any): void {
    const startDate = day.date.clone().startOf('day');
    const endDate = day.date.clone().endOf('day');
    
    // Lade alle Events für diesen Tag vom Backend
    this.http.post(environment.prismaApiUrl + '/api/dispo/team_events/get-all-by-resource-and-date', {
      data: {
        start: startDate.format('YYYY-MM-DD'),
        end: endDate.format('YYYY-MM-DD')
      }
    }).subscribe(
      (data: any) => {
        const allEvents = data.data || data || [];
        
        // Prüfe ob bereits ein Event für dieses Fahrzeug an diesem Tag existiert
        const existingEvent = allEvents.find((item: any) => {
          const location = item.location || item;
          if (!location) return false;
          
          // Prüfe Datum
          const eventDate = moment(location.start).local();
          const isSameDay = eventDate.isSame(day.date, 'day');
          
          // Prüfe ob es ein Fahrzeug ist (dispo_type === 1)
          const isVehicle = location.dispo_type === 1;
          
          // Prüfe ob es dasselbe Fahrzeug ist
          const isSameVehicle = location.module_item_id === vehicle.id;
          
          const result = isSameDay && isVehicle && isSameVehicle;
          if (result) {
            console.log('Doppelbelegung gefunden:', {
              vehicleId: vehicle.id,
              eventDate: eventDate.format('YYYY-MM-DD'),
              dayDate: day.date.format('YYYY-MM-DD'),
              location: location
            });
          }
          return result;
        });
        
        if (existingEvent) {
          const vehicleName = vehicle.label || vehicle.license_plate || 'Fahrzeug ' + vehicle.id;
          const dateLabel = day.date.format('DD.MM.YYYY');
          Swal.fire({
            title: 'Doppelbelegung',
            html: `<p><strong>${vehicleName}</strong> ist bereits am <strong>${dateLabel}</strong> eingeplant.</p><p>Möchten Sie trotzdem fortfahren?</p>`,
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#dc3545',
            cancelButtonColor: '#6c757d',
            confirmButtonText: 'Zustimmen',
            cancelButtonText: 'Abbrechen'
          }).then((result) => {
            if (result.isConfirmed) {
              this.createVehicleEventInternal(vehicle, team, day, true); // true = Doppelbelegung
            }
          });
        } else {
          this.createVehicleEventInternal(vehicle, team, day, false);
        }
      },
      err => {
        console.error('Fehler beim Prüfen der Doppelbelegung', err);
        // Bei Fehler trotzdem erstellen
        this.createVehicleEventInternal(vehicle, team, day, false);
      }
    );
  }

  private createVehicleEventInternal(vehicle: any, team: any, day: any, isDoubleBooking: boolean): void {
    const startDate = day.date.clone().startOf('day').add(8, 'hours'); // 8:00 Uhr als Standard
    const endDate = startDate.clone().add(8, 'hours'); // 8 Stunden Standard

    const eventData = {
      resource: 'V' + vehicle.id,
      label: vehicle.label || vehicle.license_plate || 'Fahrzeug ' + vehicle.id,
      module_item_id: vehicle.id, // Wichtig: module_item_id muss gesetzt sein, damit nur dieses Event gelöscht wird
      start: startDate.format('YYYY-MM-DD HH:mm:ss'),
      end: endDate.format('YYYY-MM-DD HH:mm:ss'),
      team_base_id: team.id,
      dispo_type: 1, // 1 = Fahrzeug
      image: null,
      id: null // id ist null beim Erstellen
    };

    this.http.post(environment.prismaApiUrl + '/api/dispo/team_events', { data: eventData }).subscribe(
      (response: any) => {
        const createdEvent = response.data || response;
        const eventId = createdEvent.id || createdEvent.location?.id;
        
        // Wenn Doppelbelegung, markiere das Event
        if (isDoubleBooking && eventId) {
          this.doubleBookedEvents.add(eventId);
        }
        
        this.toastr.success('Fahrzeug wurde erfolgreich eingeplant', 'Erfolg');
        this.loadEvents();
        // Prüfe Doppelbelegungen nach dem Laden
        setTimeout(() => this.checkAllDoubleBookings(), 100);
      },
      err => {
        console.error('Fehler beim Einplanen des Fahrzeugs', err);
        this.toastr.error(err.error?.error || 'Fehler beim Einplanen des Fahrzeugs', 'Fehler');
      }
    );
  }

  formatMoveDuration(duration: string): string {
    if (!duration) return '';
    
    // Konvertiere zu String falls es ein anderes Format ist
    const durationStr = String(duration).trim();
    
    // Versuche verschiedene Formate zu parsen
    // Format könnte sein: "2 hours 30 mins", "2h 30m", "2:30", etc.
    let hours = 0;
    let minutes = 0;
    
    // Suche nach "hours" oder "hour"
    const hoursMatch = durationStr.match(/(\d+)\s*(?:hours?|h)/i);
    if (hoursMatch) {
      hours = parseInt(hoursMatch[1], 10);
    }
    
    // Suche nach "mins", "minutes", "minute" oder "m"
    const minutesMatch = durationStr.match(/(\d+)\s*(?:minutes?|mins?|m)(?!\w)/i);
    if (minutesMatch) {
      minutes = parseInt(minutesMatch[1], 10);
    }
    
    // Falls keine Stunden/Minuten gefunden, versuche "X:XX" Format
    if (hours === 0 && minutes === 0) {
      const timeMatch = durationStr.match(/(\d+):(\d+)/);
      if (timeMatch) {
        hours = parseInt(timeMatch[1], 10);
        minutes = parseInt(timeMatch[2], 10);
      }
    }
    
    // Falls immer noch nichts gefunden, versuche nur Zahlen zu extrahieren
    if (hours === 0 && minutes === 0) {
      const numbers = durationStr.match(/\d+/g);
      if (numbers && numbers.length >= 2) {
        hours = parseInt(numbers[0], 10);
        minutes = parseInt(numbers[1], 10);
      } else if (numbers && numbers.length === 1) {
        // Wenn nur eine Zahl vorhanden ist, könnte es Minuten sein
        const totalMinutes = parseInt(numbers[0], 10);
        if (totalMinutes >= 60) {
          hours = Math.floor(totalMinutes / 60);
          minutes = totalMinutes % 60;
        } else {
          minutes = totalMinutes;
        }
      }
    }
    
    // Formatiere als "Xh Ymin" oder nur "Ymin" wenn keine Stunden
    if (hours > 0 && minutes > 0) {
      return `${hours}h ${minutes}min`;
    } else if (hours > 0) {
      return `${hours}h`;
    } else if (minutes > 0) {
      return `${minutes}min`;
    }
    
    // Fallback: Original zurückgeben
    return durationStr;
  }

  getTeamWeeklyRevenue(teamId: number): string {
    // Lade Events für das Team in der aktuellen Woche
    const teamEvents = this.teamEvents.get(teamId) || [];
    
    // Filtere Events der aktuellen Woche
    const weekStart = this.weekStart.clone().startOf('day');
    const weekEnd = this.weekStart.clone().endOf('isoWeek').endOf('day');
    
    const weekEvents = teamEvents.filter((event: any) => {
      const eventDate = moment(event.date || event.start);
      return eventDate.isSameOrAfter(weekStart) && eventDate.isSameOrBefore(weekEnd);
    });
    
    // Summiere order_calcs_total aus den Events
    let totalRevenue = 0;
    weekEvents.forEach((event: any) => {
      if (event.data && event.data.order_calcs_total) {
        const revenue = parseFloat(event.data.order_calcs_total);
        if (!isNaN(revenue)) {
          totalRevenue += revenue;
        }
      }
    });
    
    // Formatiere als Währung (2 Dezimalstellen)
    if (totalRevenue > 0) {
      return totalRevenue.toFixed(2);
    }
    
    return '';
  }


  getAppointmentTypeName(teamOrderType: any): string {
    if (!teamOrderType) return 'Kein Typ';
    return teamOrderType.name || 'Unbekannt';
  }

  // Hilfsfunktionen für Anzeige von Auftragsdaten im Kalender

  private getEventBaseOrder(event: any): any {
    if (!event) {
      return null;
    }

    const data = event.data || {};

    // Order kann in verschiedenen Strukturen liegen
    // 1) Direkt im Event
    if (event.order) {
      return event.order;
    }

    // 2) In data.order (verschachtelt)
    if (data.order) {
      return data.order;
    }

    // 3) data ist bereits der Order
    return data;
  }

  private getEventRootOrder(event: any): any {
    const baseOrder = this.getEventBaseOrder(event) || {};
    return (
      baseOrder.root_order ||
      baseOrder.rootOrder ||
      null
    );
  }

  // Hintergrundfarbe für Events (Order-Type / Rekla-Verursacher)
  getEventBackgroundColor(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};

    if (!baseOrder) {
      return '#fff';
    }

    // Rekla: nach Payer (Verursacher) einfärben, sonst order_type.color
    let baseColor: string;

    if (baseOrder.order_type_id === 0) {
      const payer = this.payerList.find(p => p.id === baseOrder.rekla_payer_id);
      baseColor = payer ? (payer.bgcolor || '#fff') : (baseOrder.order_type?.color || baseOrder.orderType?.color || '#fff');
    } else {
      // Alle anderen: immer order_type.color
      baseColor = baseOrder.order_type?.color || baseOrder.orderType?.color || '#fff';
    }

    return this.withOpacity(baseColor, 0.5);
  }

  // Textfarbe für Events (bei Rekla ggf. nach Payer)
  getEventTextColor(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};

    if (!baseOrder) {
      return '#000';
    }

    if (baseOrder.order_type_id === 0) {
      const payer = this.payerList.find(p => p.id === baseOrder.rekla_payer_id);
      return payer ? (payer.color || '#000') : '#000';
    }

    return '#000';
  }

  // Volle Farbe (ohne Opacity) für Rahmen / Border
  getEventBorderColor(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};

    if (!baseOrder) {
      return '#00a5a8';
    }

    if (baseOrder.order_type_id === 0) {
      const payer = this.payerList.find(p => p.id === baseOrder.rekla_payer_id);
      return payer ? (payer.bgcolor || '#00a5a8') : (baseOrder.order_type?.color || baseOrder.orderType?.color || '#00a5a8');
    }

    return baseOrder.order_type?.color || baseOrder.orderType?.color || '#00a5a8';
  }

  // Hilfsfunktion: Hex-Farbe nach rgba mit Opacity umrechnen
  private withOpacity(color: string, opacity: number): string {
    if (!color) {
      return `rgba(255, 255, 255, ${opacity})`;
    }

    // Nur für Hex-Farben anwenden
    if (color.startsWith('#')) {
      let hex = color.replace('#', '');

      if (hex.length === 3) {
        hex = hex.split('').map(c => c + c).join('');
      }

      if (hex.length === 6) {
        const r = parseInt(hex.substring(0, 2), 16);
        const g = parseInt(hex.substring(2, 4), 16);
        const b = parseInt(hex.substring(4, 6), 16);
        return `rgba(${r}, ${g}, ${b}, ${opacity})`;
      }
    }

    // Fallback: Originalfarbe zurückgeben
    return color;
  }

  getEventOrderNumber(event: any): string | null {
    const baseOrder = this.getEventBaseOrder(event) || {};
    return (
      event.order_number ||
      (event.data ? event.data.order_number : null) ||
      baseOrder.order_number ||
      null
    );
  }

  getEventOrderNumbers(event: any): { first: string | null, count: number } {
    const numbers: string[] = [];
    
    // Sammle alle möglichen Auftragsnummern
    if (event.order_number) {
      numbers.push(event.order_number);
    }
    if (event.data?.order_number) {
      numbers.push(event.data.order_number);
    }
    if (event.order?.order_number) {
      numbers.push(event.order.order_number);
    }
    
    const baseOrder = this.getEventBaseOrder(event) || {};
    if (baseOrder.order_number) {
      numbers.push(baseOrder.order_number);
    }
    
    // Entferne Duplikate
    const uniqueNumbers = [...new Set(numbers.filter(n => n != null && n !== ''))];
    
    return {
      first: uniqueNumbers.length > 0 ? uniqueNumbers[0] : null,
      count: uniqueNumbers.length
    };
  }

  getEventCustomerFirstName(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};
    const person = rootOrder.person || baseOrder.person || {};

    return (
      person.first_name ||
      baseOrder.first_name ||
      ''
    );
  }

  getEventCustomerLastName(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};
    const person = rootOrder.person || baseOrder.person || {};

    return (
      person.last_name ||
      baseOrder.last_name ||
      ''
    );
  }

  teamHasEventsThisWeek(teamId: number): boolean {
    if (!this.calendarDays || this.calendarDays.length === 0) return false;
    return this.calendarDays.some(day => this.getEventsForTeamAndDay(teamId, day).length > 0);
  }

  getEventStreet(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};

    return (
      rootOrder.street ||
      baseOrder.street ||
      ''
    );
  }

  getEventPostalCode(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};
    const person = rootOrder.person || baseOrder.person || {};

    return (
      person.postal_code ||
      rootOrder.postal_code ||
      baseOrder.postal_code ||
      ''
    );
  }

  getEventPlace(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};
    const person = rootOrder.person || baseOrder.person || {};

    return (
      person.place ||
      rootOrder.place ||
      baseOrder.place ||
      ''
    );
  }

  getEventOrderTypeLabel(event: any): string {
    const orderData = event.data || event.order || {};
    const orderType = event.orderType || orderData.order_type || orderData.orderType || null;
    
    return orderType?.label || orderType?.name || '';
  }

  getEventTeamOrderTypeShort(event: any): string {
    const teamOrderType = event.teamOrderType || event.team_order_type || null;
    
    if (!teamOrderType) {
      return '';
    }
    
    // Prüfe verschiedene mögliche Felder für 'short'
    return teamOrderType.short || teamOrderType.Short || teamOrderType.short_name || '';
  }

  /** Auftragsstatus für Event-Anzeige: "AS: id" oder "AS: id Label" */
  getEventOrderStatusDisplay(event: any): string {
    const orderData = event.data || event.order || event;
    const statusId = orderData.status_id ?? orderData.status?.id ?? null;
    if (statusId == null) {
      return '';
    }
    const label = orderData.status?.label || orderData.status?.name || '';
    return label ? `AS: ${statusId} ${label}` : `AS: ${statusId}`;
  }

  getEventOrderStatusId(event: any): string | null {
    const orderData = event.data || event.order || event;
    const id = orderData.status_id ?? orderData.status?.id ?? null;
    return id != null ? String(id) : null;
  }

  /** Status-Label für farbige Anzeige */
  getEventOrderStatusLabel(event: any): string {
    const orderData = event.data || event.order || event;
    return orderData?.status?.label || orderData?.status?.name || '';
  }

  /** Status-Farbe (status.color) für label */
  getEventOrderStatusColor(event: any): string | null {
    const orderData = event.data || event.order || event;
    return orderData?.status?.color || null;
  }

  /** Status-Label für Order (Termindetails links): aus order.status oder statusList auflösen. */
  getOrderStatusDisplayLabel(order: any): string {
    if (!order) return '';
    const status = order.status || order.Status;
    if (status && (status.label || status.name)) return status.label || status.name;
    const id = order.status_id ?? status?.id;
    if (id != null && this.statusList?.length) {
      const s = this.statusList.find((x: any) => x.id === id);
      return s ? (s.label || s.name || '') : '';
    }
    return '';
  }

  /** Status-Farbe für Order (Termindetails links): aus order.status oder statusList auflösen. */
  getOrderStatusDisplayColor(order: any): string | null {
    if (!order) return null;
    const status = order.status || order.Status;
    if (status && status.color) return status.color;
    const id = order.status_id ?? status?.id;
    if (id != null && this.statusList?.length) {
      const s = this.statusList.find((x: any) => x.id === id);
      return s?.color ?? null;
    }
    return null;
  }

  private getReklaSelectedType(order: any): 'system' | 'ap' | 'ist' | '' {
    if (!order) {
      return '';
    }
    const rootOrder = order.root_order || order.rootOrder || {};
    
    // Prüfe order_type_id an verschiedenen Stellen
    const orderTypeId = order.order_type_id 
      ?? rootOrder.order_type_id 
      ?? order.orderType?.id 
      ?? rootOrder.orderType?.id
      ?? order.order_type?.id
      ?? rootOrder.order_type?.id;
    
    if (orderTypeId !== 0) {
      return '';
    }
    const type = (order.rekla_selected_type || rootOrder.rekla_selected_type || '').toLowerCase();
    if (type === 'system' || type === 'ap' || type === 'ist') {
      return type as 'system' | 'ap' | 'ist';
    }
    return '';
  }

  getReklaSelectedTypeLabel(event: any): string {
    const orderData = event.data || event.order || {};
    const type = this.getReklaSelectedType(orderData);
    switch (type) {
      case 'ist':
        return 'IST';
      case 'ap':
        return 'AP';
      case 'system':
        return 'SYS';
      default:
        return '';
    }
  }

  getReklaSelectedMinutes(event: any): number | null {
    const orderData = event.data || event.order || {};
    const rootOrder = orderData.root_order || orderData.rootOrder || {};
    const type = this.getReklaSelectedType(orderData);
    switch (type) {
      case 'ist':
        return orderData?.rekla_real ?? rootOrder?.rekla_real ?? null;
      case 'ap':
        return orderData?.rekla_ap ?? rootOrder?.rekla_ap ?? null;
      case 'system':
        return orderData?.duration ?? rootOrder?.duration ?? null;
      default:
        return null;
    }
  }

  getReklaSelectedDisplay(event: any): string {
    const minutes = this.getReklaSelectedMinutes(event);
    return minutes != null ? this.helper.convertMinutesToHours(minutes) : '-';
  }

  isReklaOrder(event: any): boolean {
    const orderData = event.data || event.order || {};
    const rootOrder = orderData.root_order || orderData.rootOrder || {};
    
    // Prüfe order_type_id an verschiedenen Stellen
    const orderTypeId = orderData?.order_type_id 
      ?? rootOrder?.order_type_id 
      ?? orderData?.orderType?.id 
      ?? rootOrder?.orderType?.id
      ?? orderData?.order_type?.id
      ?? rootOrder?.order_type?.id;
    
    return orderTypeId === 0;
  }

  isKitchenOrder(event: any): boolean {
    const orderData = event.data || event.order || {};
    const rootOrder = orderData.root_order || orderData.rootOrder || {};
    
    // Prüfe order_type_id an verschiedenen Stellen
    const orderTypeId = orderData?.order_type_id 
      ?? rootOrder?.order_type_id 
      ?? orderData?.orderType?.id 
      ?? rootOrder?.orderType?.id
      ?? orderData?.order_type?.id
      ?? rootOrder?.order_type?.id;
    
    // Küche ist normalerweise order_type_id === 1, aber prüfe auch !== 0 (nicht Rekla)
    return orderTypeId !== 0 && orderTypeId !== null && orderTypeId !== undefined;
  }

  isKitchenOrderData(orderData: any): boolean {
    const rootOrder = orderData?.root_order || orderData?.rootOrder || {};
    
    // Prüfe order_type_id an verschiedenen Stellen
    const orderTypeId = orderData?.order_type_id 
      ?? rootOrder?.order_type_id 
      ?? orderData?.orderType?.id 
      ?? rootOrder?.orderType?.id
      ?? orderData?.order_type?.id
      ?? rootOrder?.order_type?.id;
    
    // Küche ist normalerweise order_type_id === 1, aber prüfe auch !== 0 (nicht Rekla)
    return orderTypeId !== 0 && orderTypeId !== null && orderTypeId !== undefined;
  }

  isReklaOrderData(orderData: any): boolean {
    const rootOrder = orderData?.root_order || orderData?.rootOrder || {};
    
    // Prüfe order_type_id an verschiedenen Stellen
    const orderTypeId = orderData?.order_type_id 
      ?? rootOrder?.order_type_id 
      ?? orderData?.orderType?.id 
      ?? rootOrder?.orderType?.id
      ?? orderData?.order_type?.id
      ?? rootOrder?.order_type?.id;
    
    return orderTypeId === 0;
  }

  getKitchenSkillItems(orderData: any): any[] {
    // Prüfe verschiedene mögliche Stellen für skill_items
    const skillItems = orderData?.skill_items 
      || orderData?.skillItems
      || orderData?.root_order?.skill_items
      || orderData?.root_order?.skillItems
      || orderData?.rootOrder?.skill_items
      || orderData?.rootOrder?.skillItems
      || [];
    
    return Array.isArray(skillItems) ? skillItems : [];
  }

  /** Skill-IDs (params) in Skill-Objekte auflösen. */
  private resolveSkillItemsFromParams(params: any): any[] {
    if (!params || !Array.isArray(params)) return [];
    return params
      .map((id: number) => this.skillById[id])
      .filter(Boolean);
  }

  /** Teams aus Resources mit skill_items anreichern, falls Backend data.teams mit params liefert. */
  private enrichTeamsWithSkillItems(backendTeams: any[] | undefined): void {
    if (!backendTeams || !Array.isArray(backendTeams)) return;
    const byId = new Map(backendTeams.map((t: any) => [t.id, t]));
    this.teams.forEach(team => {
      const current = team.skill_items || team.skillItems;
      if (current && Array.isArray(current) && current.length > 0) return;
      const backend = byId.get(team.id);
      const resolved = this.resolveSkillItemsFromParams(backend?.params);
      if (resolved.length > 0) {
        team.skill_items = resolved;
      }
    });
  }

  getTeamSkillItems(team: any): any[] {
    // Prüfe verschiedene mögliche Stellen für skill_items beim Team
    const skillItems = team?.skill_items 
      || team?.skillItems
      || team?.team_base?.skill_items
      || team?.team_base?.skillItems
      || [];
    
    return Array.isArray(skillItems) ? skillItems : [];
  }

  /** Team-Skills nach Kategorie gruppiert für Popup (wie im Calendar). */
  getTeamSkillsByCategory(team: any): { categoryName: string; items: any[] }[] {
    const items = this.getTeamSkillItems(team);
    const byCategory: { [key: string]: any[] } = {};
    items.forEach((s: any) => {
      const cat = s.skill_category?.title || s.skill_category?.name || 'Sonstige';
      if (!byCategory[cat]) byCategory[cat] = [];
      byCategory[cat].push(s);
    });
    return Object.keys(byCategory).map(cat => ({ categoryName: cat, items: byCategory[cat] }));
  }

  /** Kommagetrennte Skill-Namen für title-Attribut (Template darf keine Arrow-Funktion). */
  getTeamSkillTitles(team: any): string {
    const items = this.getTeamSkillItems(team);
    if (!items.length) return 'Keine Skills hinterlegt';
    return items.map((s: any) => s.title || s.name || '').filter(Boolean).join(', ');
  }

  /** Skills-Popup fixed positionieren (außerhalb der Spalte, damit z-index greift) */
  skillsPopupVisible = false;
  skillsPopupTeam: any = null;
  skillsPopupLeft = 0;
  skillsPopupTop = 0;
  private skillsPopupHideTimer: any = null;
  /** Letztes Ergebnis der Wochen-Prüfung (Aufträge der Woche für dieses Team) für Anzeige im Popup. */
  skillsPopupWeekResult: { total: number; withParams: number; ok: number; warn: number } | null = null;

  showSkillsPopup(team: any, event: MouseEvent): void {
    if (this.skillsPopupHideTimer) {
      clearTimeout(this.skillsPopupHideTimer);
      this.skillsPopupHideTimer = null;
    }
    const el = event.currentTarget as HTMLElement;
    const rect = el.getBoundingClientRect();
    this.skillsPopupTeam = team;
    this.skillsPopupLeft = rect.left;
    this.skillsPopupTop = rect.bottom + 4;
    this.skillsPopupVisible = true;
    this.cdr.detectChanges();
  }

  hideSkillsPopup(): void {
    this.skillsPopupHideTimer = setTimeout(() => {
      this.skillsPopupVisible = false;
      this.skillsPopupTeam = null;
      this.skillsPopupWeekResult = null;
      this.skillsPopupHideTimer = null;
    }, 150);
  }

  cancelSkillsPopupHide(): void {
    if (this.skillsPopupHideTimer) {
      clearTimeout(this.skillsPopupHideTimer);
      this.skillsPopupHideTimer = null;
    }
  }

  /** IDs aus order_params (oder params / root_order) – für Teilmenge-Prüfung. */
  private getOrderParamIds(orderData: any): number[] {
    const raw = orderData?.order_params
      ?? orderData?.params
      ?? orderData?.root_order?.order_params
      ?? orderData?.root_order?.params
      ?? orderData?.rootOrder?.order_params
      ?? orderData?.rootOrder?.params;
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : [raw];
    return arr.map((id: any) => Number(id)).filter((n: number) => !isNaN(n) && n > 0);
  }

  /** Für Template: order_params-IDs (Länge für *ngIf). */
  getOrderParamIdsForTemplate(orderData: any): number[] {
    return this.getOrderParamIds(orderData);
  }

  /** IDs aus team_base.params – für Teilmenge-Prüfung. */
  private getTeamBaseParamIds(team: any): number[] {
    const base = team?.team_base ?? team;
    const raw = base?.params;
    if (!raw) return [];
    const arr = Array.isArray(raw) ? raw : [raw];
    return arr.map((id: any) => Number(id)).filter((n: number) => !isNaN(n) && n > 0);
  }

  /** Prüft: order.params (IDs) sind Teilmenge von team_base.params (IDs). */
  orderParamsSubsetOfTeamBase(orderData: any, team: any): boolean {
    const orderIds = this.getOrderParamIds(orderData);
    if (orderIds.length === 0) return true;
    const teamIds = new Set(this.getTeamBaseParamIds(team));
    return orderIds.every((id: number) => teamIds.has(id));
  }

  /** Prüft: Auftrag hat params-IDs, die nicht in team_base.params sind. */
  orderParamsExceedTeamBase(orderData: any, team: any): boolean {
    const orderIds = this.getOrderParamIds(orderData);
    if (orderIds.length === 0) return false;
    const teamIds = new Set(this.getTeamBaseParamIds(team));
    return orderIds.some((id: number) => !teamIds.has(id));
  }

  /** Alle Aufträge (orderData), die dem Team in der aktuellen Woche zugeordnet sind (nach Order-ID dedupliziert). */
  private getOrdersForTeamInWeek(team: any): { orderData: any; orderId: number | string }[] {
    const teamId = team?.id ?? team?.team_base?.id;
    if (teamId == null || !this.calendarDays?.length) return [];
    const seen = new Set<number | string>();
    const result: { orderData: any; orderId: number | string }[] = [];
    for (const day of this.calendarDays) {
      const events = this.getEventsForTeamAndDay(teamId, day);
      for (const ev of events) {
        const orderData = ev?.data ?? ev?.order ?? ev;
        const orderId = orderData?.id ?? orderData?.root_order?.id ?? orderData?.rootOrder?.id ?? ev?.order_id ?? ev?.id;
        if (orderId != null && !seen.has(orderId)) {
          seen.add(orderId);
          result.push({ orderData, orderId });
        }
      }
    }
    return result;
  }

  /** Klick auf Skills: Alle Aufträge der Woche für dieses Team prüfen (order.params ⊆ team_base.params), dann Toast mit Ergebnis. */
  onTeamSkillsClick(team: any, event: MouseEvent): void {
    event.preventDefault();
    event.stopPropagation();
    this.showSkillsPopup(team, event);
    this.toastr.info('Skills werden geprüft (Aufträge der Woche für dieses Team) …', 'Skills', { timeOut: 1200 });

    const ordersInWeek = this.getOrdersForTeamInWeek(team);
    const withParams = ordersInWeek.filter(o => this.getOrderParamIds(o.orderData).length > 0);
    let okCount = 0;
    let warnCount = 0;
    for (const { orderData } of withParams) {
      if (this.orderParamsSubsetOfTeamBase(orderData, team)) okCount++; else warnCount++;
    }
    this.skillsPopupWeekResult = {
      total: ordersInWeek.length,
      withParams: withParams.length,
      ok: okCount,
      warn: warnCount
    };

    if (withParams.length === 0) {
      this.toastr.info(
        ordersInWeek.length === 0
          ? 'Keine Aufträge dieser Woche dem Team zugeordnet.'
          : ordersInWeek.length + ' Aufträge der Woche haben keine Skill-Params (params).',
        'Skills'
      );
      return;
    }

    if (warnCount === 0) {
      this.toastr.success(
        withParams.length + ' Aufträge der Woche geprüft: Alle Skills (params) sind Teilmenge von team_base.params.',
        'Skills ✓'
      );
    } else {
      this.toastr.warning(
        withParams.length + ' Aufträge geprüft: ' + warnCount + ' mit Skills (params), die das Team nicht abdeckt.',
        'Skills ⚠'
      );
    }
  }

  /** Skill-Items eines Auftrags (Event) – aus data/order skill_items oder skill_ids/params. */
  getOrderSkillItemsForEvent(event: any): any[] {
    const orderData = event?.data || event?.order || event;
    const fromItems = this.getKitchenSkillItems(orderData);
    if (fromItems.length > 0) return fromItems;
    // Fallback: nur IDs (skill_ids, params) – in Objekte auflösen
    const ids = orderData?.skill_ids
      || orderData?.skillIds
      || orderData?.root_order?.skill_ids
      || orderData?.root_order?.skillIds
      || orderData?.rootOrder?.skill_ids
      || orderData?.rootOrder?.skillIds
      || orderData?.params;
    if (ids && Array.isArray(ids)) {
      return ids
        .map((id: number) => this.skillById[id] || { id: Number(id), skill_id: Number(id), title: String(id) })
        .filter(Boolean);
    }
    return [];
  }

  /** Normierten Titel für Skill-Vergleich (ohne ID). */
  private skillTitleKey(s: any): string {
    const t = (s?.title ?? s?.name ?? '').toString().trim().toLowerCase();
    return t || '';
  }

  /** true, wenn Auftrags-Skills Teilmenge der Team-Skills sind (nur Woche, Auftragsmodus, Auftrag hat Skills). */
  orderSkillsSubsetOfTeam(event: any, team: any): boolean {
    if (this.viewMode !== 'week') return false;
    if (this.calendarMode !== 'orders' && this.calendarMode !== 'appointment') return false;
    const orderItems = this.getOrderSkillItemsForEvent(event);
    if (orderItems.length === 0) return false;
    const teamIds = new Set<number>();
    const teamTitles = new Set<string>();
    this.getTeamSkillItems(team).forEach((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) teamIds.add(Number(id));
      const key = this.skillTitleKey(s);
      if (key) teamTitles.add(key);
    });
    return orderItems.every((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) return teamIds.has(Number(id));
      return teamTitles.has(this.skillTitleKey(s));
    });
  }

  /** true, wenn Auftrag Skills hat, die nicht in der Team-Base sind (Warnung). */
  orderSkillsExceedTeam(event: any, team: any): boolean {
    if (this.viewMode !== 'week') return false;
    if (this.calendarMode !== 'orders' && this.calendarMode !== 'appointment') return false;
    const orderItems = this.getOrderSkillItemsForEvent(event);
    if (orderItems.length === 0) return false;
    const teamIds = new Set<number>();
    const teamTitles = new Set<string>();
    this.getTeamSkillItems(team).forEach((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) teamIds.add(Number(id));
      const key = this.skillTitleKey(s);
      if (key) teamTitles.add(key);
    });
    return orderItems.some((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) return !teamIds.has(Number(id));
      return !teamTitles.has(this.skillTitleKey(s));
    });
  }

  /** Prüfung für Team-Spalte: Auftrags-Skills (orderData) Teilmenge der Team-Skills? */
  orderDataSkillsSubsetOfTeam(orderData: any, team: any): boolean {
    const orderItems = this.getOrderSkillItemsForEvent({ data: orderData });
    if (orderItems.length === 0) return false;
    const teamIds = new Set<number>();
    const teamTitles = new Set<string>();
    this.getTeamSkillItems(team).forEach((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) teamIds.add(Number(id));
      const key = this.skillTitleKey(s);
      if (key) teamTitles.add(key);
    });
    return orderItems.every((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) return teamIds.has(Number(id));
      return teamTitles.has(this.skillTitleKey(s));
    });
  }

  /** Prüfung für Team-Spalte: Auftrag hat Skills, die das Team nicht abdeckt. */
  orderDataSkillsExceedTeam(orderData: any, team: any): boolean {
    const orderItems = this.getOrderSkillItemsForEvent({ data: orderData });
    if (orderItems.length === 0) return false;
    const teamIds = new Set<number>();
    const teamTitles = new Set<string>();
    this.getTeamSkillItems(team).forEach((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) teamIds.add(Number(id));
      const key = this.skillTitleKey(s);
      if (key) teamTitles.add(key);
    });
    return orderItems.some((s: any) => {
      const id = s?.id ?? s?.skill_id;
      if (id != null) return !teamIds.has(Number(id));
      return !teamTitles.has(this.skillTitleKey(s));
    });
  }

  getKitchenOrderValue(event: any): number | null {
    const orderData = event.data || event.order || {};
    const rootOrder = orderData.root_order || orderData.rootOrder || {};
    
    return orderData?.order_value ?? rootOrder?.order_value ?? null;
  }

  getKitchenAmountTotal(event: any): number | null {
    const orderData = event.data || event.order || {};
    const rootOrder = orderData.root_order || orderData.rootOrder || {};
    
    return orderData?.amount_total ?? rootOrder?.amount_total ?? null;
  }

  getKitchenPayerLabel(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};
    
    const payerId = baseOrder.rekla_payer_id || rootOrder.rekla_payer_id || null;
    if (payerId === null || payerId === undefined) {
      return '';
    }
    
    const payer = this.payerList.find(p => p.id === payerId);
    return payer ? payer.label : '';
  }

  getKitchenPayerShort(event: any): string {
    const baseOrder = this.getEventBaseOrder(event) || {};
    const rootOrder = this.getEventRootOrder(event) || {};
    
    const payerId = baseOrder.rekla_payer_id || rootOrder.rekla_payer_id || null;
    if (payerId === null || payerId === undefined) {
      return '';
    }
    
    const payer = this.payerList.find(p => p.id === payerId);
    return payer ? payer.short : '';
  }

  getKitchenMeHours(event: any): number | null {
    const me = this.getKitchenAmountTotal(event);
    if (me === null || me === 0) {
      return null;
    }
    // Zeit in Stunden: ME * 5 Minuten / 2 / 60 = ME / 24
    return me / 24;
  }

  getKitchenMeValue(event: any): number | null {
    const me = this.getKitchenAmountTotal(event);
    if (me === null || me === 0) {
      return null;
    }
    
    const orderData = event.data || event.order || {};
    const rootOrder = orderData.root_order || orderData.rootOrder || {};
    
    // customer_calc_value aus order oder root_order
    const customerCalcValue = orderData.customer_calc_value || rootOrder.customer_calc_value || null;
    if (customerCalcValue === null) {
      return null;
    }
    
    // Zeit in Stunden berechnen: ME / 24
    const hours = me / 24;
    // Wert = Stunden * customer_calc_value
    const value = hours * customerCalcValue;
    
    return Math.round(value * 100) / 100; // Auf 2 Dezimalstellen runden
  }

  getReklaSummaryForDay(teamId: number, day: any): { sys: number, ap: number, ist: number } {
    const events = this.getEventsForTeamAndDay(teamId, day);
    const reklaEvents = events.filter(event => this.isReklaOrder(event));
    
    let sysTotal = 0;
    let apTotal = 0;
    let istTotal = 0;
    
    reklaEvents.forEach(event => {
      const orderData = event.data || event.order || {};
      const rootOrder = orderData.root_order || orderData.rootOrder || {};
      const type = this.getReklaSelectedType(orderData);
      
      let minutes = 0;
      switch (type) {
        case 'system':
          minutes = orderData?.duration ?? rootOrder?.duration ?? 0;
          sysTotal += minutes;
          break;
        case 'ap':
          minutes = orderData?.rekla_ap ?? rootOrder?.rekla_ap ?? 0;
          apTotal += minutes;
          break;
        case 'ist':
          minutes = orderData?.rekla_real ?? rootOrder?.rekla_real ?? 0;
          istTotal += minutes;
          break;
      }
    });
    
    // Küchen-ME zur Gesamtsumme hinzufügen: ME * 5 Minuten / 2
    const kitchenEvents = events.filter(event => this.isKitchenOrder(event));
    let kitchenMinutesTotal = 0;
    kitchenEvents.forEach(event => {
      const me = this.getKitchenAmountTotal(event);
      if (me !== null && me > 0) {
        kitchenMinutesTotal += (me * 5) / 2; // ME * 5 Minuten / 2
      }
    });
    
    // Küchen-ME-Zeit zu sys hinzufügen (wird in formatReklaSummary zur Gesamtsumme addiert)
    sysTotal += kitchenMinutesTotal;
    
    return {
      sys: sysTotal,
      ap: apTotal,
      ist: istTotal
    };
  }

  formatReklaSummary(summary: { sys: number, ap: number, ist: number }): string {
    // Summiere alle Stunden zusammen
    const totalMinutes = summary.sys + summary.ap + summary.ist;
    
    if (totalMinutes > 0) {
      return this.helper.convertMinutesToHours(totalMinutes);
    }
    
    return '';
  }

  checkDocumentsForEvents(): void {
    // Sammle alle eindeutigen Order-IDs aus allen Events
    const orderIdMap = new Map<number, any[]>(); // Map: orderId -> Events
    
    this.teamEvents.forEach((events) => {
      events.forEach((event) => {
        // Versuche Order-ID aus verschiedenen Stellen zu holen
        // Priorität: orderId (direkt) > rootOrderId > data.id > data.root_order.id
        const orderId = event.orderId 
          || event.rootOrderId
          || event.data?.id 
          || event.data?.root_order?.id
          || event.data?.order?.id 
          || event.order?.id;
        
        if (orderId) {
          if (!orderIdMap.has(orderId)) {
            orderIdMap.set(orderId, []);
          }
          orderIdMap.get(orderId)!.push(event);
        }
      });
    });

    if (orderIdMap.size === 0) {
      console.log('checkDocumentsForEvents: Keine Order-IDs gefunden');
      return; // Keine Order-IDs gefunden
    }

    console.log('checkDocumentsForEvents: Prüfe Dokumente für', orderIdMap.size, 'Order-IDs');

    // Für jede Order-ID: Dokumente laden und Anzahl (Dokumente/Bilder) an Events setzen
    orderIdMap.forEach((events, orderId) => {
      this.documentService.getAllModuleDocuments(20, orderId, 'all').subscribe({
        next: (documents: any) => {
          let documentsCount = 0;
          let imagesCount = 0;
          const imageExtensions = ['jpg', 'jpeg', 'png', 'gif', 'bmp', 'webp', 'svg'];
          if (documents && Array.isArray(documents)) {
            documents.forEach((doc: any) => {
              if (doc.is_folder === false || doc.is_folder === 0) {
                documentsCount++;
                const name = doc.origin_name || doc.name || doc.path || '';
                const ext = name.split('.').pop()?.toLowerCase() || '';
                if (imageExtensions.includes(ext)) imagesCount++;
              }
            });
          }
          events.forEach((event) => {
            event.hasDocuments = documentsCount > 0;
            if (event.documents_count == null) event.documents_count = documentsCount;
            if (event.images_count == null) event.images_count = imagesCount;
          });
        },
        error: (err) => {
          console.error('Fehler beim Prüfen der Dokumente für Order-ID', orderId, err);
          events.forEach((event) => {
            event.hasDocuments = false;
            if (event.documents_count == null) event.documents_count = 0;
            if (event.images_count == null) event.images_count = 0;
          });
        }
      });
    });
  }

  /** Anzahl Dokumente für Event (aus Backend oder event.data/event.order). */
  getEventDocumentsCount(event: any): number {
    const n = event?.documents_count ?? event?.data?.documents_count ?? event?.order?.documents_count;
    return typeof n === 'number' && n >= 0 ? n : 0;
  }

  /** Anzahl Bilder für Event (aus Backend oder event.data/event.order). */
  getEventImagesCount(event: any): number {
    const n = event?.images_count ?? event?.data?.images_count ?? event?.order?.images_count;
    return typeof n === 'number' && n >= 0 ? n : 0;
  }

  getEventTooltip(event: any): string {
    const number = this.getEventOrderNumber(event);
    const firstName = this.getEventCustomerFirstName(event);
    const lastName = this.getEventCustomerLastName(event);
    const street = this.getEventStreet(event);
    const postalCode = this.getEventPostalCode(event);
    const place = this.getEventPlace(event);

    const parts: string[] = [];

    if (number) {
      parts.push(`#${number}`);
    }

    const name = `${firstName} ${lastName}`.trim();
    if (name) {
      parts.push(name);
    }

    const address = `${street}, ${postalCode} ${place}`.trim();
    if (street || postalCode || place) {
      parts.push(address);
    }

    const docCount = this.getEventDocumentsCount(event);
    const imgCount = this.getEventImagesCount(event);
    if (docCount > 0 || imgCount > 0) {
      parts.push(`${docCount} Dok., ${imgCount} Bild(er)`);
    }

    return parts.join(' – ');
  }

  /** Termin-Bestätigung/Absage: Anzeige für Tooltip und Badge. */
  getEventConfirmationStatus(event: any): { label: string; dateFormatted: string } | null {
    const confirmedAt = event?.confirmed_at ?? event?.data?.confirmed_at;
    const declinedAt = event?.declined_at ?? event?.data?.declined_at;
    const hasAppointmentRequest = event?.hasAppointmentRequest || event?.data?.hasAppointmentRequest;
    if (confirmedAt) {
      const d = moment(confirmedAt);
      return { label: 'Bestätigt', dateFormatted: d.isValid() ? d.format('DD.MM.YYYY HH:mm') : '' };
    }
    if (declinedAt) {
      const d = moment(declinedAt);
      return { label: 'nicht bestätigt', dateFormatted: d.isValid() ? d.format('DD.MM.YYYY HH:mm') : '' };
    }
    if (hasAppointmentRequest) {
      return { label: 'Wartend', dateFormatted: '' };
    }
    return null;
  }

  /** E-Mail: Navigation zur Mail-Seite des Auftrags (wie im Calendar). */
  openMail(orderId: number, email: string | null): void {
    if (!orderId || !email) return;
    this.router.navigate(['order', orderId, 'order-scheduler', orderId, 'mail'], { relativeTo: this.route.root });
  }

  /** Anruf ausführen (Toast + Kommentar + tel:-Link), wie im Calendar. */
  call(number: string): void {
    if (!number) return;
    this.toastr.success('Telefonnummer ' + number + ' wird angerufen.');
    const orderId = this.orderData?.id ?? this.orderData?.root_order?.id;
    if (orderId) {
      this.actionService.addComment(orderId, 'Anruf', 'Anruf TelNr.: ' + number).subscribe({
        next: () => { window.location.href = 'tel:' + number; },
        error: () => { window.location.href = 'tel:' + number; }
      });
    } else {
      window.location.href = 'tel:' + number;
    }
  }

  /** Bestätigungsdialog vor Anruf (wie im Calendar). */
  confirmCall(number: string, firstName: string, lastName: string): void {
    const name = [firstName, lastName].filter(Boolean).join(' ') || 'Kunde';
    Swal.fire({
      title: 'Anrufen',
      text: 'Möchten Sie ' + name + ' anrufen?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ja',
      cancelButtonText: 'Nein'
    }).then((result) => {
      if (result.isConfirmed) this.call(number);
    });
  }

  onAppointmentClick(appointment: any): void {
    this.highlightedAppointment = appointment;
    
    // Springe zur Woche des Termins
    if (this.viewMode === 'week') {
      this.weekStart = appointment.start.clone().startOf('isoWeek');
    } else {
      this.currentDate = appointment.start.clone();
    }
    
    this.generateCalendar();
    this.loadEvents();
    
    // Scroll zum Termin nach kurzer Verzögerung (damit der Kalender gerendert ist)
    setTimeout(() => {
      this.scrollToAppointment(appointment);
    }, 100);
  }

  scrollToAppointment(appointment: any): void {
    // Finde das entsprechende Kalender-Element
    const appointmentDate = appointment.start.format('YYYY-MM-DD');
    const teamId = appointment.teamBase?.id || appointment.resource?.substring(1);
    
    // Suche nach dem Element mit data-Attributen
    const element = document.querySelector(
      `[data-appointment-date="${appointmentDate}"][data-team-id="${teamId}"]`
    ) as HTMLElement;
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Füge eine temporäre Highlight-Klasse hinzu
      element.classList.add('appointment-highlight');
      setTimeout(() => {
        element.classList.remove('appointment-highlight');
      }, 2000);
    }
  }

  isAppointmentHighlighted(teamId: number, day: any): boolean {
    // Wenn Termin-Tab aktiv ist und selectedEventData vorhanden, prüfe auch gegen selectedEventData
    if (this.calendarMode === 'appointment' && this.selectedEventData && this.selectedEventData.event) {
      const selectedEvent = this.selectedEventData.event;
      const selectedEventDate = selectedEvent.date?.format('YYYY-MM-DD') || selectedEvent.start?.format('YYYY-MM-DD');
      const dayDate = day.date.format('YYYY-MM-DD');
      const selectedEventTeamId = selectedEvent.teamId || (this.selectedEventData.team?.id);
      
      if (selectedEventDate === dayDate && selectedEventTeamId == teamId) {
        return true;
      }
    }
    
    if (!this.highlightedAppointment) return false;
    
    const appointmentDate = this.highlightedAppointment.start.format('YYYY-MM-DD');
    const dayDate = day.date.format('YYYY-MM-DD');
    const appointmentTeamId = this.highlightedAppointment.teamBase?.id || 
                              this.highlightedAppointment.resource?.substring(1);
    
    return appointmentDate === dayDate && appointmentTeamId == teamId;
  }

  isEventHighlighted(event: any, teamId: number, day: any): boolean {
    // Wenn Termin-Tab aktiv ist und selectedEventData vorhanden, prüfe auch gegen selectedEventData
    if (this.calendarMode === 'appointment' && this.selectedEventData && this.selectedEventData.event) {
      const selectedEvent = this.selectedEventData.event;
      const selectedEventDate = selectedEvent.date?.format('YYYY-MM-DD') || selectedEvent.start?.format('YYYY-MM-DD');
      const dayDate = day.date.format('YYYY-MM-DD');
      const selectedEventTeamId = selectedEvent.teamId || (this.selectedEventData.team?.id);
      const selectedEventId = selectedEvent.id;
      
      if (selectedEventDate === dayDate && selectedEventTeamId == teamId && selectedEventId === event.id) {
        return true;
      }
    }
    
    if (!this.highlightedAppointment) return false;
    
    const appointmentDate = this.highlightedAppointment.start.format('YYYY-MM-DD');
    const dayDate = day.date.format('YYYY-MM-DD');
    const appointmentTeamId = this.highlightedAppointment.teamBase?.id || 
                              this.highlightedAppointment.resource?.substring(1);
    const appointmentId = this.highlightedAppointment.id;
    
    // Prüfe ob Datum, Team und Event-ID übereinstimmen
    return appointmentDate === dayDate && 
           appointmentTeamId == teamId && 
           event.id === appointmentId;
  }

  onEventClick(event: any, team: any, day: any, eventClick: Event): void {
    eventClick.stopPropagation(); // Verhindere, dass der Tag auch geklickt wird
    
    // Prüfe ob der Termin zum aktuellen Auftrag gehört
    const belongsToCurrentOrder = event.orderId === this.orderData?.id || 
                                  event.rootOrderId === this.orderData?.root_order?.id ||
                                  event.data?.id === this.orderData?.id;
    
    // Finde den entsprechenden Termin in existingAppointments
    const matchingAppointment = this.existingAppointments.find(apt => apt.id === event.id);
    
    if (matchingAppointment) {
      this.onAppointmentClick(matchingAppointment);
      
      // Scroll zum Termin in der linken Liste
      if (belongsToCurrentOrder) {
        // Termin gehört zum aktuellen Auftrag - selectedEventData zurücksetzen
        this.selectedEventData = null;
        // Wechsle zurück zu Aufträge-Tab, falls im Team- oder Termin-Tab
        if (this.calendarMode === 'staff' || this.calendarMode === 'appointment') {
          this.setCalendarMode('orders');
        }
        setTimeout(() => {
          this.scrollToAppointmentInList(matchingAppointment.id);
        }, 100);
      }
    } else {
      // Falls nicht in existingAppointments
      if (!belongsToCurrentOrder && event.orderId) {
        // Termin gehört nicht zum aktuellen Auftrag - Lade die Daten des Termins
        this.loadEventOrderData(event);
        // Setze highlightedAppointment für visuelle Hervorhebung
        this.highlightedAppointment = {
          id: event.id,
          teamOrderType: event.teamOrderType,
          teamBase: team,
          start: event.date || day.date,
          end: event.end ? moment(event.end) : day.date.clone().add(1, 'hour'),
          resource: 'O' + team.id
        };
        // Wechsle zum Termin-Tab ohne komplettes Reload
        if (this.calendarMode !== 'appointment') {
          this.calendarMode = 'appointment';
        }
        // Markiere den Tag und das Event
        this.generateCalendar();
        // Scroll zum Event im Kalender
        setTimeout(() => {
          this.scrollToAppointment(this.highlightedAppointment);
        }, 100);
      } else {
        // Termin gehört zum aktuellen Auftrag oder hat keine orderId
        if (belongsToCurrentOrder) {
          // Termin gehört zum aktuellen Auftrag - wechsle zurück zu Aufträge-Tab
          this.selectedEventData = null;
          if (this.calendarMode === 'staff' || this.calendarMode === 'appointment') {
            this.setCalendarMode('orders');
          }
        }
        // Erstelle ein temporäres Appointment-Objekt
        this.highlightedAppointment = {
          id: event.id,
          teamOrderType: event.teamOrderType,
          teamBase: team,
          start: event.date || day.date,
          end: event.end ? moment(event.end) : day.date.clone().add(1, 'hour'),
          resource: 'O' + team.id
        };
        
        // Markiere den Tag und das Event
        this.generateCalendar();
        
        // Scroll zum Event im Kalender
        setTimeout(() => {
          this.scrollToAppointment(this.highlightedAppointment);
        }, 100);
      }
    }
  }

  loadEventOrderData(event: any): void {
    // Setze Loading-State für linke Seite (nur wenn im Termin-Modus)
    if (this.calendarMode === 'appointment') {
      this.isLoadingEventData = true;
    }
    
    const orderId = event.orderId || event.data?.id || event.rootOrderId;
    if (!orderId) {
      // Falls keine Order-ID vorhanden, verwende die Event-Daten direkt
      this.selectedEventData = {
        event: event,
        order: event.data || event.order || null,
        teamOrderType: event.teamOrderType,
        team: event.teamId ? this.teams.find(t => t.id === event.teamId) : null
      };
      // Versuche Dokumente und Notizen zu laden, falls Order-ID in den Event-Daten vorhanden ist
      if (event.data?.id) {
        this.loadEventDocuments(event.data.id);
        this.loadEventNotes(event.data.id);
      } else if (event.orderId) {
        this.loadEventDocuments(event.orderId);
        this.loadEventNotes(event.orderId);
      } else {
        // Keine Order-ID gefunden, beende Loading-State sofort
        if (this.calendarMode === 'appointment') {
          this.isLoadingEventData = false;
        }
      }
      return;
    }

    // Lade die Auftragsdaten
    this.orderService.show(orderId).subscribe(
      (orderData: any) => {
        const order = orderData.data || orderData || null;
        this.selectedEventData = {
          event: event,
          order: order,
          teamOrderType: event.teamOrderType,
          team: event.teamId ? this.teams.find(t => t.id === event.teamId) : null
        };
        
        // Lade Dokumente und Notizen für den Auftrag
        if (order && order.id) {
          this.loadEventDocuments(order.id);
          this.loadEventNotes(order.id);
        } else {
          // Keine Order-ID gefunden, beende Loading-State sofort
          if (this.calendarMode === 'appointment') {
            this.isLoadingEventData = false;
          }
        }
      },
      (err) => {
        console.error('Fehler beim Laden der Auftragsdaten', err);
        // Fallback: Verwende die Event-Daten direkt
        const order = event.data || event.order || null;
        this.selectedEventData = {
          event: event,
          order: order,
          teamOrderType: event.teamOrderType,
          team: event.teamId ? this.teams.find(t => t.id === event.teamId) : null
        };
        // Versuche Dokumente und Notizen zu laden, falls Order-ID in den Event-Daten vorhanden ist
        if (order && order.id) {
          this.loadEventDocuments(order.id);
          this.loadEventNotes(order.id);
        } else if (event.data?.id) {
          this.loadEventDocuments(event.data.id);
          this.loadEventNotes(event.data.id);
        } else if (event.orderId) {
          this.loadEventDocuments(event.orderId);
          this.loadEventNotes(event.orderId);
        } else {
          // Keine Order-ID gefunden, beende Loading-State sofort
          if (this.calendarMode === 'appointment') {
            this.isLoadingEventData = false;
          }
        }
      }
    );
  }

  loadEventDocuments(orderId: number): void {
    this.isLoadingEventDocuments = true;
    this.documentService.getAllModuleDocuments(20, orderId, 'all').subscribe(
      (documents: any) => {
        this.selectedEventDocuments = documents.data || documents || [];
        this.isLoadingEventDocuments = false;
        // Beende Loading-State für linke Seite, wenn alle Daten geladen sind
        if (this.calendarMode === 'appointment' && !this.isLoadingEventNotes) {
          this.isLoadingEventData = false;
        }
      },
      (err) => {
        console.error('Fehler beim Laden der Dokumente', err);
        this.selectedEventDocuments = [];
        this.isLoadingEventDocuments = false;
        // Beende Loading-State für linke Seite, wenn alle Daten geladen sind
        if (this.calendarMode === 'appointment' && !this.isLoadingEventNotes) {
          this.isLoadingEventData = false;
        }
      }
    );
  }

  loadEventNotes(orderId: number): void {
    this.isLoadingEventNotes = true;
    this.http.get(environment.prismaApiUrl + `/api/dispo/notes/get_module_notes/1/${orderId}`).subscribe(
      (notes: any) => {
        this.selectedEventNotes = notes.data || notes || [];
        this.isLoadingEventNotes = false;
        // Beende Loading-State für linke Seite, wenn alle Daten geladen sind
        if (this.calendarMode === 'appointment' && !this.isLoadingEventDocuments) {
          this.isLoadingEventData = false;
        }
      },
      (err) => {
        console.error('Fehler beim Laden der Notizen', err);
        this.selectedEventNotes = [];
        this.isLoadingEventNotes = false;
        // Beende Loading-State für linke Seite, wenn alle Daten geladen sind
        if (this.calendarMode === 'appointment' && !this.isLoadingEventDocuments) {
          this.isLoadingEventData = false;
        }
      }
    );
  }

  openDocument(doc: any): void {
    this.documentService.showDocument(doc).subscribe(
      (blob: Blob) => {
        const fileType = doc.mime_type || doc.type || 'application/pdf';
        const file = new Blob([blob], { type: fileType });
        const fileURL = URL.createObjectURL(file);
        window.open(fileURL, '_blank');
      },
      (err) => {
        console.error('Fehler beim Öffnen des Dokuments', err);
        this.toastr.error('Dokument konnte nicht geöffnet werden', 'Fehler');
      }
    );
  }

  scrollToAppointmentInList(appointmentId: number): void {
    // Finde das Element in der Liste der bestehenden Termine
    const element = document.querySelector(`[data-appointment-id="${appointmentId}"]`) as HTMLElement;
    
    if (element) {
      element.scrollIntoView({ behavior: 'smooth', block: 'center' });
      // Füge eine temporäre Highlight-Klasse hinzu
      element.classList.add('appointment-list-highlight');
      setTimeout(() => {
        element.classList.remove('appointment-list-highlight');
      }, 2000);
    }
  }

  onEventRightClick(event: any, team: any, day: any, mouseEvent: MouseEvent): void {
    mouseEvent.preventDefault();
    mouseEvent.stopPropagation();
    
    this.contextMenuEvent = {
      event: event,
      team: team,
      day: day
    };
    
    // Im Teammode: Anderes Menü für Personal/Fahrzeug-Events
    if (this.calendarMode === 'staff' && (event.dispoType === 0 || event.dispoType === 1)) {
      this.contextMenuType = 'staff-event';
    } else {
      this.contextMenuType = 'event';
    }
    
    this.contextMenuPosition = {
      x: mouseEvent.clientX,
      y: mouseEvent.clientY
    };
    
    this.showContextMenu = true;
  }

  closeContextMenu(): void {
    this.showContextMenu = false;
    this.contextMenuEvent = null;
    this.contextMenuType = null;
    this.contextMenuDay = null;
    this.contextMenuTeam = null;
    this.contextMenuWeekday = null;
    this.contextMenuTeamColumn = null;
    this.dayMapMenuOpenForEventId = null;
  }

  getDayMapEventMenuId(ev: any): number | string {
    if (ev?.isBranchStart && this.dayMapBranchStart?.id != null) {
      return 'branch-' + this.dayMapBranchStart.id;
    }
    return ev?.id ?? ev?.data?.id ?? this.getDayMapOrderId(ev) ?? '';
  }

  toggleDayMapEventMenu(ev: any, $event: Event): void {
    $event.preventDefault();
    $event.stopPropagation();
    const id = this.getDayMapEventMenuId(ev);
    this.dayMapMenuOpenForEventId = this.dayMapMenuOpenForEventId === id ? null : id;
    this.cdr.detectChanges();
  }

  closeDayMapEventMenu(): void {
    this.dayMapMenuOpenForEventId = null;
    this.cdr.detectChanges();
  }

  /** Koordinaten per API ermitteln lassen (Backend übernimmt Geocoding und Speichern). Auftrag oder Filiale. */
  requestGeocodeCoords(ev: any): void {
    this.closeDayMapEventMenu();
    const eventId = this.getDayMapEventMenuId(ev);
    this.dayMapGeocodeEventId = eventId;
    this.cdr.detectChanges();

    if (ev?.isBranchStart && this.dayMapBranchStart?.id != null) {
      this.customerBranchService.geocodeBranchCoords(this.dayMapBranchStart.id).subscribe({
        next: (res: any) => {
          this.dayMapGeocodeEventId = null;
          const lat = res?.lat ?? res?.data?.lat;
          const lng = res?.lng ?? res?.data?.lng;
          if (lat != null && lng != null && this.dayMapBranchStart) {
            this.dayMapBranchStart = { ...this.dayMapBranchStart, lat, lng };
            this.dayMapCachedCoords = this.computeDayMapCoords(this.dayMapDisplayEvents);
          }
          this.toastr.success('Koordinaten wurden ermittelt und gespeichert.');
          this.cdr.detectChanges();
        },
        error: (err) => {
          this.dayMapGeocodeEventId = null;
          this.toastr.error(err?.error?.message || 'Koordinaten konnten nicht ermittelt werden.');
          this.cdr.detectChanges();
        }
      });
      return;
    }

    const orderId = this.getDayMapOrderId(ev);
    if (orderId == null) {
      this.dayMapGeocodeEventId = null;
      this.toastr.warning('Kein Auftrag zugeordnet.');
      this.cdr.detectChanges();
      return;
    }
    this.orderService.geocodeOrderCoords(orderId).subscribe({
      next: (res: any) => {
        this.dayMapGeocodeEventId = null;
        const lat = res?.lat ?? res?.data?.lat;
        const lng = res?.lng ?? res?.data?.lng;
        if (lat != null && lng != null) {
          const d = ev?.data || ev?.order || {};
          const root = d?.root_order || d?.rootOrder || {};
          if (!(d as any).root_order) (d as any).root_order = root || {};
          const r = (d as any).root_order;
          if (!r.person) (r as any).person = {};
          (r as any).person.lat = lat;
          (r as any).person.lng = lng;
          (d as any).lat = lat;
          (d as any).lng = lng;
          this.dayMapCachedCoords = this.computeDayMapCoords(this.dayMapDisplayEvents);
        }
        this.toastr.success('Koordinaten wurden ermittelt und gespeichert.');
        this.cdr.detectChanges();
      },
      error: (err) => {
        this.dayMapGeocodeEventId = null;
        this.toastr.error(err?.error?.message || 'Koordinaten konnten nicht ermittelt werden.');
        this.cdr.detectChanges();
      }
    });
  }

  openStatusChangeModal(): void {
    if (!this.contextMenuEvent) return;
    const event = this.contextMenuEvent.event;
    // Order-ID für Status-Update: order_id (team_order), orderId, order.id oder data.id – NICHT root_order.id
    const rawId = event.order_id ?? event.orderId ?? event.order?.id ?? event.data?.id ?? event.data?.order?.id;
    const orderId = rawId != null ? Math.floor(Number(rawId)) : null;
    if (!orderId || isNaN(orderId) || orderId < 1) {
      this.toastr.warning('Keine gültige Auftrags-ID zum Termin gefunden', 'Hinweis');
      this.closeContextMenu();
      return;
    }
    const orderData = event.data || event.order || event;
    const currentStatusId = orderData.status_id ?? orderData.status?.id ?? null;
    const currentStatusLabel = orderData.status?.label || orderData.status?.name || '–';
    const orderNumber = this.getEventOrderNumbers(event).first || orderData.order_number || orderData.root_order?.order_number || '';
    this.statusChangeModalData = {
      orderId,
      orderNumber,
      currentStatusId,
      currentStatusLabel,
      event
    };
    this.closeContextMenu();
    this.showStatusChangeModal = true;
  }

  closeStatusChangeModal(): void {
    this.showStatusChangeModal = false;
    this.statusChangeModalData = null;
  }

  changeOrderStatusFromModal(newStatusId: number): void {
    if (!this.statusChangeModalData) return;
    const { orderId, event } = this.statusChangeModalData;
    const numericOrderId = Math.floor(Number(orderId));
    if (isNaN(numericOrderId) || numericOrderId < 1) {
      this.toastr.error('Ungültige Auftrags-ID', 'Fehler');
      return;
    }
    const newStatus = this.statusList.find(s => s.id === newStatusId);
    const newStatusLabel = newStatus?.label || String(newStatusId);
    this.orderService.updateStatus(numericOrderId, newStatusId).subscribe({
      next: () => {
        this.toastr.success(`Status erfolgreich zu "${newStatusLabel}" geändert`, 'Status aktualisiert');
        if (event) {
          event.status_id = newStatusId;
          event.data = event.data || {};
          event.data.status_id = newStatusId;
          event.data.status = newStatus || { id: newStatusId, label: newStatusLabel, color: newStatus?.color };
          if (event.order) {
            event.order.status_id = newStatusId;
            event.order.status = newStatus;
          }
        }
        this.loadEvents();
        this.closeStatusChangeModal();
      },
      error: (err) => {
        const msg = err?.error?.error || err?.error?.message || err?.message || 'Unbekannter Fehler';
        const details = err?.error?.details ? ' ' + JSON.stringify(err.error.details) : '';
        console.error('Fehler beim Status-Update:', err);
        this.toastr.error(msg + details, 'Fehler beim Ändern des Status');
        this.closeStatusChangeModal();
      }
    });
  }

  onWeekdayHeaderRightClick(day: any, mouseEvent: MouseEvent): void {
    mouseEvent.preventDefault();
    mouseEvent.stopPropagation();
    
    this.contextMenuWeekday = day;
    this.contextMenuType = 'weekday';
    
    this.contextMenuPosition = {
      x: mouseEvent.clientX,
      y: mouseEvent.clientY
    };
    
    this.showContextMenu = true;
  }

  generateDayPdf(): void {
    if (!this.contextMenuWeekday) {
      this.closeContextMenu();
      return;
    }
    
    const selectedDate = this.contextMenuWeekday.date.format('YYYY-MM-DD');
    const dateLabel = this.contextMenuWeekday.date.format('DD.MM.YYYY');
    
    // Zeige Ladeanzeige
    this.toastr.info('PDF wird erstellt...', 'Info');
    
    // Rufe Backend-API auf, um PDF zu erstellen
    // Backend-Route heißt bereits gen-team-scheduler-pdf-by-date, daher diese verwenden
    this.http.get(environment.prismaApiUrl + '/api/dispo/team_orders/gen-team-scheduler-pdf-by-date/' + selectedDate, {
      responseType: 'blob'
    }).subscribe(
      (blob: Blob) => {
        // Erstelle Download-Link
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement('a');
        link.href = url;
        link.download = `Tagesplan_${selectedDate}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
        
        this.toastr.success(`PDF für ${dateLabel} wurde erstellt`, 'Erfolg');
        this.closeContextMenu();
      },
      err => {
        console.error('Fehler beim Erstellen des PDFs', err);
        this.toastr.error('Fehler beim Erstellen des PDFs', 'Fehler');
        this.closeContextMenu();
      }
    );
  }

  onDayRightClick(day: any, team: any, mouseEvent: MouseEvent): void {
    mouseEvent.preventDefault();
    mouseEvent.stopPropagation();
    
    this.contextMenuDay = day;
    this.contextMenuTeam = team;
    
    // Wenn Tag blockiert ist, öffne direkt das Blockierungs-Modal
    const key = `${team.id}_${day.date.format('YYYY-MM-DD')}`;
    if (this.isTeamBlocked(team.id, day)) {
      this.openBlockDayModal();
      return;
    }
    
    this.contextMenuType = this.calendarMode === 'staff' ? 'staff-day' : 'day';
    
    this.contextMenuPosition = {
      x: mouseEvent.clientX,
      y: mouseEvent.clientY
    };
    
    this.showContextMenu = true;
  }

  expandStaffAssignmentsToWeek(): void {
    if (this.calendarMode !== 'staff' || !this.contextMenuDay || !this.contextMenuTeam) {
      return;
    }

    const assignments = this.getStaffAssignmentsForDay(this.contextMenuTeam.id, this.contextMenuDay);
    if (assignments.length === 0) {
      this.toastr.info('Keine Belegung zum Übertragen vorhanden', 'Info');
      this.closeContextMenu();
      return;
    }

    const startOfWeek = this.contextMenuDay.date.clone().startOf('isoWeek');
    const requests: any[] = [];

    for (let i = 0; i < 7; i++) {
      const targetDate = startOfWeek.clone().add(i, 'days');
      if (targetDate.isSame(this.contextMenuDay.date, 'day')) {
        continue;
      }

      assignments.forEach(assignment => {
        if (!this.staffAssignmentExists(this.contextMenuTeam.id, targetDate, assignment)) {
          requests.push(this.createStaffEventClone(assignment, this.contextMenuTeam, targetDate));
        }
      });
    }

    if (requests.length === 0) {
      this.toastr.info('Belegung ist bereits für alle Tage vorhanden', 'Info');
      this.closeContextMenu();
      return;
    }

    forkJoin(requests).subscribe(
      () => {
        this.toastr.success('Belegung wurde auf die Woche übertragen', 'Erfolg');
        this.loadEvents();
        this.closeContextMenu();
      },
      err => {
        console.error('Fehler beim Übertragen der Belegung', err);
        this.toastr.error('Fehler beim Übertragen der Belegung', 'Fehler');
        this.closeContextMenu();
      }
    );
  }

  copyStaffAssignments(): void {
    if (this.calendarMode !== 'staff' || !this.contextMenuDay || !this.contextMenuTeam) {
      return;
    }

    const assignments = this.getStaffAssignmentsForDay(this.contextMenuTeam.id, this.contextMenuDay);
    if (assignments.length === 0) {
      this.toastr.info('Keine Belegung zum Kopieren', 'Info');
      this.closeContextMenu();
      return;
    }

    this.copiedStaffAssignments = assignments.map(assignment => ({ ...assignment }));
    this.copiedStaffSource = {
      teamId: this.contextMenuTeam.id,
      date: this.contextMenuDay.date.clone()
    };

    this.toastr.success('Belegung kopiert', 'Erfolg');
    this.closeContextMenu();
  }

  pasteStaffAssignments(): void {
    if (this.calendarMode !== 'staff' || !this.contextMenuDay || !this.contextMenuTeam) {
      return;
    }

    if (!this.copiedStaffAssignments || this.copiedStaffAssignments.length === 0) {
      this.toastr.warning('Keine kopierte Belegung vorhanden', 'Hinweis');
      this.closeContextMenu();
      return;
    }

    const targetDate = this.contextMenuDay.date.clone();
    const requests: any[] = [];

    this.copiedStaffAssignments.forEach(assignment => {
      if (!this.staffAssignmentExists(this.contextMenuTeam.id, targetDate, assignment)) {
        requests.push(this.createStaffEventClone(assignment, this.contextMenuTeam, targetDate));
      }
    });

    if (requests.length === 0) {
      this.toastr.info('Belegung bereits vorhanden', 'Info');
      this.closeContextMenu();
      return;
    }

    forkJoin(requests).subscribe(
      () => {
        this.toastr.success('Belegung eingefügt', 'Erfolg');
        this.loadEvents();
        this.closeContextMenu();
      },
      err => {
        console.error('Fehler beim Einfügen der Belegung', err);
        this.toastr.error('Fehler beim Einfügen der Belegung', 'Fehler');
        this.closeContextMenu();
      }
    );
  }

  canPasteStaffAssignments(): boolean {
    return !!(this.copiedStaffAssignments && this.copiedStaffAssignments.length > 0);
  }

  deleteStaffEvent(): void {
    if (!this.contextMenuEvent) return;
    
    const event = this.contextMenuEvent.event;
    const eventId = event.id;
    
    console.log('Lösche Event:', {
      id: eventId,
      dispoType: event.dispoType,
      moduleItemId: event.moduleItemId || event.module_item_id,
      title: event.title,
      start: event.start,
      teamId: event.teamId
    });
    
    if (!eventId) {
      this.toastr.error('Event-ID nicht gefunden', 'Fehler');
      this.closeContextMenu();
      return;
    }
    
    // Bestimme ob es Personal oder Fahrzeug ist
    const isEmployee = event.dispoType === 0 || event.dispoType === '0';
    
    // Hole den Namen des Personals/Fahrzeugs
    let itemName = 'Unbekannt';
    if (isEmployee) {
      if (event.employee) {
        itemName = `${event.employee.first_name || ''} ${event.employee.last_name || ''}`.trim();
      } else if (event.title) {
        itemName = event.title;
      } else if (event.moduleItemId) {
        // Suche in der employees-Liste
        const employee = this.employees.find((emp: any) => emp.id === event.moduleItemId);
        if (employee) {
          itemName = `${employee.first_name || ''} ${employee.last_name || ''}`.trim();
        }
      }
    } else {
      if (event.vehicle) {
        itemName = event.vehicle.label || event.vehicle.license_plate || 'Fahrzeug';
      } else if (event.title) {
        itemName = event.title;
      } else if (event.moduleItemId) {
        // Suche in der vehicles-Liste
        const vehicle = this.vehicles.find((veh: any) => veh.id === event.moduleItemId);
        if (vehicle) {
          itemName = vehicle.label || vehicle.license_plate || 'Fahrzeug';
        }
      }
    }
    
    Swal.fire({
      title: isEmployee ? 'Person löschen?' : 'Fahrzeug löschen?',
      html: `<p>Möchten Sie <strong>${itemName}</strong> wirklich löschen?</p><p>Nur dieses einzelne Personal/Fahrzeug wird gelöscht, nicht die gesamte Belegung.</p>`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ja, löschen',
      cancelButtonText: 'Abbrechen'
    }).then((result) => {
      if (result.isConfirmed) {
        console.log('Lösche Event mit ID:', eventId);
        this.deleteTeamEvent(eventId).subscribe(
          (response: any) => {
            console.log('Event erfolgreich gelöscht:', response);
            this.toastr.success(isEmployee ? 'Person wurde gelöscht' : 'Fahrzeug wurde gelöscht', 'Erfolg');
            
            // Entferne Event sofort aus teamStaffEvents
            this.teamStaffEvents.forEach((events, teamId) => {
              const index = events.findIndex((e: any) => e.id === eventId);
              if (index !== -1) {
                events.splice(index, 1);
                this.teamStaffEvents.set(teamId, events);
              }
            });
            
            // Entferne auch aus doubleBookedEvents falls vorhanden
            this.doubleBookedEvents.delete(eventId);
            
            // Prüfe Doppelbelegungen sofort nach dem Löschen
            this.checkAllDoubleBookings();
            
            // Lade Events neu, um die Anzeige zu aktualisieren
            this.loadEvents();
            this.closeContextMenu();
          },
          err => {
            console.error('Fehler beim Löschen', err);
            this.toastr.error(err.error?.message || 'Fehler beim Löschen', 'Fehler');
            this.closeContextMenu();
          }
        );
      } else {
        this.closeContextMenu();
      }
    });
  }

  deleteStaffAssignments(): void {
    if (this.calendarMode !== 'staff' || !this.contextMenuDay || !this.contextMenuTeam) {
      return;
    }

    const assignments = this.getStaffAssignmentsForDay(this.contextMenuTeam.id, this.contextMenuDay);
    if (assignments.length === 0) {
      this.toastr.info('Keine Belegung zum Löschen vorhanden', 'Info');
      this.closeContextMenu();
      return;
    }

    const dateLabel = this.contextMenuDay.date.format('DD.MM.YYYY');
    const teamName = this.contextMenuTeam.label || this.contextMenuTeam.name || 'Team ' + this.contextMenuTeam.id;

    Swal.fire({
      title: 'Belegung löschen?',
      text: `Sollen alle Belegungen für ${teamName} am ${dateLabel} entfernt werden?`,
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ja, löschen',
      cancelButtonText: 'Abbrechen'
    }).then(result => {
      if (!result.isConfirmed) {
        this.closeContextMenu();
        return;
      }

      const deleteRequests = assignments
        .filter(assignment => assignment.id)
        .map(assignment => this.deleteTeamEvent(assignment.id));

      if (deleteRequests.length === 0) {
        this.toastr.info('Keine löschbaren Belegungen gefunden', 'Info');
        this.closeContextMenu();
        return;
      }

      // Verwende forkJoin mit Fehlerbehandlung für jedes Observable
      forkJoin(deleteRequests.map(req => req.pipe(
        catchError((error: any) => {
          // Behandle Fehler für einzelne Löschungen, damit forkJoin nicht komplett fehlschlägt
          console.warn('Fehler beim Löschen eines einzelnen Events:', error);
          // Gebe ein Erfolgsobjekt zurück, damit forkJoin weiterläuft
          return of({ success: false, error: error });
        })
      ))).subscribe(
        (results: any[]) => {
          // Prüfe ob alle erfolgreich waren
          const allSuccessful = results.every((r: any) => r.success !== false);
          const someFailed = results.some((r: any) => r.success === false);
          
          if (allSuccessful) {
            this.toastr.success('Belegung wurde gelöscht', 'Erfolg');
          } else if (someFailed) {
            this.toastr.warning('Belegung wurde teilweise gelöscht', 'Warnung');
          }
          
          // Entferne alle gelöschten Events sofort aus teamStaffEvents
          assignments.forEach(assignment => {
            if (assignment.id) {
              this.teamStaffEvents.forEach((events, teamId) => {
                const index = events.findIndex((e: any) => e.id === assignment.id);
                if (index !== -1) {
                  events.splice(index, 1);
                  this.teamStaffEvents.set(teamId, events);
                }
              });
              this.doubleBookedEvents.delete(assignment.id);
            }
          });
          
          // Prüfe Doppelbelegungen sofort nach dem Löschen
          this.checkAllDoubleBookings();
          
          // Lade Events neu, um die Anzeige zu aktualisieren
          this.loadEvents();
          this.closeContextMenu();
        },
        err => {
          // Fallback für unerwartete Fehler
          console.error('Unerwarteter Fehler beim Löschen der Belegung', err);
          this.toastr.error(err.error?.message || 'Fehler beim Löschen der Belegung', 'Fehler');
          
          // Versuche trotzdem, die gelöschten Events aus teamStaffEvents zu entfernen
          assignments.forEach(assignment => {
            if (assignment.id) {
              this.teamStaffEvents.forEach((events, teamId) => {
                const index = events.findIndex((e: any) => e.id === assignment.id);
                if (index !== -1) {
                  events.splice(index, 1);
                  this.teamStaffEvents.set(teamId, events);
                }
              });
              this.doubleBookedEvents.delete(assignment.id);
            }
          });
          
          // Prüfe Doppelbelegungen sofort
          this.checkAllDoubleBookings();
          
          this.loadEvents();
          this.closeContextMenu();
        }
      );
    });
  }

  editDay(): void {
    if (!this.contextMenuDay || !this.contextMenuTeam) return;
    
    // TODO: Bearbeitungs-Dialog für Tag/Team öffnen
    this.toastr.info('Bearbeitung für Tag/Team wird implementiert', 'Info');
    this.closeContextMenu();
  }

  openBlockDayModal(): void {
    if (!this.contextMenuDay || !this.contextMenuTeam) {
      return;
    }
    
    const key = `${this.contextMenuTeam.id}_${this.contextMenuDay.date.format('YYYY-MM-DD')}`;
    const isBlocked = this.teamBlockedDays.has(key);
    const note = this.teamBlockedNotes.get(key) || '';
    
    // Initialisiere blockDayModalData BEVOR das Modal geöffnet wird
    this.blockDayModalData = {
      isBlocked: isBlocked,
      note: note
    };
    
    // Schließe Kontextmenü, aber behalte contextMenuDay und contextMenuTeam
    this.showContextMenu = false;
    this.contextMenuType = null;
    
    // Öffne Modal mit Change Detection
    setTimeout(() => {
      this.showBlockDayModal = true;
    }, 0);
  }

  closeBlockDayModal(): void {
    this.showBlockDayModal = false;
    this.blockDayModalData = { isBlocked: false, note: '' };
  }

  saveBlockDay(): void {
    if (!this.contextMenuDay || !this.contextMenuTeam) return;
    
    const dateStr = this.contextMenuDay.date.format('DD.MM.YYYY');
    const teamName = this.contextMenuTeam.label || this.contextMenuTeam.name || 'Team ' + this.contextMenuTeam.id;
    const key = `${this.contextMenuTeam.id}_${this.contextMenuDay.date.format('YYYY-MM-DD')}`;
    const startDate = this.contextMenuDay.date.clone().startOf('day');
    const endDate = this.contextMenuDay.date.clone().endOf('day');
    
    if (this.blockDayModalData.isBlocked) {
      // Blockieren oder aktualisieren
      const params = new HttpParams()
        .set('start', startDate.format('YYYY-MM-DD'))
        .set('end', endDate.format('YYYY-MM-DD'))
        .set('team_base_id', this.contextMenuTeam.id.toString());
      
      // Prüfe, ob bereits eine Blockierung existiert
      this.http.get(environment.prismaApiUrl + '/api/dispo/team_absence', { params }).subscribe(
        (data: any) => {
          const absences = data.data || data || [];
          const dayAbsences = absences.filter((absence: any) => {
            const absenceStart = moment(absence.start_date).startOf('day');
            const absenceEnd = moment(absence.end_date).startOf('day');
            const targetDate = this.contextMenuDay.date.clone().startOf('day');
            return targetDate.isSameOrAfter(absenceStart, 'day') && 
                   targetDate.isSameOrBefore(absenceEnd, 'day') &&
                   absence.team_base_id === this.contextMenuTeam.id;
          });
          
          if (dayAbsences.length > 0) {
            // Aktualisiere bestehende Blockierung
            const absence = dayAbsences[0];
            const updatePayload = {
              data: {
                team_base_id: this.contextMenuTeam.id,
                start_date: startDate.format('YYYY-MM-DD 00:00:00'),
                end_date: endDate.format('YYYY-MM-DD 23:59:59'),
                absence_type: 'blocked',
                absence_type_id: 0,
                note: this.blockDayModalData.note || `Kalenderblock ${dateStr}`
              }
            };
            
            this.http.put(environment.prismaApiUrl + `/api/dispo/team_absence/${absence.id}`, updatePayload).subscribe(
              () => {
                this.teamBlockedNotes.set(key, this.blockDayModalData.note);
                this.toastr.success(`Blockierung für ${dateStr} für ${teamName} wurde aktualisiert`, 'Erfolg');
                this.closeBlockDayModal();
                const weekStart = this.weekStart.clone().startOf('isoWeek');
                const weekEnd = this.weekStart.clone().endOf('isoWeek');
                this.loadTeamAbsences(weekStart, weekEnd, () => {
                  this.generateCalendar();
                });
              },
              err => {
                console.error('Fehler beim Aktualisieren der Blockierung', err);
                this.toastr.error(err.error?.error || 'Fehler beim Aktualisieren der Blockierung', 'Fehler');
              }
            );
          } else {
            // Erstelle neue Blockierung
            const payload = {
              data: {
                team_base_id: this.contextMenuTeam.id,
                start_date: startDate.format('YYYY-MM-DD 00:00:00'),
                end_date: endDate.format('YYYY-MM-DD 23:59:59'),
                absence_type: 'blocked',
                absence_type_id: 0,
                note: this.blockDayModalData.note || `Kalenderblock ${dateStr}`
              }
            };
            
            this.http.post(environment.prismaApiUrl + '/api/dispo/team_absence', payload).subscribe(
              () => {
                this.teamBlockedNotes.set(key, this.blockDayModalData.note);
                this.toastr.success(`Tag ${dateStr} für ${teamName} wurde blockiert`, 'Erfolg');
                this.closeBlockDayModal();
                const weekStart = this.weekStart.clone().startOf('isoWeek');
                const weekEnd = this.weekStart.clone().endOf('isoWeek');
                this.loadTeamAbsences(weekStart, weekEnd, () => {
                  this.generateCalendar();
                });
              },
              err => {
                console.error('Fehler beim Blockieren des Tags', err);
                this.toastr.error(err.error?.error || 'Fehler beim Blockieren des Tags', 'Fehler');
              }
            );
          }
        },
        err => {
          console.error('Fehler beim Laden der Absences', err);
          this.toastr.error('Fehler beim Laden der Absences', 'Fehler');
        }
      );
    } else {
      // Blockierung aufheben
      const params = new HttpParams()
        .set('start', startDate.format('YYYY-MM-DD'))
        .set('end', endDate.format('YYYY-MM-DD'))
        .set('team_base_id', this.contextMenuTeam.id.toString());
      
      this.http.get(environment.prismaApiUrl + '/api/dispo/team_absence', { params }).subscribe(
        (data: any) => {
          const absences = data.data || data || [];
          const dayAbsences = absences.filter((absence: any) => {
            const absenceStart = moment(absence.start_date).startOf('day');
            const absenceEnd = moment(absence.end_date).startOf('day');
            const targetDate = this.contextMenuDay.date.clone().startOf('day');
            return targetDate.isSameOrAfter(absenceStart, 'day') && 
                   targetDate.isSameOrBefore(absenceEnd, 'day') &&
                   absence.team_base_id === this.contextMenuTeam.id;
          });
          
          if (dayAbsences.length > 0) {
            const deleteRequests = dayAbsences.map((absence: any) => 
              this.http.delete(environment.prismaApiUrl + `/api/dispo/team_absence/${absence.id}`)
            );
            
            forkJoin(deleteRequests).subscribe(
              () => {
                this.teamBlockedNotes.delete(key);
                this.toastr.success(`Blockierung für ${dateStr} für ${teamName} wurde aufgehoben`, 'Erfolg');
                this.closeBlockDayModal();
                const weekStart = this.weekStart.clone().startOf('isoWeek');
                const weekEnd = this.weekStart.clone().endOf('isoWeek');
                this.loadTeamAbsences(weekStart, weekEnd, () => {
                  this.generateCalendar();
                });
              },
              err => {
                console.error('Fehler beim Aufheben der Blockierung', err);
                this.toastr.error(err.error?.error || 'Fehler beim Aufheben der Blockierung', 'Fehler');
              }
            );
          } else {
            this.teamBlockedNotes.delete(key);
            this.toastr.success(`Blockierung für ${dateStr} für ${teamName} wurde aufgehoben`, 'Erfolg');
            this.closeBlockDayModal();
            const weekStart = this.weekStart.clone().startOf('isoWeek');
            const weekEnd = this.weekStart.clone().endOf('isoWeek');
            this.loadTeamAbsences(weekStart, weekEnd, () => {
              this.generateCalendar();
            });
          }
        },
        err => {
          console.error('Fehler beim Laden der Absences', err);
          this.toastr.error('Fehler beim Laden der Absences', 'Fehler');
        }
      );
    }
  }

  blockDay(): void {
    if (!this.contextMenuDay || !this.contextMenuTeam) return;
    
    const dateStr = this.contextMenuDay.date.format('DD.MM.YYYY');
    const teamName = this.contextMenuTeam.label || this.contextMenuTeam.name || 'Team ' + this.contextMenuTeam.id;
    const key = `${this.contextMenuTeam.id}_${this.contextMenuDay.date.format('YYYY-MM-DD')}`;
    const isBlocked = this.teamBlockedDays.has(key);
    
    if (isBlocked) {
      // Tag ist bereits blockiert - Blockieren aufheben
      Swal.fire({
        title: 'Blockieren aufheben?',
        text: `Möchten Sie die Blockierung für den ${dateStr} für ${teamName} aufheben?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#00a5a8',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ja, Blockierung aufheben',
        cancelButtonText: 'Abbrechen'
      }).then((result) => {
        if (result.isConfirmed) {
          // Lade vorhandene Absences für diesen Tag und lösche sie
          const startDate = this.contextMenuDay.date.clone().startOf('day');
          const endDate = this.contextMenuDay.date.clone().endOf('day');
          const params = new HttpParams()
            .set('start', startDate.format('YYYY-MM-DD'))
            .set('end', endDate.format('YYYY-MM-DD'))
            .set('team_base_id', this.contextMenuTeam.id.toString());
          
          this.http.get(environment.prismaApiUrl + '/api/dispo/team_absence', { params }).subscribe(
            (data: any) => {
              const absences = data.data || data || [];
              const dayAbsences = absences.filter((absence: any) => {
                const absenceStart = moment(absence.start_date).startOf('day');
                const absenceEnd = moment(absence.end_date).startOf('day');
                const targetDate = this.contextMenuDay.date.clone().startOf('day');
                return targetDate.isSameOrAfter(absenceStart, 'day') && 
                       targetDate.isSameOrBefore(absenceEnd, 'day') &&
                       absence.team_base_id === this.contextMenuTeam.id;
              });
              
              if (dayAbsences.length > 0) {
                // Lösche alle gefundenen Absences
                const deleteRequests = dayAbsences.map((absence: any) => 
                  this.http.delete(environment.prismaApiUrl + `/api/dispo/team_absence/${absence.id}`)
                );
                
                forkJoin(deleteRequests).subscribe(
                  () => {
                    this.toastr.success(`Blockierung für ${dateStr} für ${teamName} wurde aufgehoben`, 'Erfolg');
                    this.closeContextMenu();
                    // Lade Absences für die gesamte Woche neu, um die Anzeige zu aktualisieren
                    const weekStart = this.weekStart.clone().startOf('isoWeek');
                    const weekEnd = this.weekStart.clone().endOf('isoWeek');
                    this.loadTeamAbsences(weekStart, weekEnd, () => {
                      this.generateCalendar();
                    });
                  },
                  err => {
                    console.error('Fehler beim Aufheben der Blockierung', err);
                    this.toastr.error(err.error?.error || 'Fehler beim Aufheben der Blockierung', 'Fehler');
                  }
                );
              } else {
                // Keine Absence gefunden, entferne nur aus dem Set
                this.toastr.success(`Blockierung für ${dateStr} für ${teamName} wurde aufgehoben`, 'Erfolg');
                this.closeContextMenu();
                // Lade Absences für die gesamte Woche neu, um die Anzeige zu aktualisieren
                const weekStart = this.weekStart.clone().startOf('isoWeek');
                const weekEnd = this.weekStart.clone().endOf('isoWeek');
                this.loadTeamAbsences(weekStart, weekEnd, () => {
                  this.generateCalendar();
                });
              }
            },
            err => {
              console.error('Fehler beim Laden der Absences', err);
              this.toastr.error('Fehler beim Laden der Absences', 'Fehler');
            }
          );
        }
      });
    } else {
      // Tag ist nicht blockiert - Blockieren
      Swal.fire({
        title: 'Tag blockieren?',
        text: `Möchten Sie den ${dateStr} für ${teamName} blockieren?`,
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#00a5a8',
        cancelButtonColor: '#6c757d',
        confirmButtonText: 'Ja, blockieren',
        cancelButtonText: 'Abbrechen'
      }).then((result) => {
        if (result.isConfirmed) {
          const startDate = this.contextMenuDay.date.clone().startOf('day');
          const endDate = this.contextMenuDay.date.clone().endOf('day');
          
          const payload = {
            data: {
              team_base_id: this.contextMenuTeam.id,
              start_date: startDate.format('YYYY-MM-DD 00:00:00'),
              end_date: endDate.format('YYYY-MM-DD 23:59:59'),
              absence_type: 'blocked',
              absence_type_id: 0,
              note: `Kalenderblock ${dateStr}`
            }
          };
          
          this.http.post(environment.prismaApiUrl + '/api/dispo/team_absence', payload).subscribe(
            () => {
              this.toastr.success(`Tag ${dateStr} für ${teamName} wurde blockiert`, 'Erfolg');
              this.closeContextMenu();
              // Lade Absences für die gesamte Woche neu, um die Anzeige zu aktualisieren
              const weekStart = this.weekStart.clone().startOf('isoWeek');
              const weekEnd = this.weekStart.clone().endOf('isoWeek');
              this.loadTeamAbsences(weekStart, weekEnd, () => {
                this.generateCalendar();
              });
            },
            err => {
              console.error('Fehler beim Blockieren des Tags', err);
              this.toastr.error(err.error?.error || 'Fehler beim Blockieren des Tags', 'Fehler');
            }
          );
        }
      });
    }
  }

  editAppointment(): void {
    if (!this.contextMenuEvent) return;
    
    const event = this.contextMenuEvent.event;
    const team = this.contextMenuEvent.team;
    const day = this.contextMenuEvent.day;
    
    // Hole Personal und Fahrzeuge für diesen Tag
    const employeeEvents = this.getTeamEmployeesForDay(team.id, day);
    const vehicleEvents = this.getTeamVehiclesForDay(team.id, day);
    
    // Erweitere Employee-Daten mit vollständigen Namen
    const employees = employeeEvents.map(empEvent => {
      // Suche vollständige Employee-Daten
      let fullEmployee = null;
      if (empEvent.moduleItemId) {
        fullEmployee = this.employees.find((emp: any) => emp.id === empEvent.moduleItemId);
      }
      
      // Hole auch aus teamStaffEvents
      const teamEvents = this.teamStaffEvents.get(team.id) || [];
      const staffEvent = teamEvents.find((e: any) => 
        e.id === empEvent.id && 
        (e.moduleItemId === empEvent.moduleItemId || e.module_item_id === empEvent.moduleItemId)
      );
      
      if (staffEvent && staffEvent.employee) {
        fullEmployee = staffEvent.employee;
      }
      
      // Formatiere Name
      let displayName = empEvent.label || empEvent.title || 'Unbekannt';
      if (fullEmployee) {
        const firstName = fullEmployee.first_name || '';
        const lastName = fullEmployee.last_name || '';
        if (firstName && lastName) {
          displayName = `${firstName} ${lastName}`;
        } else if (lastName) {
          displayName = lastName;
        } else if (firstName) {
          displayName = firstName;
        }
      }
      
      return {
        ...empEvent,
        displayName: displayName,
        employee: fullEmployee
      };
    });
    
    // Erweitere Vehicle-Daten
    const vehicles = vehicleEvents.map(vehEvent => {
      // Suche vollständige Vehicle-Daten
      let fullVehicle = null;
      if (vehEvent.moduleItemId) {
        fullVehicle = this.vehicles.find((veh: any) => veh.id === vehEvent.moduleItemId);
      }
      
      // Hole auch aus teamStaffEvents
      const teamEvents = this.teamStaffEvents.get(team.id) || [];
      const staffEvent = teamEvents.find((e: any) => 
        e.id === vehEvent.id && 
        (e.moduleItemId === vehEvent.moduleItemId || e.module_item_id === vehEvent.moduleItemId)
      );
      
      // Vehicle-Daten können auch direkt im Event sein (z.B. als title/label)
      if (staffEvent) {
        if (staffEvent.vehicle) {
          fullVehicle = staffEvent.vehicle;
        }
      }
      
      const displayName = vehEvent.label || vehEvent.title || staffEvent?.title || staffEvent?.label || fullVehicle?.label || fullVehicle?.license_plate || 'Unbekannt';
      
      return {
        ...vehEvent,
        displayName: displayName,
        vehicle: fullVehicle
      };
    });
    
    // Parse Zeit aus event
    let timeStart = '08:00';
    let timeEnd = '17:00';
    
    if (event.timeStart && event.timeEnd) {
      timeStart = event.timeStart;
      timeEnd = event.timeEnd;
    } else if (event.start && event.end) {
      // Interpretiere die Zeit als lokale Zeit (nicht UTC)
      // Wenn die Zeit als String kommt, parse sie explizit als lokale Zeit
      const startMoment = moment(event.start).local();
      const endMoment = moment(event.end).local();
      timeStart = startMoment.format('HH:mm');
      timeEnd = endMoment.format('HH:mm');
    } else if (event.time) {
      // Parse "HH:mm - HH:mm" Format
      const timeParts = event.time.split(' - ');
      if (timeParts.length === 2) {
        timeStart = timeParts[0].trim();
        timeEnd = timeParts[1].trim();
      }
    }
    
    // Order-ID und Status für Auftrags-Termine (Status editierbar)
    const rawOrderId = event.order_id ?? event.orderId ?? event.order?.id ?? event.data?.id ?? event.data?.order?.id;
    const orderId = rawOrderId != null ? Math.floor(Number(rawOrderId)) : null;
    const orderData = event.data || event.order || event;
    const currentStatusId = orderData.status_id ?? orderData.status?.id ?? null;
    const hasOrder = orderId != null && !isNaN(orderId) && orderId >= 1;

    // Bereite Modal-Daten vor
    this.editModalData = {
      event: event,
      team: team,
      day: day,
      employees: employees,
      vehicles: vehicles,
      timeStart: timeStart,
      timeEnd: timeEnd,
      originalStart: event.start ? moment(event.start) : day.date.clone().startOf('day'),
      originalEnd: event.end ? moment(event.end) : day.date.clone().startOf('day'),
      comment: event.comment || event.data?.comment || '',
      createdBy: event.createdBy || null,
      orderId: hasOrder ? orderId : null,
      statusId: currentStatusId != null ? currentStatusId : null,
      originalStatusId: currentStatusId != null ? currentStatusId : null
    };

    this.showEditModal = true;
    this.closeContextMenu();
  }
  
  closeEditModal(): void {
    this.showEditModal = false;
    this.editModalData = null;
  }
  
  saveAppointment(): void {
    if (!this.editModalData) return;
    
    const { event, team, day, timeStart, timeEnd, originalStart, comment } = this.editModalData;
    
    // Validiere Zeit
    if (!timeStart || !timeEnd) {
      this.toastr.error('Bitte geben Sie eine gültige Zeit ein', 'Fehler');
      return;
    }
    
    // Parse Zeit
    const [startHours, startMinutes] = timeStart.split(':').map(Number);
    const [endHours, endMinutes] = timeEnd.split(':').map(Number);
    
    if (isNaN(startHours) || isNaN(startMinutes) || isNaN(endHours) || isNaN(endMinutes)) {
      this.toastr.error('Bitte geben Sie eine gültige Zeit ein', 'Fehler');
      return;
    }
    
    // Erstelle neue Start- und End-Daten (als lokale Zeit)
    // Verwende utc(false) um sicherzustellen, dass die Zeit als lokale Zeit behandelt wird
    const newStartDate = day.date.clone().startOf('day').add(startHours, 'hours').add(startMinutes, 'minutes');
    const newEndDate = day.date.clone().startOf('day').add(endHours, 'hours').add(endMinutes, 'minutes');
    
    // Prüfe ob End-Zeit nach Start-Zeit liegt
    if (newEndDate.isSame(newStartDate) || newEndDate.isBefore(newStartDate)) {
      this.toastr.error('Die End-Zeit muss nach der Start-Zeit liegen', 'Fehler');
      return;
    }
    
    // Update-Daten vorbereiten
    // Sende die Zeit als formatierter String (YYYY-MM-DD HH:mm:ss) statt Date-Objekt
    // Das Backend erwartet dieses Format und parst es mit Carbon
    const updateData = {
      id: event.id,
      start: newStartDate.format('YYYY-MM-DD HH:mm:ss'),
      end: newEndDate.format('YYYY-MM-DD HH:mm:ss'),
      resource: 'O' + team.id,
      team_order_type_id: event.teamOrderTypeId || event.team_order_type_id,
      comment: comment || null
    };
    
    // Speichere Termin-Änderungen (Zeit, Kommentar)
    this.teamOrderService.update(updateData).subscribe({
      next: () => {
        const orderId = this.editModalData?.orderId;
        const newStatusId = this.editModalData?.statusId;
        const originalStatusId = this.editModalData?.originalStatusId;
        const statusChanged = orderId != null && newStatusId !== originalStatusId;

        if (statusChanged && newStatusId != null) {
          const newStatus = this.statusList.find((s: any) => s.id === newStatusId);
          const newStatusLabel = newStatus?.label || String(newStatusId);
          this.orderService.updateStatus(orderId, newStatusId).subscribe({
            next: () => {
              this.toastr.success('Termin und Status wurden aktualisiert', 'Erfolg');
              const ev = this.editModalData?.event;
              if (ev) {
                ev.status_id = newStatusId;
                ev.data = ev.data || {};
                ev.data.status_id = newStatusId;
                ev.data.status = newStatus || { id: newStatusId, label: newStatusLabel, color: newStatus?.color };
                if (ev.order) {
                  ev.order.status_id = newStatusId;
                  ev.order.status = newStatus;
                }
              }
              this.loadEvents();
              this.loadExistingAppointments();
              this.closeEditModal();
            },
            error: (err) => {
              this.toastr.error(err?.error?.message || 'Status konnte nicht aktualisiert werden', 'Fehler');
              this.loadEvents();
              this.loadExistingAppointments();
              this.closeEditModal();
            }
          });
        } else {
          this.toastr.success('Termin wurde erfolgreich aktualisiert', 'Erfolg');
          this.loadEvents();
          this.loadExistingAppointments();
          this.closeEditModal();
        }
      },
      error: (err) => {
        this.toastr.error(err.error?.message || 'Fehler beim Speichern', 'Fehler');
      }
    });
  }

  reserveAppointment(eventOverride?: any): void {
    const targetEvent = eventOverride || this.contextMenuEvent?.event || this.editModalData?.event;
    if (!targetEvent || !targetEvent.id) return;

    const newState = !targetEvent.reserved;

    this.teamOrderService.setReserved(targetEvent.id).subscribe(
      () => {
        targetEvent.reserved = newState;
        if (this.selectedEventData?.event?.id === targetEvent.id) {
          this.selectedEventData.event.reserved = newState;
        }
        if (this.editModalData?.event?.id === targetEvent.id) {
          this.editModalData.event.reserved = newState;
        }
        // Lokale Listen aktualisieren, ohne alles neu zu laden
        this.updateReservationFlag(targetEvent.id, newState, targetEvent.teamId || targetEvent.team_base_id || targetEvent.team_base?.id);
        this.toastr.success(newState ? 'Termin reserviert' : 'Reservierung aufgehoben', 'Erfolg');
      },
      (err) => {
        console.error('Fehler beim Reservieren des Termins', err);
        this.toastr.error('Termin konnte nicht reserviert werden', 'Fehler');
      }
    );
  }

  private updateReservationFlag(eventId: number, newState: boolean, teamId?: number): void {
    // existingAppointments aktualisieren
    const idx = this.existingAppointments.findIndex(a => a.id === eventId);
    if (idx !== -1) {
      this.existingAppointments[idx].reserved = newState;
    }

    // teamEvents aktualisieren
    if (teamId && this.teamEvents.has(teamId)) {
      const events = this.teamEvents.get(teamId) || [];
      const eIdx = events.findIndex(e => e.id === eventId);
      if (eIdx !== -1) {
        events[eIdx].reserved = newState;
        this.teamEvents.set(teamId, events);
      }
    } else {
      // Falls teamId fehlt, versuche global zu finden
      this.teamEvents.forEach((events, key) => {
        const eIdx = events.findIndex(e => e.id === eventId);
        if (eIdx !== -1) {
          events[eIdx].reserved = newState;
          this.teamEvents.set(key, events);
        }
      });
    }
  }

  /** Kontextmenü: Terminanfrage-E-Mail für bestehenden Termin erneut senden. */
  sendAppointmentRequestEmail(): void {
    if (!this.contextMenuEvent) {
      return;
    }
    const event = this.contextMenuEvent.event;
    const orderId = event.order_id || event.orderId;
    if (!orderId) {
      console.warn('sendAppointmentRequestEmail: kein orderId im Event', event);
      return;
    }

    // Hole aktuelle Auftragsdaten (inkl. root_order.person für E-Mail-Adresse)
    this.orderService.show(orderId).subscribe({
      next: (order: any) => {
        try {
          const start = moment(event.start || event.date);
          const end = moment(event.end || start.clone().add(order?.duration || 60, 'minutes'));
          const teamName = this.getTeamName(this.contextMenuEvent.team);
          const appointmentId = event.id || event.team_order_id || null;
          const type = event.teamOrderType || event.team_order_type || null;
          const appointmentTypeLabel = type ? (type.name || type.label || null) : null;
          this.openEmailDialogForTermin(order, start, end, teamName, appointmentId, appointmentTypeLabel);
        } catch (e) {
          console.error('sendAppointmentRequestEmail: Fehler beim Öffnen des E-Mail-Dialogs', e);
        }
      },
      error: (err) => {
        console.error('sendAppointmentRequestEmail: Fehler beim Laden des Auftrags', err);
      }
    });
  }

  enableMoveAppointment(): void {
    if (!this.contextMenuEvent) return;
    
    const event = this.contextMenuEvent.event;
    // Setze das Event als draggable
    this.draggingEvent = event;
    this.toastr.info('Termin kann jetzt verschoben werden. Ziehen Sie den Termin an die gewünschte Position.', 'Verschieben aktiviert', {
      timeOut: 3000
    });
    this.closeContextMenu();
  }

  switchToOrder(): void {
    if (!this.contextMenuEvent) return;
    
    const event = this.contextMenuEvent.event;
    // Versuche orderId aus verschiedenen Stellen zu holen
    const orderId = event.orderId 
      || event.data?.id 
      || event.data?.order?.id
      || event.order?.id;
    
    if (!orderId) {
      this.toastr.error('Keine Auftrags-ID gefunden', 'Fehler');
      this.closeContextMenu();
      return;
    }

    // Hole Auftragsinformationen für die Anzeige im Dialog
    const orderData = event.data || event.order || {};
    const orderNumber = orderData.order_number || orderData.orderNumber || orderId;
    const orderTypeLabel = orderData.order_type?.label 
      || orderData.orderType?.label 
      || orderData.root_order?.order_type?.label
      || 'Unbekannt';
    
    // Bestätigungsdialog anzeigen
    Swal.fire({
      title: 'Zum Auftrag wechseln?',
      text: `Möchten Sie zu Auftrag #${orderNumber} (${orderTypeLabel}) wechseln?`,
      icon: 'question',
      showCancelButton: true,
      confirmButtonText: 'Ja, wechseln',
      cancelButtonText: 'Abbrechen',
      confirmButtonColor: '#2c3e50',
      cancelButtonColor: '#6c757d'
    }).then((result) => {
      if (result.isConfirmed) {
        // Navigiere zur order-overview - die Komponente lädt den Auftrag automatisch
        this.router.navigate(['/order', orderId, 'order-overview']);
        this.closeContextMenu();
      } else {
        this.closeContextMenu();
      }
    });
  }

  onEventDragStart(event: any, dragEvent: DragEvent): void {
    if (this.draggingEvent?.id === event.id) {
      // Speichere Event-Daten für den Drop
      const dragData = {
        eventId: event.id,
        event: event,
        isMoving: true
      };
      dragEvent.dataTransfer!.setData('application/json', JSON.stringify(dragData));
      dragEvent.dataTransfer!.effectAllowed = 'move';
    } else {
      // Verhindere Drag wenn nicht im Verschieben-Modus
      dragEvent.preventDefault();
    }
  }

  deleteAppointment(): void {
    if (!this.contextMenuEvent) return;
    
    const event = this.contextMenuEvent.event;
    const appointmentId = event.id;
    
    Swal.fire({
      title: 'Termin löschen?',
      text: 'Möchten Sie diesen Termin wirklich löschen? Diese Aktion kann nicht rückgängig gemacht werden.',
      icon: 'warning',
      showCancelButton: true,
      confirmButtonColor: '#dc3545',
      cancelButtonColor: '#6c757d',
      confirmButtonText: 'Ja, löschen',
      cancelButtonText: 'Abbrechen'
    }).then((result) => {
      if (result.isConfirmed) {
        this.teamOrderService.delete({ id: appointmentId }).subscribe(
          deleteResult => {
            Swal.fire({
              title: 'Gelöscht!',
              text: 'Der Termin wurde erfolgreich gelöscht.',
              icon: 'success',
              timer: 2000,
              showConfirmButton: false
            });
            this.loadEvents();
            this.loadExistingAppointments();
            this.closeContextMenu();
          },
          err => {
            Swal.fire({
              title: 'Fehler',
              text: err.error?.message || 'Fehler beim Löschen des Termins',
              icon: 'error'
            });
            this.closeContextMenu();
          }
        );
      } else {
        this.closeContextMenu();
      }
    });
  }

  copyOrder(): void {
    if (!this.contextMenuEvent) {
      console.error('copyOrder - contextMenuEvent nicht vorhanden');
      return;
    }
    
    const event = this.contextMenuEvent.event;
    console.log('copyOrder - event:', event);
    
    // Versuche verschiedene mögliche Felder für orderData
    // Prüfe zuerst event.data, dann event.order, dann direkt im event (falls es selbst ein order ist)
    let orderData = event.data || event.order || null;
    
    // Falls orderData nicht direkt vorhanden ist, aber event selbst order-ähnliche Daten hat
    if (!orderData && event.orderId) {
      // Event hat orderId, aber kein orderData - verwende event selbst als Basis
      orderData = {
        id: event.orderId || event.rootOrderId || event.id,
        order_number: event.order_number || '',
        root_order: event.root_order || null,
        duration: event.duration || 60
      };
    }
    
    // Falls immer noch kein orderData, versuche root_order
    if (!orderData) {
      orderData = event.root_order || null;
    }
    
    // Falls immer noch kein orderData, aber event hat id, verwende event als orderData
    if (!orderData && event.id) {
      // Event selbst als orderData verwenden (für team_order Events)
      orderData = {
        id: event.orderId || event.rootOrderId || event.data?.id || null,
        order_number: event.order_number || '',
        root_order: event.root_order || event.data?.root_order || null,
        duration: event.duration || 60,
        data: event.data || null
      };
    }
    
    if (!orderData || !orderData.id) {
      console.error('copyOrder - orderData nicht gefunden oder keine ID:', orderData);
      console.error('copyOrder - event-Struktur:', JSON.stringify(event, null, 2));
      this.toastr.error('Auftragsdaten nicht gefunden', 'Fehler');
      this.closeContextMenu();
      return;
    }
    
    // Speichere den Auftrag für das Einfügen
    this.copiedOrder = {
      orderData: orderData,
      teamOrderType: event.teamOrderType || event.team_order_type || null,
      team: event.team || null,
      date: event.date || null
    };
    
    // Speichere auch das Event für das Verschieben (mit vollständigen Event-Daten)
    this.copiedEvent = {
      ...event,
      id: event.id, // Wichtig: Event-ID für das Löschen
      start: event.start,
      end: event.end,
      date: event.date
    };
    
    console.log('copyOrder - copiedOrder gespeichert:', this.copiedOrder);
    console.log('copyOrder - copiedEvent gespeichert:', this.copiedEvent);
    
    this.toastr.success('Auftrag wurde kopiert', 'Erfolg');
    this.closeContextMenu();
  }

  pasteOrder(): void {
    console.log('pasteOrder - copiedOrder:', this.copiedOrder);
    console.log('pasteOrder - contextMenuDay:', this.contextMenuDay);
    console.log('pasteOrder - contextMenuTeam:', this.contextMenuTeam);
    
    if (!this.copiedOrder || !this.contextMenuDay || !this.contextMenuTeam) {
      console.error('pasteOrder - Fehlende Daten:', {
        copiedOrder: !!this.copiedOrder,
        contextMenuDay: !!this.contextMenuDay,
        contextMenuTeam: !!this.contextMenuTeam
      });
      this.toastr.warning('Kein kopierter Auftrag vorhanden oder kein Ziel ausgewählt', 'Hinweis');
      this.closeContextMenu();
      return;
    }

    // Prüfe ob Termintypen geladen sind
    if (this.teamOrderTypes.length === 0) {
      this.toastr.warning('Termintypen werden noch geladen. Bitte warten Sie einen Moment.', 'Warnung');
      return;
    }

    // Setze Standard-Termintyp, falls keiner ausgewählt ist
    if (!this.selectedTeamOrderType && this.copiedOrder.teamOrderType) {
      this.selectedTeamOrderType = this.copiedOrder.teamOrderType;
    } else if (!this.selectedTeamOrderType && this.teamOrderTypes.length > 0) {
      this.selectedTeamOrderType = this.teamOrderTypes[0];
    }

    // Speichere Ziel-Datum und Team für das Einfügen (falls Modal geöffnet wird)
    this.pasteOrderTargetDay = this.contextMenuDay;
    this.pasteOrderTargetTeam = this.contextMenuTeam;
    
    // Öffne Modal zur Auswahl der Aktion (Kopieren oder Verschieben)
    this.pasteOrderAction = 'copy'; // Standard: Kopieren
    this.showPasteOrderModal = true;
    this.closeContextMenu();
  }

  executePasteOrder(): void {
    if (this.pasteOrderAction === 'move') {
      this.executePasteOrderAsMove();
    } else {
      this.executePasteOrderAsCopy();
    }
  }

  executePasteOrderAsCopy(): void {
    console.log('executePasteOrderAsCopy - copiedOrder:', this.copiedOrder);
    console.log('executePasteOrderAsCopy - contextMenuDay:', this.contextMenuDay);
    console.log('executePasteOrderAsCopy - contextMenuTeam:', this.contextMenuTeam);
    console.log('executePasteOrderAsCopy - pasteOrderTargetDay:', this.pasteOrderTargetDay);
    console.log('executePasteOrderAsCopy - pasteOrderTargetTeam:', this.pasteOrderTargetTeam);
    
    // Verwende gespeicherte Werte, falls contextMenuDay/Team nicht mehr vorhanden sind
    const targetDay = this.contextMenuDay || this.pasteOrderTargetDay;
    const targetTeam = this.contextMenuTeam || this.pasteOrderTargetTeam;
    
    if (!this.copiedOrder || !targetDay || !targetTeam) {
      console.error('executePasteOrderAsCopy - Fehlende Daten:', {
        copiedOrder: !!this.copiedOrder,
        targetDay: !!targetDay,
        targetTeam: !!targetTeam
      });
      this.toastr.warning('Kein kopierter Auftrag vorhanden oder kein Ziel ausgewählt', 'Warnung');
      this.closePasteOrderModal();
      return;
    }

    const targetDate = targetDay.date.clone();
    const orderData = this.copiedOrder.orderData;
    const teamOrderType = this.copiedOrder.teamOrderType;

    if (!orderData || !orderData.id) {
      console.error('executePasteOrderAsCopy - orderData nicht gefunden:', orderData);
      this.toastr.error('Kopierte Auftragsdaten nicht gefunden', 'Fehler');
      this.closePasteOrderModal();
      return;
    }

    // Verwende den ausgewählten Termintyp oder den aus dem kopierten Auftrag
    const selectedType = this.selectedTeamOrderType || teamOrderType;
    if (!selectedType || !selectedType.id) {
      console.error('executePasteOrderAsCopy - Termintyp nicht gefunden:', selectedType);
      this.toastr.warning('Termintyp nicht gefunden. Kann nicht kopiert werden.', 'Warnung');
      this.closePasteOrderModal();
      return;
    }

    // Verwende den gleichen Service wie beim Drag & Drop
    // Berechne Start- und Endzeit
    const startDate = targetDate.clone().startOf('day').add(8, 'hours'); // 8:00 Uhr als Standard
    const endDate = startDate.clone().add((orderData.duration || 60) * 60, 'seconds');

    const resource = 'O' + targetTeam.id;
    const data = {
      start: startDate.toDate(),
      end: endDate.toDate(),
      resource: resource,
      id: orderData.id,
      data: orderData,
      team_order_type_id: selectedType.id
    };

    console.log('pasteOrderAsCopy - Erstelle neuen Termin (Kopie) mit team_order_type_id:', data.team_order_type_id);
    console.log('pasteOrderAsCopy - data:', data);

    this.teamOrderService.store(data).subscribe(
      result => {
        this.toastr.success('Auftrag wurde kopiert und am neuen Standort angelegt', 'Erfolg');
        this.loadEvents();
        this.closePasteOrderModal();
        const appointmentId = result?.id ?? null;
        this.openTerminContactChoiceDialog(orderData, startDate, endDate, targetTeam, appointmentId);
      },
      err => {
        console.error('Fehler beim Kopieren des Auftrags', err);
        this.toastr.error(err.error?.message || err.error?.error || 'Fehler beim Kopieren des Auftrags', 'Fehler');
        this.closePasteOrderModal();
      }
    );
  }

  executePasteOrderAsMove(): void {
    console.log('executePasteOrderAsMove - copiedOrder:', this.copiedOrder);
    console.log('executePasteOrderAsMove - copiedEvent:', this.copiedEvent);
    console.log('executePasteOrderAsMove - contextMenuDay:', this.contextMenuDay);
    console.log('executePasteOrderAsMove - contextMenuTeam:', this.contextMenuTeam);
    console.log('executePasteOrderAsMove - pasteOrderTargetDay:', this.pasteOrderTargetDay);
    console.log('executePasteOrderAsMove - pasteOrderTargetTeam:', this.pasteOrderTargetTeam);
    
    // Verwende gespeicherte Werte, falls contextMenuDay/Team nicht mehr vorhanden sind
    const targetDay = this.contextMenuDay || this.pasteOrderTargetDay;
    const targetTeam = this.contextMenuTeam || this.pasteOrderTargetTeam;
    
    if (!this.copiedOrder || !targetDay || !targetTeam) {
      console.error('executePasteOrderAsMove - Fehlende Daten');
      this.toastr.warning('Kein kopierter Auftrag vorhanden oder kein Ziel ausgewählt', 'Warnung');
      this.closePasteOrderModal();
      return;
    }

    const targetDate = targetDay.date.clone();
    const orderData = this.copiedOrder.orderData;
    const teamOrderType = this.copiedOrder.teamOrderType;

    if (!orderData || !orderData.id) {
      this.toastr.error('Auftragsdaten nicht gefunden. Kann nicht verschoben werden.', 'Fehler');
      this.closePasteOrderModal();
      return;
    }

    // Verwende den ausgewählten Termintyp oder den aus dem kopierten Auftrag
    const selectedType = this.selectedTeamOrderType || teamOrderType;
    if (!selectedType || !selectedType.id) {
      this.toastr.warning('Termintyp nicht gefunden. Kann nicht verschoben werden.', 'Warnung');
      this.closePasteOrderModal();
      return;
    }

    // Berechne neue Start- und Endzeit
    // Wenn Event-Daten vorhanden sind, behalte die ursprüngliche Dauer
    let newStartDate: moment.Moment;
    let newEndDate: moment.Moment;

    if (this.copiedEvent && this.copiedEvent.id) {
      // Event-Daten vorhanden: Behalte ursprüngliche Zeit und Dauer
      const originalStart = moment(this.copiedEvent.start || this.copiedEvent.date);
      const originalEnd = moment(this.copiedEvent.end || this.copiedEvent.date);
      const duration = originalEnd.diff(originalStart, 'minutes');

      newStartDate = targetDate.clone().startOf('day').add(originalStart.hours(), 'hours').add(originalStart.minutes(), 'minutes');
      newEndDate = newStartDate.clone().add(duration, 'minutes');
    } else {
      // Keine Event-Daten: Verwende Standard-Zeit (8:00 Uhr) und Dauer aus orderData
      newStartDate = targetDate.clone().startOf('day').add(8, 'hours'); // 8:00 Uhr als Standard
      newEndDate = newStartDate.clone().add((orderData.duration || 60) * 60, 'seconds');
    }

    const resource = 'O' + targetTeam.id;

    // Wenn Event-ID vorhanden ist, lösche den alten Termin und erstelle einen neuen
    if (this.copiedEvent && this.copiedEvent.id) {
      // Schritt 1: Alten Termin löschen
      console.log('pasteOrderAsMove - Lösche alten Termin:', this.copiedEvent.id);
      
      this.teamOrderService.delete({ id: this.copiedEvent.id }).subscribe(
        deleteResult => {
          // Schritt 2: Neuen Termin am neuen Standort erstellen
          const data = {
            start: newStartDate.toDate(),
            end: newEndDate.toDate(),
            resource: resource,
            id: orderData.id,
            data: orderData,
            team_order_type_id: selectedType.id
          };

          console.log('pasteOrderAsMove - Erstelle neuen Termin am neuen Standort:', data);

          this.teamOrderService.store(data).subscribe(
            createResult => {
              this.toastr.success('Auftrag wurde erfolgreich verschoben', 'Erfolg');
              this.loadEvents();
              this.closePasteOrderModal();
              const appointmentId = createResult?.id ?? null;
              this.openTerminContactChoiceDialog(orderData, newStartDate, newEndDate, targetTeam, appointmentId);
            },
            createErr => {
              console.error('Fehler beim Erstellen des neuen Termins nach Verschieben', createErr);
              this.toastr.error(createErr.error?.message || createErr.error?.error || 'Fehler beim Erstellen des neuen Termins', 'Fehler');
              this.closePasteOrderModal();
            }
          );
        },
        deleteErr => {
          console.error('Fehler beim Löschen des alten Termins', deleteErr);
          this.toastr.error(deleteErr.error?.message || deleteErr.error?.error || 'Fehler beim Löschen des alten Termins', 'Fehler');
          this.closePasteOrderModal();
        }
      );
    } else {
      // Keine Event-ID: Erstelle einfach einen neuen Termin am neuen Standort
      // (Der alte Termin kann nicht gelöscht werden, da keine ID vorhanden ist)
      const data = {
        start: newStartDate.toDate(),
        end: newEndDate.toDate(),
        resource: resource,
        id: orderData.id,
        data: orderData,
        team_order_type_id: selectedType.id
      };

      console.log('pasteOrderAsMove - Erstelle neuen Termin am neuen Standort (ohne alten zu löschen):', data);

      this.teamOrderService.store(data).subscribe(
        createResult => {
          this.toastr.success('Auftrag wurde am neuen Standort angelegt', 'Erfolg');
          this.loadEvents();
          this.closePasteOrderModal();
          const appointmentId = createResult?.id ?? null;
          this.openTerminContactChoiceDialog(orderData, newStartDate, newEndDate, targetTeam, appointmentId);
        },
        createErr => {
          console.error('Fehler beim Erstellen des neuen Termins', createErr);
          this.toastr.error(createErr.error?.message || createErr.error?.error || 'Fehler beim Erstellen des neuen Termins', 'Fehler');
          this.closePasteOrderModal();
        }
      );
    }
  }

  closePasteOrderModal(): void {
    this.showPasteOrderModal = false;
    // Optional: Lösche gespeicherte Ziel-Daten
    // this.pasteOrderTargetDay = null;
    // this.pasteOrderTargetTeam = null;
  }

  confirmPasteOrder(): void {
    console.log('confirmPasteOrder - pasteOrderAction:', this.pasteOrderAction);
    console.log('confirmPasteOrder - copiedOrder:', this.copiedOrder);
    console.log('confirmPasteOrder - contextMenuDay:', this.contextMenuDay);
    console.log('confirmPasteOrder - contextMenuTeam:', this.contextMenuTeam);
    
    // Keine Prüfung mehr - Verschieben funktioniert auch ohne Event-Daten
    // (Datum wird einfach angepasst)
    this.executePasteOrder();
  }

  canPasteOrder(): boolean {
    const canPaste = !!(this.copiedOrder && this.copiedOrder.orderData);
    console.log('canPasteOrder - copiedOrder:', this.copiedOrder, 'canPaste:', canPaste);
    return canPaste;
  }

  getCopiedOrderNumber(): string {
    if (!this.copiedOrder || !this.copiedOrder.orderData) {
      return '';
    }
    const orderData = this.copiedOrder.orderData;
    return orderData.order_number || orderData.root_order?.order_number || '';
  }

  getCopiedOrderName(): string {
    if (!this.copiedOrder || !this.copiedOrder.orderData) {
      return '';
    }
    const orderData = this.copiedOrder.orderData;
    const firstName = orderData.root_order?.person?.first_name || orderData.first_name || '';
    const lastName = orderData.root_order?.person?.last_name || orderData.last_name || '';
    return (firstName + ' ' + lastName).trim() || '';
  }

  clearCopiedOrder(): void {
    this.copiedOrder = null;
    this.copiedEvent = null;
    this.toastr.info('Kopierter Auftrag wurde gelöscht', 'Info');
  }

  private finishInitialLoading(): void {
    if (!this.hasFinishedInitialLoading) {
      this.isInitialLoading = false;
      this.hasFinishedInitialLoading = true;
    }
  }
}

